//! DO NOT EDIT THIS FILE MANUALLY!
//! IT IS AUTO-GENERATED FROM: protos-backend-logging/src/main/proto/faire/logging/product_area.proto
//! RUN `yarn nx regenerate web-api` TO REGENERATE.

import { FairePod } from '@faire/types-observability-api/faire/logging/FairePod';
import { ProductArea } from '@faire/types-observability-api/faire/logging/ProductArea';

const deprecatedForProductArea: Partial<Record<ProductArea, boolean>> = {
  PRODUCT_AREA_UNKNOWN: true,
  ABOUT_US_PAGE: undefined,
  ADMIN: undefined,
  ADYEN: undefined,
  ADYEN_PAYOUT: undefined,
  STRIPE_PAYOUT: undefined,
  AFFILIATES: undefined,
  AI_BRIDGE: undefined,
  AI_TOOLS: undefined,
  ALCOHOL: undefined,
  ALERT_BANNERS: undefined,
  AMEX: undefined,
  ANTI_ABUSE: undefined,
  API_PERFORMANCE: undefined,
  APPAREL_BRAND: undefined,
  APPAREL_COLLECTIONS: undefined,
  CORE_COLLECTIONS: undefined,
  COLLECTIONS_RETAILER_DISPLAY: undefined,
  APPAREL_DISCOVERY: true,
  APPDASH: undefined,
  ATELIER_FAIRE: undefined,
  AUTH: undefined,
  AUTOBOTS_FRAMEWORK: undefined,
  AUTOPILOT: undefined,
  MFA: undefined,
  AWS_SAGEMAKER: undefined,
  B2B_REFERRALS: undefined,
  BACKEND_DRIVEN_MESSAGING_CONTAINERS: true,
  BACKFILA: undefined,
  BADGES: undefined,
  BLOG_GATED_CONTENT: true,
  BOARDS: undefined,
  BRAND_ACCOUNT_SETTINGS: undefined,
  BRAND_ACQUISITION: undefined,
  BRAND_ANALYTICS: undefined,
  PRODUCT_SALES_REPORT: undefined,
  BRAND_ANNOUNCEMENTS: undefined,
  BRAND_APP: undefined,
  BRAND_CATALOG_COMPLETENESS: undefined,
  BRAND_CORE: undefined,
  BRAND_CRM: undefined,
  BRAND_CUSTOMER_ENGAGEMENT_SURVEY: undefined,
  BRAND_DAILY_DIGEST: undefined,
  BRAND_EMAIL_PREFERENCES: undefined,
  BRAND_F14D_DISCOUNTS: undefined,
  BRAND_FRAUD: undefined,
  BRAND_HYPE_MAP: true,
  BRAND_INTEGRATIONS: undefined,
  BRAND_INVOICES: undefined,
  BRAND_LEADS: undefined,
  BRAND_LISTING_QUALITY: true,
  BRAND_LOYALTY: undefined,
  BRAND_MARKETING_CAMPAIGNS: undefined,
  BRAND_MARKETPLACE: true,
  BRAND_MARKETPLACE_HOMEPAGE: undefined,
  BRAND_MCP: undefined,
  BRAND_MOBILE: undefined,
  BRAND_MULTI_USER_MANAGEMENT: undefined,
  BRAND_NUDGES: undefined,
  BRAND_ACTIVATION: undefined,
  BRAND_ONBOARDING: undefined,
  BRAND_ORDERS: undefined,
  BRAND_PAYOUT_CALCULATION: undefined,
  BRAND_NOTIFICATIONS_CENTRE: undefined,
  BRAND_PAYOUTS: undefined,
  BRAND_PORTAL_HOMEPAGE: undefined,
  BRAND_PORTAL_SEARCH: undefined,
  BRAND_PORTAL_NAVIGATION: undefined,
  BRAND_PORTAL_PRODUCTS_PAGE: undefined,
  BRAND_PREVIEW: undefined,
  BRAND_PRICING: undefined,
  BRAND_PRODUCT_SEARCH_SUGGESTIONS: undefined,
  BRAND_PRODUCT_TAGS: undefined,
  BRAND_PROMOS: undefined,
  BRAND_PROSPECTING: true,
  BRAND_RESTRICTIONS: undefined,
  BRAND_REVIEWS: undefined,
  BRAND_SAFETY: undefined,
  BRAND_SEARCH: undefined,
  BRAND_SHOP_CURRENCY: undefined,
  BRAND_SHOP_PAGE: undefined,
  BRAND_SHOP_SETTINGS: undefined,
  PRODUCT_GEO_AVAILABILITY: undefined,
  BRAND_SHOPIFY_INTEGRATION: true,
  BRAND_SHOPIFY_CATALOG_SYNC: true,
  BRAND_SHOPIFY_PRODUCT_IMPORT: undefined,
  BRAND_SHOPIFY_VARIANT_IMPORT: undefined,
  BRAND_SHOPIFY_PRODUCT_LINKING: undefined,
  BRAND_SHOPIFY_PRODUCT_STATUS_SYNC: undefined,
  BRAND_SHOPIFY_DATA_REPLICATION: undefined,
  BRAND_SHOPIFY_PERFORMANCE_TRACKING: undefined,
  BRAND_SHOPIFY_OTHER: undefined,
  BRAND_SHOPIFY_METAFIELDS_SYNC: undefined,
  BRAND_SHOPIFY_CONTENT_SYNC: undefined,
  BRAND_SHOPIFY_HOME: undefined,
  BRAND_SHOPIFY_INVENTORY_SYNC: undefined,
  BRAND_SHOPIFY_ORDER_SYNC: undefined,
  BRAND_SHOPIFY_PREFERENCES: undefined,
  BRAND_SHOPIFY_PRICE_SYNC: undefined,
  BRAND_SHOPIFY_SALES_CHANNEL_MIGRATION: undefined,
  BRAND_SHOPIFY_SETUP: undefined,
  RETAILER_SHOPIFY_APP: undefined,
  BRAND_SLA: undefined,
  BRAND_TAGS: undefined,
  BRAND_TILE: undefined,
  BRAND_VERIFICATION: undefined,
  BRAND_WIDGET: undefined,
  BRANDS: true,
  BRAZE: undefined,
  BRAZE_EMAILS: undefined,
  BROWSER_EXTENSION: undefined,
  BUILDER_IO: undefined,
  BUY_IT_AGAIN: undefined,
  BULK_ACTIONS: undefined,
  BULK_PRODUCT_EDIT: undefined,
  BULK_PRODUCT_EXPORT: undefined,
  BULK_PRODUCT_UPLOAD: undefined,
  CAPABILITIES: undefined,
  CARBON_NEUTRAL_RETAILER: true,
  CART: undefined,
  CART_RECOMMENDATIONS: undefined,
  CART_COLLABORATION: undefined,
  CATEGORIES: true,
  CATEGORY_PAGE_RECOMMENDATIONS: undefined,
  BROWSE_INFRASTRUCTURE: undefined,
  CATEGORY_RESULTS: undefined,
  CATEGORY_RESULTS_RANKING: undefined,
  CATALOGS_MIGRATION: undefined,
  CATALOG_VERIFICATION: undefined,
  CHAT_GPT_ENTERPRISE: undefined,
  CHECKOUT: undefined,
  CLAWBACKS: undefined,
  CLIENT_EVENTS: undefined,
  CLIENT_HEALTH_TOOL: undefined,
  COCKROACH_DB: undefined,
  COLLECTIONS: true,
  COMMISSIONS: true,
  COMMS_PLANNER: undefined,
  CONDUCTOR: undefined,
  CONSUMER: true,
  CSV_IMPORT: undefined,
  CURRENCY_CONVERSION: undefined,
  CX_CUSTOMER_QUEUES: undefined,
  CX_FOUNDATIONS: undefined,
  RETAILER_FIRST_ORDER_INCENTIVE: undefined,
  RETAILER_ACTIVATION_INCENTIVES: undefined,
  CX_OPS: undefined,
  DATA_ATLAS: undefined,
  DATA_FACTORY: undefined,
  DATA_LAKE: undefined,
  DATA_LOOKUP: undefined,
  DATABASE: undefined,
  DATABASE_EXPLORER: undefined,
  DELAYER: undefined,
  DRAFT_ORDERS: undefined,
  RETAILER_DRAFT_ORDERS: undefined,
  DUTIES: undefined,
  E2E: undefined,
  ECO_FRIENDLY: true,
  EDGE_INFRA: undefined,
  EDIT_ORDERS: undefined,
  EMAIL_INFRA: undefined,
  ERROR_RATE_TRIAGE: undefined,
  EVENTS: undefined,
  EXCLUSIVITY: undefined,
  EXPERIMENTS: undefined,
  EXPERIMENT_PLATFORM: undefined,
  EXPIRED_SETTINGS_CLEANUP: undefined,
  EXTERNAL_APIS: true,
  EXTERNAL_API_BRANDS: undefined,
  EXTERNAL_API_CORE: undefined,
  EXTERNAL_API_BRAND_PROMOS: undefined,
  EXTERNAL_API_ORDERS: undefined,
  EXTERNAL_API_OAUTH: undefined,
  EXTERNAL_API_MCP_OAUTH: undefined,
  EXTERNAL_API_PARTNERSHIPS: undefined,
  EXTERNAL_API_PRODUCTS: undefined,
  EXTERNAL_API_PREPACKS: undefined,
  EXTERNAL_API_PRODUCT_INVENTORY: undefined,
  EXTERNAL_API_RETAILERS: undefined,
  EXTERNAL_API_TAXONOMY: undefined,
  EXTERNAL_API_PRODUCT_REVIEWS: undefined,
  EXTERNAL_DEVELOPER: undefined,
  FAIREY: undefined,
  FAIRE_CLI: undefined,
  FAIRE_CONTENT: undefined,
  FAIRE_DIRECT: undefined,
  FAIRE_DIRECT_ADOPTION_EMAIL: undefined,
  FAIRE_DIRECT_APP: undefined,
  FAIRE_DIRECT_RETAILERS: true,
  FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_DIRECT_REWARDS_LIFECYCLE_EMAIL: undefined,
  FAIRE_DIRECT_TRIGGER_EMAIL: undefined,
  FAIRE_FOLK_HUB: true,
  FAIRE_SOCIAL_PROOF: true,
  FAIRE_SPACES: true,
  RETAILER_POS_INTEGRATIONS: undefined,
  FAIRESYNC: undefined,
  FAIRESYNC_INTEGRATION_CLOVER: undefined,
  FAIRESYNC_INTEGRATION_SHOPIFY: undefined,
  FAIRESYNC_INTEGRATION_SQUARE: undefined,
  FAIRESYNC_INTEGRATION_LIGHTSPEED: undefined,
  FAIRESYNC_INTEGRATION_QUICKBOOKS: true,
  FAIREWORKS: undefined,
  FASHION_WEEK: true,
  FILTERS: undefined,
  FLASH_SALES: undefined,
  FOOD_AND_BEVERAGE: true,
  FRONTEND_APIS: undefined,
  FRONTEND_TOOLING: undefined,
  FULLSTORY_CONFIG: true,
  GITHUB: undefined,
  GMAIL: undefined,
  GOOSE: undefined,
  GUARANTEED_VOLUME: undefined,
  HACK_WEEK: undefined,
  HELP_CENTER: undefined,
  HOME_FEED: true,
  TRANSLATIONS: undefined,
  HUBSPOT: true,
  IDV: undefined,
  IMAGES: true,
  INALYTICS: undefined,
  INCENTIVES: undefined,
  INFRA: true,
  INFERENCE: true,
  INSIDER: undefined,
  INSTRUMENTS: undefined,
  INTERNAL_API: undefined,
  INVENTORY: undefined,
  ISSUE_REPORTS: undefined,
  JOBS: undefined,
  KITCHEN_SINK: undefined,
  KNOWLEDGE_GRAPH: undefined,
  LAIKA: undefined,
  LAUNCH_WITH_FAIRE: true,
  LATENCY_TRIAGE: undefined,
  LEGAL_DOCUMENTS: true,
  STAGING: undefined,
  LIVE_STREAMS: true,
  LLM: true,
  LLM_OPERATIONS: undefined,
  LOCALIZATION: undefined,
  LOGGED_IN_HOMEPAGE: undefined,
  MAKER_BUY_BACK: undefined,
  MARKETS: undefined,
  MESSENGER: undefined,
  MESSENGER_CONTEXT_PANEL: undefined,
  MESSENGER_INLINE_CONTEXT: undefined,
  MILESTONES: undefined,
  MISPRICED_RESELLER: undefined,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_IN: true,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_OUT: undefined,
  MOBILE_RETAILER_LOGGED_OUT: undefined,
  MOBILE_RETAILER_MESSENGER: undefined,
  MOBILE_RETAILER_ONBOARDING: undefined,
  MOBILE_RETAILER_SIGNUP: undefined,
  MY_BRANDS: undefined,
  ZENDESK_TRANSLATIONS: true,
  MYSQL: undefined,
  NAVIGATION_INFRASTRUCTURE: undefined,
  NAVIGATION_TREE_UX: undefined,
  NET_TERMS: undefined,
  NEWSROOM: undefined,
  NEW_RETAILERS: undefined,
  PARTNERSHIPS_PAGE: undefined,
  OMNISEARCH: undefined,
  ONE_FAIRE_TEAM: undefined,
  OPEN_SIZING: undefined,
  OPEN_WITH_FAIRE: undefined,
  OPEN_WITH_FAIRE_LOGGED_OUT: undefined,
  ORDER_SUBMISSION: undefined,
  ORDERS: undefined,
  PACKING_SLIP: undefined,
  PAYMENTS: undefined,
  PDF_RENDERING: undefined,
  PERF_DARK_READ: undefined,
  PICK_LIST: undefined,
  PLAID: undefined,
  POSTMARK: undefined,
  PR_BOT: undefined,
  PREORDERS: undefined,
  PREPACKS: undefined,
  PRERELEASE: undefined,
  PRESTASHOP: undefined,
  PRICING: true,
  PRICING_PARITY: undefined,
  PRIVACY: undefined,
  PRODUCERS: undefined,
  PRODUCT_CHANGE_HISTORY: undefined,
  PRODUCT_INFO: true,
  PRODUCT_PRICE_MATCH_GUARANTEE: undefined,
  PRODUCT_REVIEWS: undefined,
  PRODUCT_SAMPLES: true,
  PRODUCT_TILE: undefined,
  PRODUCTS: true,
  PRODUCTS_API: undefined,
  PRODUCTS_PLATFORM: undefined,
  PROMO_MODALS: undefined,
  PROMOTIONAL_EVENTS: undefined,
  PROMO_CODES: undefined,
  PURCHASE_ORDER: undefined,
  PUSH_NOTIFICATIONS: undefined,
  QUALTRICS: undefined,
  QUEUES: undefined,
  QUICK_ADD: undefined,
  R2B_REFERRALS: undefined,
  R2R_REFERRALS: undefined,
  RANKING: undefined,
  RECOMMENDATIONS: true,
  REDIS: undefined,
  RELEASE_TOOL: undefined,
  REGIONAL_SEARCH: true,
  REORDER_UPDATES_HUB: true,
  RETAILER_ADVERTISING: undefined,
  RETAILER_BRAND_LOYALTY: true,
  RETAILER_BRANDS_MANAGEMENT: undefined,
  RETAILER_FINDER_APP: undefined,
  RETAILER_INVOICES: undefined,
  RETAILER_LAYOUT_ELEMENTS: undefined,
  LAYOUT_SERVICE: undefined,
  RETAILER_MARKETING: undefined,
  RETAILER_MOBILE: undefined,
  RETAILER_NUX: undefined,
  RETAILER_ONBOARDING: undefined,
  RETAILER_ORDER_MANAGEMENT: undefined,
  RETAILER_OWNER_TRANSFER: true,
  RETAILER_PORTAL: true,
  RETAILER_POS: true,
  RETAILER_REPORTING: undefined,
  RETAILER_SAVINGS: undefined,
  RETAILER_SETTINGS_PAGE: undefined,
  RETAILER_STYLE_QUIZ: undefined,
  CAREERS_PAGE: undefined,
  RETAILER_YEAR_IN_REVIEW: undefined,
  RETAILERS: true,
  RETAILER_CONVERSION: undefined,
  RETAILER_CORE: undefined,
  RETURNS: undefined,
  REVERSE_SYNCER: undefined,
  RISK: true,
  RISK_OPS: undefined,
  RISK_ASSESSMENT: undefined,
  SALES_REPS: undefined,
  SALESFORCE: undefined,
  SAMPLES: undefined,
  SAMPLES_RETAILER: undefined,
  SPYGLASS: undefined,
  HELP_CENTER_INFRA: undefined,
  HELP_CENTER_PAGES: undefined,
  HELP_CENTER_SELF_SERVE: undefined,
  SANDBOX: undefined,
  SEARCH: undefined,
  SEARCH_SUGGESTIONS: undefined,
  SEARCH_INFRASTRUCTURE: undefined,
  SEARCH_EXPERIENCE_ACCELERATOR: true,
  SEE_MORE_PAGE: undefined,
  RETAILER_MULTI_USER_MANAGEMENT: true,
  RETAILER_TEAM_SHARING: true,
  SEASONAL_CATEGORIES: undefined,
  IMPERSONATION: undefined,
  SECURITY: undefined,
  SENTRY: undefined,
  SEO: undefined,
  SESSIONS: undefined,
  SETTINGS: undefined,
  SHIPMENTS: true,
  SHIPPING: undefined,
  SHIPPING_SERVICE_EXTRACTION: undefined,
  STATE_MACHINES: undefined,
  ADDRESSES: undefined,
  SHIPPING_INSURANCE: undefined,
  COMMERCIAL_INVOICES: undefined,
  TARIFF_CODES: undefined,
  SAPIENT: undefined,
  SHOPIFY_MAKERS: true,
  SIGNIN: undefined,
  SIGNUP: true,
  SLACK: undefined,
  SLATE_DESIGN_SYSTEM: true,
  SLATE_CORE_COMPONENTS_LIBRARY: true,
  SLATE_FOUNDATIONS_LIBRARY: true,
  SLATE_TOOLS: true,
  BRAND_COMPONENTS_LIBRARY: undefined,
  RETAILER_COMPONENTS_LIBRARY: undefined,
  SLATE_COMPONENTS: undefined,
  SLATE_ICONS: undefined,
  SLATE_FOUNDATIONS: undefined,
  COMMUNITY_LIBRARY_COMPONENTS: undefined,
  STORYBOOK_INFRA: undefined,
  DESIGN_PROTOTYPE_PLAYGROUND: undefined,
  ACCESSIBILITY_TOOLING: undefined,
  ICON_TOOLING: undefined,
  UI_LIBRARY_TOOLING: undefined,
  SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: undefined,
  STRIPE: undefined,
  SUNCO: undefined,
  SWATCHES: undefined,
  SWITCHBOARD: undefined,
  TAKTILE: undefined,
  TASKS: undefined,
  FAIRE_TASK_MANAGER: undefined,
  TAX_FORMS: undefined,
  TAXES: undefined,
  TAXONOMY: undefined,
  TERMS_OF_SERVICE: undefined,
  TEST: undefined,
  TESTIMONIALS: undefined,
  TIME_TURNER: undefined,
  TOP_BRAND: undefined,
  TOP_PRODUCTS: undefined,
  TRADESHOW: undefined,
  UNIVERSAL_FEEDBACK_TOOL: undefined,
  UPMARKET: true,
  UPMARKET_EXPERIENCE: true,
  USER_INVITATION: true,
  USERS: undefined,
  VALIDATION: undefined,
  VIDEOS: undefined,
  VISITORS: true,
  VS_CODE_EXTENSION: undefined,
  WAITLISTED_SIGNUP: undefined,
  WAREHOUSE_TOOLING: undefined,
  WEB_DOCS_SITE: undefined,
  WEB_RETAILER_SERVER: true,
  WEB_SERVER_SIDE_RENDERING: true,
  WEBSERVER: undefined,
  XLSX_IMPORT: true,
  XLSX_ONBOARDING_IMPORT: undefined,
  ZIP_CODE_PROTECTION: true,
  RETAILER_TEAM_MANAGEMENT: undefined,
  BRAND_INCREMENTALITY: undefined,
  ZENDESK: undefined,
  MOBILE_PERFORMANCE_MONITORING_INFRASTRUCTURE: undefined,
  ADS: undefined,
  ADS_MANAGER: undefined,
  LOCAL_FILTERS_AND_MERCHANDISING: undefined,
  RECOGNIZABLE_BRANDS: true,
  LOGGED_OUT_RETAILERS: undefined,
  WEB_BRAND_SERVER: undefined,
  WEB_BRAND_NEXTJS: undefined,
  FINANCIAL_EVENTS: undefined,
  WEB_PROXY: undefined,
  RETAILER_PROFILE_INFO: undefined,
  SHIPPING_RESTRICTION: undefined,
  RECOMMENDATIONS_INFRASTRUCTURE: undefined,
  DISCOVERY_RECOMMENDATIONS: undefined,
  BRAND_PAGE: undefined,
  PRODUCT_PAGE: undefined,
  PRODUCT_PAGE_MINISHOP_AND_RECOMMENDATIONS: undefined,
  PRODUCT_PAGE_PRODUCT_DETAILS: undefined,
  PRODUCT_PAGE_REVIEWS: undefined,
  FONOA: undefined,
  MOBILE_CORE: undefined,
  RETAILER_STORE_MANAGEMENT: undefined,
  COMMISSION_UPDATE_REQUESTS: undefined,
  SCIM: undefined,
  INTERNAL_API_SALESFORCE: undefined,
  INTERNAL_API_CATALOGS_MIGRATION: undefined,
  INTERNAL_API_RETAILER_SHOPIFY_INTEGRATION: undefined,
  INTERNAL_API_INVENTORY: undefined,
  INTERNAL_API_ORDERS: undefined,
  FAIRE_FOR_TEAMS: undefined,
  MULTI_BRAND: undefined,
  ALERT_BANNERS_BRAND: undefined,
  ALERT_BANNERS_RETAILERS: undefined,
  ISSUE_REPORT_CLAWBACKS: undefined,
  RETURN_CLAWBACKS: undefined,
  CANONICAL_DATA: undefined,
  FINACIAL_DATA_PLATFORM: undefined,
  DATA_SECURITY: undefined,
  DATA_WAREHOUSE: undefined,
  DATA_AIRFLOW: undefined,
  DATA_FAIREFLOW: undefined,
  DATA_SQL_VALIDATION_DAG: undefined,
  DATA_FIVETRAN: undefined,
  DATA_LOOKER: undefined,
  DATA_MODE: undefined,
  DATA_SELECTSTAR: undefined,
  DATA_FAIRE_COM: undefined,
  DATA_MESH: undefined,
  DATA_ENV: undefined,
  STREAM_PROCESSING: undefined,
  DATA_AWS: undefined,
  DATA_CONTRACTS: undefined,
  RETAILER_UNIVERSE: undefined,
  KG_SCRAPE: undefined,
  KG_MATCH: undefined,
  XP_METRICS: true,
  FEATURE_STORE: undefined,
  MODEL_STORE: undefined,
  INFERENCE_SERVICE: undefined,
  ML_OBSERVABILITY: undefined,
  OBSERVABILITY: undefined,
  ORACLE_CLOUD: true,
  OCI_GPU_CLUSTER_INFRA: undefined,
  ML_TRAINING: undefined,
  INTERNAL_API_PRODUCTS: undefined,
  INTERNAL_API_IMAGES: undefined,
  BACKEND_TEST_INFRA: undefined,
  CATALOGS_SERVICE: true,
  BRAND_TERMS_OF_SERVICE: undefined,
  RETAILER_NOTIFICATIONS: undefined,
  PHOENIX: undefined,
  MOBILE_APP_BUILD_INFRASTRUCTURE: undefined,
  MOBILE_APP_SETTINGS: undefined,
  MOBILE_APP_STARTUP: undefined,
  PRODUCT_MESSAGING: undefined,
  PERSONALIZATION: undefined,
  CUSTOM_ARRANGEMENT: undefined,
  RUNWAY: undefined,
  CONVERSATIONAL_SEARCH: true,
  RETAILER_ADDRESS_MANAGEMENT: undefined,
  RETAILER_BACKORDERS: undefined,
  DIGEST_PAGE: true,
  PAGE_DATA_APIS: undefined,
  MOBILE_CI: undefined,
  CSV_EXPORT: undefined,
  PAID_MARKETING: undefined,
  BRAND_MESSENGER: undefined,
  RETAILER_MESSENGER: undefined,
  MESSENGER_INFRASTRUCTURE: undefined,
  RETAILER_AUTHORIZATION: undefined,
  SHOP_LOCAL: undefined,
  CONFIG_VARS: undefined,
  CACHING: undefined,
  SIDE_CART: undefined,
  UNLISTED_PRODUCTS: undefined,
  FAIRE_PAY: undefined,
  FULFILLED_BY_FAIRE: undefined,
  SHIPBOB: undefined,
  FULFILLMENT_INBOUND: undefined,
  FAIRE_SOURCE: undefined,
  FAIRE_SOURCE_BUY_IT_AGAIN: true,
  HOME_RETAILER_SERVICE: undefined,
  ADMIN_SERVER: undefined,
  PETE_SERVER: undefined,
  VOLUME_BASED_DISCOUNTS: undefined,
  CI_CD: undefined,
  PRODUCT_BUNDLES: true,
  CUSTOMER_FEEDBACK: undefined,
  MISSION_CONTROL: undefined,
  MOBILE_WARDROBE: undefined,
  SINGLE_SIGN_ON: undefined,
  SDUI: undefined,
  EPPO: undefined,
  VISITOR_APP: undefined,
  VISITOR_SERVER: undefined,
  PURCHASE_ORDER_INGESTION: undefined,
  HELP_CENTER_NEXT_JS: undefined,
  IMPRESSION_LOGGING: undefined,
  RETAILER_BRAND_CONSOLIDATION: undefined,
  PINECONE: undefined,
  BRANDS_SERVICE: undefined,
  BRANDS_SERVICE_MIGRATION: undefined,
  CART_CHECKOUT_IMPROVEMENT: undefined,
  PRODUCT_LISTING_QUALITY: undefined,
  PRODUCT_DELISTING: undefined,
  PRODUCT_EDITOR: undefined,
  ORDERS_MIGRATION: undefined,
  RETAILER_ACCOUNT_MANAGEMENT: undefined,
  OWNED_TOKENS: undefined,
  INSIGHTS_UPDATES_HUB: undefined,
  WEB_BRIDGE: undefined,
  BRAND_SHOPIFY_ADMIN: undefined,
  VIRTUAL_ASSISTANT: undefined,
  TERRAFORM_TOOLING: undefined,
  K8S_CLUSTERS: undefined,
  NETWORKING: undefined,
  AWS_COSTS: undefined,
  DNS: undefined,
  CDN: undefined,
  OBJECT_STORAGE: undefined,
  ONCALL_TOOLS: undefined,
  DISASTER_RECOVERY: undefined,
  SERVICE_MESH: undefined,
  GAMEDAYS: undefined,
  REMOTE_DEV: undefined,
  MESSENGER_USER_CONFIGURATIONS: undefined,
  ADMIN_LAYOUT: undefined,
  RETAILER_VETTING: undefined,
  RETAILER_OFF_FAIRE_MATCH: undefined,
  TEMPORAL: undefined,
  GROW_WITH_FAIRE: undefined,
  MARKET_HUB: undefined,
  MARKET_PROMOTIONS: undefined,
  QUALITY_TOOLING: undefined,
  TEST_INFRA: undefined,
  ONBOARDING_PROJECT: undefined,
  SAMURAI: undefined,
  FAIRE_FUNDS_TRIAGE: undefined,
  BRAND_SALES_REP_ATTRIBUTION: undefined,
  NEXTJS_INFRASTRUCTURE: undefined,
  QUICKBOOKS_ACCOUNTING_SYNC: undefined,
  APP_MODAL_FRAMEWORK: undefined,
  SIGNUP_FLOW: undefined,
  SIGNUP_MODAL: undefined,
  R2B_REQUEST_TO_SHOP: undefined,
  RETAILER_ACTIVATION_CHECKLIST: undefined,
  REVENUE_TEAM: undefined,
  TRENDS: undefined,
  MESSENGER_EMOJI_AND_MESSAGE_REACTION: undefined,
  PORTKEY: undefined,
  UPMARKET_PLUS: undefined,
  FAIREADMIN_ACCESS: undefined,
  SHOPIFY_EMAIL_RELAY: undefined,
  EXTERNAL_API_PRODUCT_PRICES: undefined,
  BRAND_PAGE_HEADER: undefined,
  BRAND_PAGE_PRODUCT_GRID: undefined,
  BRAND_PAGE_RECOMMENDATIONS: undefined,
  BRAND_PAGE_BRAND_REVIEWS: undefined,
  FAIRE_PLUS: undefined,
  PRODUCT_PURCHASABILITY: undefined,
  REORDER_HUB: undefined,
  MESSAGE_TEMPLATES: undefined,
  DATAFOLD: undefined,
  ANOMALO: undefined,
  RETAILER_HEADER: undefined,
  EXTERNAL_API_AUTH: undefined,
  IMAGE_CORRECTNESS_AND_CONSISTENCY: true,
  IMAGE_QUALITY_AND_GOVERNANCE: true,
  PRODUCT_IMAGES: true,
  IMAGE_PLATFORM_INFRASTRUCTURE: undefined,
  PRODUCT_IMAGE_CORRECTNESS_AND_CONSISTENCY: undefined,
  PRODUCT_IMAGE_MANAGEMENT: undefined,
  WORKATO: undefined,
  FUNCTIONAL_STAGE: undefined,
  FORMULA_DSL: undefined,
  FINANCIAL_INVOICE: undefined,
  BRAND_STORIES: undefined,
  SECURITY_UTILITIES: undefined,
  INPUT_SANITIZATION: undefined,
  BOT_DEFENSE: undefined,
  SECURITY_AUDIT_LOGGING: undefined,
  WRITE_MODE_ENFORCEMENT: undefined,
  SECRET_MANAGEMENT: undefined,
  FAIRE_SOURCE_SHOP_PAGE: undefined,
  POSTHOG: undefined,
  SEARCH_BAR: undefined,
  SEARCH_SUGGESTIONS_EMPTY_STATE: undefined,
  BRAND_PAGE_SEARCH: undefined,
  AWS_INFRA: undefined,
  WEB_API: undefined,
  BRAND_FINANCING: undefined,
  COMPLIANCE: undefined,
  MARKDOWN_ALLOWANCES: undefined,
  FSR_CONFIGURATION: undefined,
  SWARM_UI: undefined,
  ANALYTICS_EVENTS: undefined,
  BRAND_SHOPIFY_ORDER_FULFILLMENT_SYNC: undefined,
  BRAND_BULK_FULFILLMENT_CSV: undefined,
  BULK_UPLOAD_FRAMEWORK: undefined,
  CUSTOMIZABLE_PRODUCTS: undefined,
  SHOPIFY_BESTSELLER_NUDGE: undefined,
  FIREBASE: undefined,
  AGENT_DOJO: undefined,
  TEST_DASHBOARD: true,
  FAIRESPACE: undefined,
  TEST_TRACKER: undefined,
  QUIP: undefined,
  IT_IAM: undefined,
  DATA_IMPORTED_ENTITIES: undefined,
  DETEKT: undefined,
  FINANCIAL_INVOICE_SETTLEMENTS: undefined,
};

export const getDeprecatedForProductArea = (
  enumValue: ProductArea | keyof typeof ProductArea
): boolean | undefined => {
  return deprecatedForProductArea[enumValue];
};

const podForProductArea: Partial<Record<ProductArea, keyof typeof FairePod>> = {
  PRODUCT_AREA_UNKNOWN: `FAIRE_POD_UNASSIGNED`,
  ABOUT_US_PAGE: `FAIRE_POD_RETAILER_ACQUISITION`,
  ADMIN: `FAIRE_POD_FINTECH_AND_OPS`,
  ADYEN: `FAIRE_POD_FINTECH_AND_OPS`,
  ADYEN_PAYOUT: `FAIRE_POD_FINTECH_AND_OPS`,
  STRIPE_PAYOUT: `FAIRE_POD_FINTECH_AND_OPS`,
  AFFILIATES: `FAIRE_POD_GROWTH_PLATFORM`,
  AI_BRIDGE: `FAIRE_POD_AI_PLATFORM`,
  AI_TOOLS: `FAIRE_POD_COMPASS`,
  ALCOHOL: `FAIRE_POD_SHIPPING`,
  ALERT_BANNERS: `FAIRE_POD_RETAILER_ACTIVATION`,
  AMEX: `FAIRE_POD_RETAILER_ACTIVATION`,
  ANTI_ABUSE: `FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS`,
  API_PERFORMANCE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  APPAREL_BRAND: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  APPAREL_COLLECTIONS: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  CORE_COLLECTIONS: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  COLLECTIONS_RETAILER_DISPLAY: `FAIRE_POD_EVALUATE`,
  APPAREL_DISCOVERY: `FAIRE_POD_INSPIRE`,
  APPDASH: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  ATELIER_FAIRE: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  AUTH: `FAIRE_POD_SECURITY`,
  AUTOBOTS_FRAMEWORK: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  AUTOPILOT: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  MFA: `FAIRE_POD_ANTI_ABUSE`,
  AWS_SAGEMAKER: `FAIRE_POD_AI_PLATFORM`,
  B2B_REFERRALS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BACKEND_DRIVEN_MESSAGING_CONTAINERS: `FAIRE_POD_SHIPPING`,
  BACKFILA: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  BADGES: `FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM`,
  BLOG_GATED_CONTENT: `FAIRE_POD_RETAILER_ACTIVATION`,
  BOARDS: `FAIRE_POD_INSPIRE`,
  BRAND_ACCOUNT_SETTINGS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_ACQUISITION: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_ANALYTICS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  PRODUCT_SALES_REPORT: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_ANNOUNCEMENTS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_APP: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_CATALOG_COMPLETENESS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_CORE: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_CRM: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  BRAND_CUSTOMER_ENGAGEMENT_SURVEY: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_DAILY_DIGEST: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_EMAIL_PREFERENCES: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_F14D_DISCOUNTS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_FRAUD: `FAIRE_POD_MARKETPLACE_QUALITY`,
  BRAND_HYPE_MAP: `FAIRE_POD_DATA`,
  BRAND_INTEGRATIONS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_INVOICES: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  BRAND_LEADS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_LISTING_QUALITY: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  BRAND_LOYALTY: `FAIRE_POD_MARKETPLACE_QUALITY`,
  BRAND_MARKETING_CAMPAIGNS: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  BRAND_MARKETPLACE: `FAIRE_POD_EVALUATE`,
  BRAND_MARKETPLACE_HOMEPAGE: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_MCP: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_MOBILE: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_MULTI_USER_MANAGEMENT: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_NUDGES: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_ACTIVATION: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_ONBOARDING: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_ORDERS: `FAIRE_POD_SHIPPING`,
  BRAND_PAYOUT_CALCULATION: `FAIRE_POD_FINTECH_AND_OPS`,
  BRAND_NOTIFICATIONS_CENTRE: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_PAYOUTS: `FAIRE_POD_FINTECH_AND_OPS`,
  BRAND_PORTAL_HOMEPAGE: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_PORTAL_SEARCH: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_PORTAL_NAVIGATION: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_PORTAL_PRODUCTS_PAGE: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_PREVIEW: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_PRICING: `FAIRE_POD_MARKETPLACE_QUALITY`,
  BRAND_PRODUCT_SEARCH_SUGGESTIONS: `FAIRE_POD_EVALUATE`,
  BRAND_PRODUCT_TAGS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_PROMOS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_PROSPECTING: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_RESTRICTIONS: `FAIRE_POD_SHIPPING`,
  BRAND_REVIEWS: `FAIRE_POD_EVALUATE`,
  BRAND_SAFETY: `FAIRE_POD_MARKETPLACE_QUALITY`,
  BRAND_SEARCH: `FAIRE_POD_SEARCH_FX`,
  BRAND_SHOP_CURRENCY: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_SHOP_PAGE: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_SHOP_SETTINGS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  PRODUCT_GEO_AVAILABILITY: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_INTEGRATION: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_SHOPIFY_CATALOG_SYNC: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_PRODUCT_IMPORT: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_VARIANT_IMPORT: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_PRODUCT_LINKING: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_PRODUCT_STATUS_SYNC: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_DATA_REPLICATION: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_PERFORMANCE_TRACKING: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_OTHER: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_METAFIELDS_SYNC: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  BRAND_SHOPIFY_CONTENT_SYNC: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_HOME: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_INVENTORY_SYNC: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_ORDER_SYNC: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_SHOPIFY_PREFERENCES: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_SHOPIFY_PRICE_SYNC: `FAIRE_POD_MARKETPLACE_QUALITY`,
  BRAND_SHOPIFY_SALES_CHANNEL_MIGRATION: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_SETUP: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  RETAILER_SHOPIFY_APP: `FAIRE_POD_RETAILER_ACTIVATION`,
  BRAND_SLA: `FAIRE_POD_MARKETPLACE_QUALITY`,
  BRAND_TAGS: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  BRAND_TILE: `FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM`,
  BRAND_VERIFICATION: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_WIDGET: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  BRANDS: `FAIRE_POD_BRAND_PLATFORM`,
  BRAZE: `FAIRE_POD_GROWTH_PLATFORM`,
  BRAZE_EMAILS: `FAIRE_POD_MARKETING_OPERATIONS`,
  BROWSER_EXTENSION: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  BUILDER_IO: `FAIRE_POD_RETAILER_ACQUISITION`,
  BUY_IT_AGAIN: `FAIRE_POD_ORDER_REORDER`,
  BULK_ACTIONS: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  BULK_PRODUCT_EDIT: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BULK_PRODUCT_EXPORT: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BULK_PRODUCT_UPLOAD: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  CAPABILITIES: `FAIRE_POD_SECURITY`,
  CARBON_NEUTRAL_RETAILER: `FAIRE_POD_RETAILER_ACTIVATION`,
  CART: `FAIRE_POD_ORDER_REORDER`,
  CART_RECOMMENDATIONS: `FAIRE_POD_ORDER_REORDER`,
  CART_COLLABORATION: `FAIRE_POD_ORDER_REORDER`,
  CATEGORIES: `FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT`,
  CATEGORY_PAGE_RECOMMENDATIONS: `FAIRE_POD_INSPIRE`,
  BROWSE_INFRASTRUCTURE: `FAIRE_POD_INSPIRE`,
  CATEGORY_RESULTS: `FAIRE_POD_INSPIRE`,
  CATEGORY_RESULTS_RANKING: `FAIRE_POD_PERSONALIZATION`,
  CATALOGS_MIGRATION: `FAIRE_POD_BRAND_PLATFORM`,
  CATALOG_VERIFICATION: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  CHAT_GPT_ENTERPRISE: `FAIRE_POD_AI_PLATFORM`,
  CHECKOUT: `FAIRE_POD_INSIDER`,
  CLAWBACKS: `FAIRE_POD_FINTECH_AND_OPS`,
  CLIENT_EVENTS: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  CLIENT_HEALTH_TOOL: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  COCKROACH_DB: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  COLLECTIONS: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  COMMISSIONS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  COMMS_PLANNER: `FAIRE_POD_GROWTH_PLATFORM`,
  CONDUCTOR: `FAIRE_POD_RETAILER_ACTIVATION`,
  CONSUMER: `FAIRE_POD_RETAILER_ACTIVATION`,
  CSV_IMPORT: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  CURRENCY_CONVERSION: `FAIRE_POD_FINTECH_AND_OPS`,
  CX_CUSTOMER_QUEUES: `FAIRE_POD_FINTECH_AND_OPS`,
  CX_FOUNDATIONS: `FAIRE_POD_FINTECH_AND_OPS`,
  RETAILER_FIRST_ORDER_INCENTIVE: `FAIRE_POD_RETAILER_ONBOARDING`,
  RETAILER_ACTIVATION_INCENTIVES: `FAIRE_POD_RETAILER_ACTIVATION`,
  CX_OPS: `FAIRE_POD_FINTECH_AND_OPS`,
  DATA_ATLAS: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_FACTORY: `FAIRE_POD_DATA`,
  DATA_LAKE: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_LOOKUP: `FAIRE_POD_DATA`,
  DATABASE: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  DATABASE_EXPLORER: `FAIRE_POD_DATA`,
  DELAYER: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  DRAFT_ORDERS: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  RETAILER_DRAFT_ORDERS: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  DUTIES: `FAIRE_POD_SHIPPING`,
  E2E: `FAIRE_POD_PLATFORM_CODE_RELEASE`,
  ECO_FRIENDLY: `FAIRE_POD_INSPIRE`,
  EDGE_INFRA: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  EDIT_ORDERS: `FAIRE_POD_SHIPPING`,
  EMAIL_INFRA: `FAIRE_POD_GROWTH_PLATFORM`,
  ERROR_RATE_TRIAGE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  EVENTS: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  EXCLUSIVITY: `FAIRE_POD_FINTECH_AND_OPS`,
  EXPERIMENTS: `FAIRE_POD_ANALYTICS_PLATFORM`,
  EXPERIMENT_PLATFORM: `FAIRE_POD_CORE_DATA_INFRA`,
  EXPIRED_SETTINGS_CLEANUP: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  EXTERNAL_APIS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  EXTERNAL_API_BRANDS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  EXTERNAL_API_CORE: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  EXTERNAL_API_BRAND_PROMOS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  EXTERNAL_API_ORDERS: `FAIRE_POD_SHIPPING`,
  EXTERNAL_API_OAUTH: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  EXTERNAL_API_MCP_OAUTH: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  EXTERNAL_API_PARTNERSHIPS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  EXTERNAL_API_PRODUCTS: `FAIRE_POD_BRAND_PLATFORM`,
  EXTERNAL_API_PREPACKS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  EXTERNAL_API_PRODUCT_INVENTORY: `FAIRE_POD_BRAND_PLATFORM`,
  EXTERNAL_API_RETAILERS: `FAIRE_POD_RETAILER_ACTIVATION`,
  EXTERNAL_API_TAXONOMY: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  EXTERNAL_API_PRODUCT_REVIEWS: `FAIRE_POD_MARKETPLACE_QUALITY`,
  EXTERNAL_DEVELOPER: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  FAIREY: `FAIRE_POD_AI_PLATFORM`,
  FAIRE_CLI: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  FAIRE_CONTENT: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  FAIRE_DIRECT: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  FAIRE_DIRECT_ADOPTION_EMAIL: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  FAIRE_DIRECT_APP: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  FAIRE_DIRECT_RETAILERS: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  FAIRE_DIRECT_REWARDS: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  FAIRE_DIRECT_REWARDS_LIFECYCLE_EMAIL: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  FAIRE_DIRECT_TRIGGER_EMAIL: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  FAIRE_FOLK_HUB: `FAIRE_POD_INTERNAL_TOOLS`,
  FAIRE_SOCIAL_PROOF: `FAIRE_POD_RETAILER_ACTIVATION`,
  FAIRE_SPACES: `FAIRE_POD_MOBILE_CORE`,
  RETAILER_POS_INTEGRATIONS: `FAIRE_POD_SHIPPING`,
  FAIRESYNC: `FAIRE_POD_SHIPPING`,
  FAIRESYNC_INTEGRATION_CLOVER: `FAIRE_POD_SHIPPING`,
  FAIRESYNC_INTEGRATION_SHOPIFY: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  FAIRESYNC_INTEGRATION_SQUARE: `FAIRE_POD_SHIPPING`,
  FAIRESYNC_INTEGRATION_LIGHTSPEED: `FAIRE_POD_SHIPPING`,
  FAIRESYNC_INTEGRATION_QUICKBOOKS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  FAIREWORKS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  FASHION_WEEK: `FAIRE_POD_UPMARKET_TOOLING`,
  FILTERS: `FAIRE_POD_SEARCH_FX`,
  FLASH_SALES: `FAIRE_POD_FINTECH_AND_OPS`,
  FOOD_AND_BEVERAGE: `FAIRE_POD_FOOD_AND_BEVERAGE`,
  FRONTEND_APIS: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  FRONTEND_TOOLING: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  FULLSTORY_CONFIG: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  GITHUB: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  GMAIL: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  GOOSE: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  GUARANTEED_VOLUME: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  HACK_WEEK: `FAIRE_POD_UNASSIGNED`,
  HELP_CENTER: `FAIRE_POD_FINTECH_AND_OPS`,
  HOME_FEED: `FAIRE_POD_INSPIRE`,
  TRANSLATIONS: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  HUBSPOT: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  IDV: `FAIRE_POD_FINTECH_AND_OPS`,
  IMAGES: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  INALYTICS: `FAIRE_POD_PLATFORM_CODE_RELEASE`,
  INCENTIVES: `FAIRE_POD_RETAILER_ACTIVATION`,
  INFRA: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  INFERENCE: `FAIRE_POD_AI_PLATFORM`,
  INSIDER: `FAIRE_POD_INSIDER`,
  INSTRUMENTS: `FAIRE_POD_FINTECH_AND_OPS`,
  INTERNAL_API: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  INVENTORY: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  ISSUE_REPORTS: `FAIRE_POD_FINTECH_AND_OPS`,
  JOBS: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  KITCHEN_SINK: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  KNOWLEDGE_GRAPH: `FAIRE_POD_GROWTH_PLATFORM`,
  LAIKA: `FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT`,
  LAUNCH_WITH_FAIRE: `FAIRE_POD_OPENING_SOON`,
  LATENCY_TRIAGE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  LEGAL_DOCUMENTS: `FAIRE_POD_RETAILER_ACTIVATION`,
  STAGING: `FAIRE_POD_PLATFORM_CODE_RELEASE`,
  LIVE_STREAMS: `FAIRE_POD_UPMARKET_TOOLING`,
  LLM: `FAIRE_POD_AI_PLATFORM`,
  LLM_OPERATIONS: `FAIRE_POD_AI_PLATFORM`,
  LOCALIZATION: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  LOGGED_IN_HOMEPAGE: `FAIRE_POD_INSPIRE`,
  MAKER_BUY_BACK: `FAIRE_POD_FINTECH_AND_OPS`,
  MARKETS: `FAIRE_POD_INSIDER`,
  MESSENGER: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  MESSENGER_CONTEXT_PANEL: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  MESSENGER_INLINE_CONTEXT: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  MILESTONES: `FAIRE_POD_RETAILER_ACTIVATION`,
  MISPRICED_RESELLER: `FAIRE_POD_MARKETPLACE_QUALITY`,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_IN: `FAIRE_POD_INSPIRE`,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_OUT: `FAIRE_POD_RETAILER_ACQUISITION`,
  MOBILE_RETAILER_LOGGED_OUT: `FAIRE_POD_RETAILER_ACQUISITION`,
  MOBILE_RETAILER_MESSENGER: `FAIRE_POD_RETAILER_ACTIVATION`,
  MOBILE_RETAILER_ONBOARDING: `FAIRE_POD_RETAILER_ACTIVATION`,
  MOBILE_RETAILER_SIGNUP: `FAIRE_POD_RETAILER_ACTIVATION`,
  MY_BRANDS: `FAIRE_POD_INSPIRE`,
  ZENDESK_TRANSLATIONS: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  MYSQL: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  NAVIGATION_INFRASTRUCTURE: `FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM`,
  NAVIGATION_TREE_UX: `FAIRE_POD_INSPIRE`,
  NET_TERMS: `FAIRE_POD_FINTECH_AND_OPS`,
  NEWSROOM: `FAIRE_POD_RETAILER_ACQUISITION`,
  NEW_RETAILERS: `FAIRE_POD_GROWTH_PLATFORM`,
  PARTNERSHIPS_PAGE: `FAIRE_POD_RETAILER_ACQUISITION`,
  OMNISEARCH: `FAIRE_POD_FINTECH_AND_OPS`,
  ONE_FAIRE_TEAM: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  OPEN_SIZING: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  OPEN_WITH_FAIRE: `FAIRE_POD_OPENING_SOON`,
  OPEN_WITH_FAIRE_LOGGED_OUT: `FAIRE_POD_OPENING_SOON`,
  ORDER_SUBMISSION: `FAIRE_POD_INSIDER`,
  ORDERS: `FAIRE_POD_SHIPPING`,
  PACKING_SLIP: `FAIRE_POD_SHIPPING`,
  PAYMENTS: `FAIRE_POD_FINTECH_AND_OPS`,
  PDF_RENDERING: `FAIRE_POD_BRAND_PLATFORM`,
  PERF_DARK_READ: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  PICK_LIST: `FAIRE_POD_SHIPPING`,
  PLAID: `FAIRE_POD_FINTECH_AND_OPS`,
  POSTMARK: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  PR_BOT: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  PREORDERS: `FAIRE_POD_PREORDERS_AND_CUSTOM`,
  PREPACKS: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  PRERELEASE: `FAIRE_POD_PLATFORM_CODE_RELEASE`,
  PRESTASHOP: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  PRICING: `FAIRE_POD_PRICING`,
  PRICING_PARITY: `FAIRE_POD_MARKETPLACE_QUALITY`,
  PRIVACY: `FAIRE_POD_SECURITY`,
  PRODUCERS: `FAIRE_POD_ORDER_REORDER`,
  PRODUCT_CHANGE_HISTORY: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  PRODUCT_INFO: `FAIRE_POD_EVALUATE`,
  PRODUCT_PRICE_MATCH_GUARANTEE: `FAIRE_POD_MARKETPLACE_QUALITY`,
  PRODUCT_REVIEWS: `FAIRE_POD_EVALUATE`,
  PRODUCT_SAMPLES: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  PRODUCT_TILE: `FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM`,
  PRODUCTS: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  PRODUCTS_API: `FAIRE_POD_BRAND_PLATFORM`,
  PRODUCTS_PLATFORM: `FAIRE_POD_BRAND_PLATFORM`,
  PROMO_MODALS: `FAIRE_POD_RETAILER_ACTIVATION`,
  PROMOTIONAL_EVENTS: `FAIRE_POD_INSIDER`,
  PROMO_CODES: `FAIRE_POD_INSIDER`,
  PURCHASE_ORDER: `FAIRE_POD_FINTECH_AND_OPS`,
  PUSH_NOTIFICATIONS: `FAIRE_POD_GROWTH_PLATFORM`,
  QUALTRICS: `FAIRE_POD_GROWTH_PLATFORM`,
  QUEUES: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  QUICK_ADD: `FAIRE_POD_ORDER_REORDER`,
  R2B_REFERRALS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  R2R_REFERRALS: `FAIRE_POD_RETAILER_ACQUISITION`,
  RANKING: `FAIRE_POD_SEARCH_RANKING_ALGORITHMS`,
  RECOMMENDATIONS: `FAIRE_POD_INSPIRE`,
  REDIS: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  RELEASE_TOOL: `FAIRE_POD_PLATFORM_CODE_RELEASE`,
  REGIONAL_SEARCH: `FAIRE_POD_SEARCH_FX`,
  REORDER_UPDATES_HUB: `FAIRE_POD_ORDER_REORDER`,
  RETAILER_ADVERTISING: `FAIRE_POD_RETAILER_ACQUISITION`,
  RETAILER_BRAND_LOYALTY: `FAIRE_POD_FINTECH_AND_OPS`,
  RETAILER_BRANDS_MANAGEMENT: `FAIRE_POD_INSPIRE`,
  RETAILER_FINDER_APP: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  RETAILER_INVOICES: `FAIRE_POD_FINTECH_AND_OPS`,
  RETAILER_LAYOUT_ELEMENTS: `FAIRE_POD_INSPIRE`,
  LAYOUT_SERVICE: `FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM`,
  RETAILER_MARKETING: `FAIRE_POD_GROWTH_PLATFORM`,
  RETAILER_MOBILE: `FAIRE_POD_APP`,
  RETAILER_NUX: `FAIRE_POD_RETAILER_ONBOARDING`,
  RETAILER_ONBOARDING: `FAIRE_POD_RETAILER_ONBOARDING`,
  RETAILER_ORDER_MANAGEMENT: `FAIRE_POD_SHIPPING`,
  RETAILER_OWNER_TRANSFER: `FAIRE_POD_FINTECH_AND_OPS`,
  RETAILER_PORTAL: `FAIRE_POD_RETAILER_ACTIVATION`,
  RETAILER_POS: `FAIRE_POD_SHIPPING`,
  RETAILER_REPORTING: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  RETAILER_SAVINGS: `FAIRE_POD_RETAILER_ACTIVATION`,
  RETAILER_SETTINGS_PAGE: `FAIRE_POD_FINTECH_AND_OPS`,
  RETAILER_STYLE_QUIZ: `FAIRE_POD_RETAILER_ONBOARDING`,
  CAREERS_PAGE: `FAIRE_POD_RETAILER_ACQUISITION`,
  RETAILER_YEAR_IN_REVIEW: `FAIRE_POD_RETAILER_ACTIVATION`,
  RETAILERS: `FAIRE_POD_RETAILER_ACTIVATION`,
  RETAILER_CONVERSION: `FAIRE_POD_RETAILER_ONBOARDING`,
  RETAILER_CORE: `FAIRE_POD_RETAILER_ACTIVATION`,
  RETURNS: `FAIRE_POD_FINTECH_AND_OPS`,
  REVERSE_SYNCER: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  RISK: `FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS`,
  RISK_OPS: `FAIRE_POD_FINTECH_AND_OPS`,
  RISK_ASSESSMENT: `FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS`,
  SALES_REPS: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  SALESFORCE: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  SAMPLES: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  SAMPLES_RETAILER: `FAIRE_POD_ORDER_REORDER`,
  SPYGLASS: `FAIRE_POD_GROWTH_PLATFORM`,
  HELP_CENTER_INFRA: `FAIRE_POD_FINTECH_AND_OPS`,
  HELP_CENTER_PAGES: `FAIRE_POD_FINTECH_AND_OPS`,
  HELP_CENTER_SELF_SERVE: `FAIRE_POD_FINTECH_AND_OPS`,
  SANDBOX: `FAIRE_POD_PLATFORM_CODE_RELEASE`,
  SEARCH: `FAIRE_POD_SEARCH_FX`,
  SEARCH_SUGGESTIONS: `FAIRE_POD_SEARCH_FX`,
  SEARCH_INFRASTRUCTURE: `FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT`,
  SEARCH_EXPERIENCE_ACCELERATOR: `FAIRE_POD_EVALUATE`,
  SEE_MORE_PAGE: `FAIRE_POD_INSPIRE`,
  RETAILER_MULTI_USER_MANAGEMENT: `FAIRE_POD_FINTECH_AND_OPS`,
  RETAILER_TEAM_SHARING: `FAIRE_POD_FINTECH_AND_OPS`,
  SEASONAL_CATEGORIES: `FAIRE_POD_INSPIRE`,
  IMPERSONATION: `FAIRE_POD_SECURITY`,
  SECURITY: `FAIRE_POD_SECURITY`,
  SENTRY: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  SEO: `FAIRE_POD_RETAILER_ACQUISITION`,
  SESSIONS: `FAIRE_POD_SECURITY`,
  SETTINGS: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  SHIPMENTS: `FAIRE_POD_SHIPPING`,
  SHIPPING: `FAIRE_POD_SHIPPING`,
  SHIPPING_SERVICE_EXTRACTION: `FAIRE_POD_VALUE_PLATFORM`,
  STATE_MACHINES: `FAIRE_POD_VALUE_PLATFORM`,
  ADDRESSES: `FAIRE_POD_SHIPPING`,
  SHIPPING_INSURANCE: `FAIRE_POD_SHIPPING`,
  COMMERCIAL_INVOICES: `FAIRE_POD_SHIPPING`,
  TARIFF_CODES: `FAIRE_POD_SHIPPING`,
  SAPIENT: `FAIRE_POD_SHIPPING`,
  SHOPIFY_MAKERS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  SIGNIN: `FAIRE_POD_RETAILER_ACQUISITION`,
  SIGNUP: `FAIRE_POD_RETAILER_ONBOARDING`,
  SLACK: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  SLATE_DESIGN_SYSTEM: `FAIRE_POD_DESIGN_PLATFORM`,
  SLATE_CORE_COMPONENTS_LIBRARY: `FAIRE_POD_DESIGN_PLATFORM`,
  SLATE_FOUNDATIONS_LIBRARY: `FAIRE_POD_DESIGN_PLATFORM`,
  SLATE_TOOLS: `FAIRE_POD_DESIGN_PLATFORM`,
  BRAND_COMPONENTS_LIBRARY: `FAIRE_POD_BRAND_UNASSIGNED`,
  RETAILER_COMPONENTS_LIBRARY: `FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM`,
  SLATE_COMPONENTS: `FAIRE_POD_DESIGN_PLATFORM`,
  SLATE_ICONS: `FAIRE_POD_DESIGN_PLATFORM`,
  SLATE_FOUNDATIONS: `FAIRE_POD_DESIGN_PLATFORM`,
  COMMUNITY_LIBRARY_COMPONENTS: `FAIRE_POD_DESIGN_PLATFORM`,
  STORYBOOK_INFRA: `FAIRE_POD_DESIGN_PLATFORM`,
  DESIGN_PROTOTYPE_PLAYGROUND: `FAIRE_POD_DESIGN_PLATFORM`,
  ACCESSIBILITY_TOOLING: `FAIRE_POD_DESIGN_PLATFORM`,
  ICON_TOOLING: `FAIRE_POD_DESIGN_PLATFORM`,
  UI_LIBRARY_TOOLING: `FAIRE_POD_DESIGN_PLATFORM`,
  SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: `FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL`,
  STRIPE: `FAIRE_POD_FINTECH_AND_OPS`,
  SUNCO: `FAIRE_POD_FINTECH_AND_OPS`,
  SWATCHES: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  SWITCHBOARD: `FAIRE_POD_PLATFORM_CODE_RELEASE`,
  TAKTILE: `FAIRE_POD_FINTECH_AND_OPS`,
  TASKS: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  FAIRE_TASK_MANAGER: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  TAX_FORMS: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  TAXES: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  TAXONOMY: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  TERMS_OF_SERVICE: `FAIRE_POD_FINTECH_AND_OPS`,
  TEST: `FAIRE_POD_UNASSIGNED`,
  TESTIMONIALS: `FAIRE_POD_RETAILER_ACQUISITION`,
  TIME_TURNER: `FAIRE_POD_CORE_DATA_INFRA`,
  TOP_BRAND: `FAIRE_POD_MARKETPLACE_QUALITY`,
  TOP_PRODUCTS: `FAIRE_POD_EVALUATE`,
  TRADESHOW: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  UNIVERSAL_FEEDBACK_TOOL: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  UPMARKET: `FAIRE_POD_UPMARKET_TOOLING`,
  UPMARKET_EXPERIENCE: `FAIRE_POD_UPMARKET_EXPERIENCE`,
  USER_INVITATION: `FAIRE_POD_FINTECH_AND_OPS`,
  USERS: `FAIRE_POD_SECURITY`,
  VALIDATION: `FAIRE_POD_SECURITY`,
  VIDEOS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  VISITORS: `FAIRE_POD_RETAILER_ACQUISITION`,
  VS_CODE_EXTENSION: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  WAITLISTED_SIGNUP: `FAIRE_POD_RETAILER_ONBOARDING`,
  WAREHOUSE_TOOLING: `FAIRE_POD_FINTECH_AND_OPS`,
  WEB_DOCS_SITE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  WEB_RETAILER_SERVER: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  WEB_SERVER_SIDE_RENDERING: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  WEBSERVER: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  XLSX_IMPORT: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  XLSX_ONBOARDING_IMPORT: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  ZIP_CODE_PROTECTION: `FAIRE_POD_FINTECH_AND_OPS`,
  RETAILER_TEAM_MANAGEMENT: `FAIRE_POD_FINTECH_AND_OPS`,
  BRAND_INCREMENTALITY: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  ZENDESK: `FAIRE_POD_FINTECH_AND_OPS`,
  MOBILE_PERFORMANCE_MONITORING_INFRASTRUCTURE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  ADS: `FAIRE_POD_ADS_DELIVERY`,
  ADS_MANAGER: `FAIRE_POD_ADVERTISER_GROWTH`,
  LOCAL_FILTERS_AND_MERCHANDISING: `FAIRE_POD_SEARCH_FX`,
  RECOGNIZABLE_BRANDS: `FAIRE_POD_RETAILER_ACTIVATION`,
  LOGGED_OUT_RETAILERS: `FAIRE_POD_RETAILER_ACQUISITION`,
  WEB_BRAND_SERVER: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  WEB_BRAND_NEXTJS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  FINANCIAL_EVENTS: `FAIRE_POD_VALUE_PLATFORM`,
  WEB_PROXY: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  RETAILER_PROFILE_INFO: `FAIRE_POD_FINTECH_AND_OPS`,
  SHIPPING_RESTRICTION: `FAIRE_POD_SHIPPING`,
  RECOMMENDATIONS_INFRASTRUCTURE: `FAIRE_POD_INSPIRE`,
  DISCOVERY_RECOMMENDATIONS: `FAIRE_POD_INSPIRE`,
  BRAND_PAGE: `FAIRE_POD_EVALUATE`,
  PRODUCT_PAGE: `FAIRE_POD_EVALUATE`,
  PRODUCT_PAGE_MINISHOP_AND_RECOMMENDATIONS: `FAIRE_POD_EVALUATE`,
  PRODUCT_PAGE_PRODUCT_DETAILS: `FAIRE_POD_EVALUATE`,
  PRODUCT_PAGE_REVIEWS: `FAIRE_POD_EVALUATE`,
  FONOA: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  MOBILE_CORE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  RETAILER_STORE_MANAGEMENT: `FAIRE_POD_SHIPPING`,
  COMMISSION_UPDATE_REQUESTS: `FAIRE_POD_FAIRE_DIRECT_GROWTH`,
  SCIM: `FAIRE_POD_SECURITY`,
  INTERNAL_API_SALESFORCE: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  INTERNAL_API_CATALOGS_MIGRATION: `FAIRE_POD_BRAND_PLATFORM`,
  INTERNAL_API_RETAILER_SHOPIFY_INTEGRATION: `FAIRE_POD_RETAILER_ACTIVATION`,
  INTERNAL_API_INVENTORY: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  INTERNAL_API_ORDERS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  FAIRE_FOR_TEAMS: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  MULTI_BRAND: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  ALERT_BANNERS_BRAND: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  ALERT_BANNERS_RETAILERS: `FAIRE_POD_RETAILER_ACTIVATION`,
  ISSUE_REPORT_CLAWBACKS: `FAIRE_POD_FINTECH_AND_OPS`,
  RETURN_CLAWBACKS: `FAIRE_POD_FINTECH_AND_OPS`,
  CANONICAL_DATA: `FAIRE_POD_ANALYTICS_PLATFORM`,
  FINACIAL_DATA_PLATFORM: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_SECURITY: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_WAREHOUSE: `FAIRE_POD_ANALYTICS_PLATFORM`,
  DATA_AIRFLOW: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_FAIREFLOW: `FAIRE_POD_ANALYTICS_PLATFORM`,
  DATA_SQL_VALIDATION_DAG: `FAIRE_POD_ANALYTICS_PLATFORM`,
  DATA_FIVETRAN: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_LOOKER: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_MODE: `FAIRE_POD_ANALYTICS_PLATFORM`,
  DATA_SELECTSTAR: `FAIRE_POD_ANALYTICS_PLATFORM`,
  DATA_FAIRE_COM: `FAIRE_POD_ANALYTICS_PLATFORM`,
  DATA_MESH: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_ENV: `FAIRE_POD_CORE_DATA_INFRA`,
  STREAM_PROCESSING: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_AWS: `FAIRE_POD_CORE_DATA_INFRA`,
  DATA_CONTRACTS: `FAIRE_POD_CORE_DATA_INFRA`,
  RETAILER_UNIVERSE: `FAIRE_POD_CORE_DATA_INFRA`,
  KG_SCRAPE: `FAIRE_POD_CORE_DATA_INFRA`,
  KG_MATCH: `FAIRE_POD_CORE_DATA_INFRA`,
  XP_METRICS: `FAIRE_POD_CORE_DATA_INFRA`,
  FEATURE_STORE: `FAIRE_POD_AI_PLATFORM`,
  MODEL_STORE: `FAIRE_POD_AI_PLATFORM`,
  INFERENCE_SERVICE: `FAIRE_POD_AI_PLATFORM`,
  ML_OBSERVABILITY: `FAIRE_POD_AI_PLATFORM`,
  OBSERVABILITY: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  ORACLE_CLOUD: `FAIRE_POD_AI_PLATFORM`,
  OCI_GPU_CLUSTER_INFRA: `FAIRE_POD_AI_PLATFORM`,
  ML_TRAINING: `FAIRE_POD_AI_PLATFORM`,
  INTERNAL_API_PRODUCTS: `FAIRE_POD_BRAND_PLATFORM`,
  INTERNAL_API_IMAGES: `FAIRE_POD_BRAND_PLATFORM`,
  BACKEND_TEST_INFRA: `FAIRE_POD_BRAND_PLATFORM`,
  CATALOGS_SERVICE: `FAIRE_POD_BRAND_PLATFORM`,
  BRAND_TERMS_OF_SERVICE: `FAIRE_POD_BRAND_PLATFORM`,
  RETAILER_NOTIFICATIONS: `FAIRE_POD_RETAILER_ONBOARDING`,
  PHOENIX: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  MOBILE_APP_BUILD_INFRASTRUCTURE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  MOBILE_APP_SETTINGS: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  MOBILE_APP_STARTUP: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  PRODUCT_MESSAGING: `FAIRE_POD_RETAILER_ACTIVATION`,
  PERSONALIZATION: `FAIRE_POD_PERSONALIZATION`,
  CUSTOM_ARRANGEMENT: `FAIRE_POD_EVALUATE`,
  RUNWAY: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  CONVERSATIONAL_SEARCH: `FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT`,
  RETAILER_ADDRESS_MANAGEMENT: `FAIRE_POD_SHIPPING`,
  RETAILER_BACKORDERS: `FAIRE_POD_SHIPPING`,
  DIGEST_PAGE: `FAIRE_POD_INSPIRE`,
  PAGE_DATA_APIS: `FAIRE_POD_RETAILER_ACQUISITION`,
  MOBILE_CI: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  CSV_EXPORT: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  PAID_MARKETING: `FAIRE_POD_GROWTH_PLATFORM`,
  BRAND_MESSENGER: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  RETAILER_MESSENGER: `FAIRE_POD_RETAILER_ACTIVATION`,
  MESSENGER_INFRASTRUCTURE: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  RETAILER_AUTHORIZATION: `FAIRE_POD_RETAILER_ONBOARDING`,
  SHOP_LOCAL: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  CONFIG_VARS: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  CACHING: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  SIDE_CART: `FAIRE_POD_ORDER_REORDER`,
  UNLISTED_PRODUCTS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  FAIRE_PAY: `FAIRE_POD_FAIRE_PAY`,
  FULFILLED_BY_FAIRE: `FAIRE_POD_FULFILLMENT`,
  SHIPBOB: `FAIRE_POD_FULFILLMENT`,
  FULFILLMENT_INBOUND: `FAIRE_POD_FULFILLMENT`,
  FAIRE_SOURCE: `FAIRE_POD_FULFILLMENT`,
  FAIRE_SOURCE_BUY_IT_AGAIN: `FAIRE_POD_FULFILLMENT`,
  HOME_RETAILER_SERVICE: `FAIRE_POD_RETAILER_ACQUISITION`,
  ADMIN_SERVER: `FAIRE_POD_FINTECH_AND_OPS`,
  PETE_SERVER: `FAIRE_POD_PLATFORM_CODE_RELEASE`,
  VOLUME_BASED_DISCOUNTS: `FAIRE_POD_INSIDER`,
  CI_CD: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  PRODUCT_BUNDLES: `FAIRE_POD_EVALUATE`,
  CUSTOMER_FEEDBACK: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  MISSION_CONTROL: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  MOBILE_WARDROBE: `FAIRE_POD_VALUE_MOBILE`,
  SINGLE_SIGN_ON: `FAIRE_POD_RETAILER_ACQUISITION`,
  SDUI: `FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM`,
  EPPO: `FAIRE_POD_RETAILER_ACQUISITION`,
  VISITOR_APP: `FAIRE_POD_RETAILER_ACQUISITION`,
  VISITOR_SERVER: `FAIRE_POD_RETAILER_ACQUISITION`,
  PURCHASE_ORDER_INGESTION: `FAIRE_POD_ORDER_REORDER`,
  HELP_CENTER_NEXT_JS: `FAIRE_POD_FINTECH_AND_OPS`,
  IMPRESSION_LOGGING: `FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM`,
  RETAILER_BRAND_CONSOLIDATION: `FAIRE_POD_SHIPPING`,
  PINECONE: `FAIRE_POD_AI_PLATFORM`,
  BRANDS_SERVICE: `FAIRE_POD_BRAND_PLATFORM`,
  BRANDS_SERVICE_MIGRATION: `FAIRE_POD_BRAND_PLATFORM`,
  CART_CHECKOUT_IMPROVEMENT: `FAIRE_POD_RETAILER_ACTIVATION`,
  PRODUCT_LISTING_QUALITY: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  PRODUCT_DELISTING: `FAIRE_POD_MARKETPLACE_QUALITY`,
  PRODUCT_EDITOR: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  ORDERS_MIGRATION: `FAIRE_POD_VALUE_PLATFORM`,
  RETAILER_ACCOUNT_MANAGEMENT: `FAIRE_POD_FINTECH_AND_OPS`,
  OWNED_TOKENS: `FAIRE_POD_SECURITY`,
  INSIGHTS_UPDATES_HUB: `FAIRE_POD_INSPIRE`,
  WEB_BRIDGE: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  BRAND_SHOPIFY_ADMIN: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  VIRTUAL_ASSISTANT: `FAIRE_POD_FINTECH_AND_OPS`,
  TERRAFORM_TOOLING: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  K8S_CLUSTERS: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  NETWORKING: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  AWS_COSTS: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  DNS: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  CDN: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  OBJECT_STORAGE: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  ONCALL_TOOLS: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  DISASTER_RECOVERY: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  SERVICE_MESH: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  GAMEDAYS: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  REMOTE_DEV: `FAIRE_POD_PLATFORM_CODE_AUTHORING`,
  MESSENGER_USER_CONFIGURATIONS: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  ADMIN_LAYOUT: `FAIRE_POD_FINTECH_AND_OPS`,
  RETAILER_VETTING: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  RETAILER_OFF_FAIRE_MATCH: `FAIRE_POD_RETAILER_ONBOARDING`,
  TEMPORAL: `FAIRE_POD_VALUE_PLATFORM`,
  GROW_WITH_FAIRE: `FAIRE_POD_INSIDER`,
  MARKET_HUB: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  MARKET_PROMOTIONS: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  QUALITY_TOOLING: `FAIRE_POD_UNASSIGNED`,
  TEST_INFRA: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  ONBOARDING_PROJECT: `FAIRE_POD_UNASSIGNED`,
  SAMURAI: `FAIRE_POD_PLATFORM_CODE_AUTHORING`,
  FAIRE_FUNDS_TRIAGE: `FAIRE_POD_UNASSIGNED`,
  BRAND_SALES_REP_ATTRIBUTION: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  NEXTJS_INFRASTRUCTURE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  QUICKBOOKS_ACCOUNTING_SYNC: `FAIRE_POD_FAIRE_PAY`,
  APP_MODAL_FRAMEWORK: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  SIGNUP_FLOW: `FAIRE_POD_RETAILER_ONBOARDING`,
  SIGNUP_MODAL: `FAIRE_POD_RETAILER_ACQUISITION`,
  R2B_REQUEST_TO_SHOP: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  RETAILER_ACTIVATION_CHECKLIST: `FAIRE_POD_RETAILER_ACTIVATION`,
  REVENUE_TEAM: `FAIRE_POD_SECURITY`,
  TRENDS: `FAIRE_POD_INSPIRE`,
  MESSENGER_EMOJI_AND_MESSAGE_REACTION: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  PORTKEY: `FAIRE_POD_AI_PLATFORM`,
  UPMARKET_PLUS: `FAIRE_POD_UPMARKET_PLUS`,
  FAIREADMIN_ACCESS: `FAIRE_POD_SECURITY`,
  SHOPIFY_EMAIL_RELAY: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  EXTERNAL_API_PRODUCT_PRICES: `FAIRE_POD_BRAND_PLATFORM`,
  BRAND_PAGE_HEADER: `FAIRE_POD_EVALUATE`,
  BRAND_PAGE_PRODUCT_GRID: `FAIRE_POD_EVALUATE`,
  BRAND_PAGE_RECOMMENDATIONS: `FAIRE_POD_EVALUATE`,
  BRAND_PAGE_BRAND_REVIEWS: `FAIRE_POD_EVALUATE`,
  FAIRE_PLUS: `FAIRE_POD_UPMARKET_PLUS`,
  PRODUCT_PURCHASABILITY: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  REORDER_HUB: `FAIRE_POD_ORDER_REORDER`,
  MESSAGE_TEMPLATES: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  DATAFOLD: `FAIRE_POD_ANALYTICS_PLATFORM`,
  ANOMALO: `FAIRE_POD_ANALYTICS_PLATFORM`,
  RETAILER_HEADER: `FAIRE_POD_EVALUATE`,
  EXTERNAL_API_AUTH: `FAIRE_POD_SECURITY`,
  IMAGE_CORRECTNESS_AND_CONSISTENCY: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  IMAGE_QUALITY_AND_GOVERNANCE: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  PRODUCT_IMAGES: `FAIRE_POD_BRAND_PLATFORM`,
  IMAGE_PLATFORM_INFRASTRUCTURE: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  PRODUCT_IMAGE_CORRECTNESS_AND_CONSISTENCY: `FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES`,
  PRODUCT_IMAGE_MANAGEMENT: `FAIRE_POD_BRAND_PLATFORM`,
  WORKATO: `FAIRE_POD_FINTECH_AND_OPS`,
  FUNCTIONAL_STAGE: `FAIRE_POD_ADS_DELIVERY`,
  FORMULA_DSL: `FAIRE_POD_ADS_DELIVERY`,
  FINANCIAL_INVOICE: `FAIRE_POD_VALUE_PLATFORM`,
  BRAND_STORIES: `FAIRE_POD_RELATIONSHIP_GROWTH`,
  SECURITY_UTILITIES: `FAIRE_POD_SECURITY`,
  INPUT_SANITIZATION: `FAIRE_POD_SECURITY`,
  BOT_DEFENSE: `FAIRE_POD_SECURITY`,
  SECURITY_AUDIT_LOGGING: `FAIRE_POD_SECURITY`,
  WRITE_MODE_ENFORCEMENT: `FAIRE_POD_SECURITY`,
  SECRET_MANAGEMENT: `FAIRE_POD_SECURITY`,
  FAIRE_SOURCE_SHOP_PAGE: `FAIRE_POD_FULFILLMENT`,
  POSTHOG: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  SEARCH_BAR: `FAIRE_POD_SEARCH_FX`,
  SEARCH_SUGGESTIONS_EMPTY_STATE: `FAIRE_POD_SEARCH_FX`,
  BRAND_PAGE_SEARCH: `FAIRE_POD_EVALUATE`,
  AWS_INFRA: `FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY`,
  WEB_API: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  BRAND_FINANCING: `FAIRE_POD_FINTECH_AND_OPS`,
  COMPLIANCE: `FAIRE_POD_SECURITY`,
  MARKDOWN_ALLOWANCES: `FAIRE_POD_FINTECH_AND_OPS`,
  FSR_CONFIGURATION: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  SWARM_UI: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  ANALYTICS_EVENTS: `FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS`,
  BRAND_SHOPIFY_ORDER_FULFILLMENT_SYNC: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BRAND_BULK_FULFILLMENT_CSV: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  BULK_UPLOAD_FRAMEWORK: `FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM`,
  CUSTOMIZABLE_PRODUCTS: `FAIRE_POD_PREORDERS_AND_CUSTOM`,
  SHOPIFY_BESTSELLER_NUDGE: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  FIREBASE: `FAIRE_POD_GROWTH_PLATFORM`,
  AGENT_DOJO: `FAIRE_POD_PLATFORM_CODE_AUTHORING`,
  TEST_DASHBOARD: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  FAIRESPACE: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  TEST_TRACKER: `FAIRE_POD_PLATFORM_CODE_REVIEW`,
  QUIP: `FAIRE_POD_CLIENT_FOUNDATIONS`,
  IT_IAM: `FAIRE_POD_SECURITY`,
  DATA_IMPORTED_ENTITIES: `FAIRE_POD_BRAND_CATALOG_GROWTH`,
  DETEKT: `FAIRE_POD_PLATFORM_CODE_AUTHORING`,
  FINANCIAL_INVOICE_SETTLEMENTS: `FAIRE_POD_RELATIONSHIP_GROWTH`,
};

export const getPodForProductArea = (
  enumValue: ProductArea | keyof typeof ProductArea
): keyof typeof FairePod | undefined => {
  return podForProductArea[enumValue];
};

const titleForProductArea: Partial<Record<ProductArea, string>> = {
  PRODUCT_AREA_UNKNOWN: undefined,
  ABOUT_US_PAGE: `About Us Page`,
  ADMIN: `Admin Authorization`,
  ADYEN: undefined,
  ADYEN_PAYOUT: `Adyen Payout`,
  STRIPE_PAYOUT: `Stripe Payout`,
  AFFILIATES: `Affiliates`,
  AI_BRIDGE: `AI Bridge`,
  AI_TOOLS: `AI Tools`,
  ALCOHOL: `Alcohol`,
  ALERT_BANNERS: `Alert Banners`,
  AMEX: `Amex landing page`,
  ANTI_ABUSE: `Anti-Abuse`,
  API_PERFORMANCE: `Api Performance`,
  APPAREL_BRAND: undefined,
  APPAREL_COLLECTIONS: `Apparel Product Based Collections`,
  CORE_COLLECTIONS: `Core Product Based Collections`,
  COLLECTIONS_RETAILER_DISPLAY: `Collections Retailer Display`,
  APPAREL_DISCOVERY: undefined,
  APPDASH: `Appdash`,
  ATELIER_FAIRE: `L'Atelier Faire`,
  AUTH: `Authentication`,
  AUTOBOTS_FRAMEWORK: `Autobots Framework`,
  AUTOPILOT: `Autopilot`,
  MFA: `MFA`,
  AWS_SAGEMAKER: `AWS Sagemaker`,
  B2B_REFERRALS: `B2B Referrals`,
  BACKEND_DRIVEN_MESSAGING_CONTAINERS: `Backend-Driven Messaging Containers`,
  BACKFILA: `Backfila`,
  BADGES: undefined,
  BLOG_GATED_CONTENT: `Blog Gated Content`,
  BOARDS: undefined,
  BRAND_ACCOUNT_SETTINGS: `Brand Account Settings`,
  BRAND_ACQUISITION: `Brand Acquisition`,
  BRAND_ANALYTICS: undefined,
  PRODUCT_SALES_REPORT: `Brand Analytics Product Sales Report`,
  BRAND_ANNOUNCEMENTS: undefined,
  BRAND_APP: undefined,
  BRAND_CATALOG_COMPLETENESS: `Brand catalog completeness`,
  BRAND_CORE: undefined,
  BRAND_CRM: undefined,
  BRAND_CUSTOMER_ENGAGEMENT_SURVEY: undefined,
  BRAND_DAILY_DIGEST: undefined,
  BRAND_EMAIL_PREFERENCES: undefined,
  BRAND_F14D_DISCOUNTS: undefined,
  BRAND_FRAUD: `Brand Fraud`,
  BRAND_HYPE_MAP: undefined,
  BRAND_INTEGRATIONS: `Brand Integrations`,
  BRAND_INVOICES: undefined,
  BRAND_LEADS: undefined,
  BRAND_LISTING_QUALITY: undefined,
  BRAND_LOYALTY: `Brand Loyalty Programs`,
  BRAND_MARKETING_CAMPAIGNS: undefined,
  BRAND_MARKETPLACE: undefined,
  BRAND_MARKETPLACE_HOMEPAGE: undefined,
  BRAND_MCP: `Brand MCP`,
  BRAND_MOBILE: `Faire Brand App`,
  BRAND_MULTI_USER_MANAGEMENT: undefined,
  BRAND_NUDGES: undefined,
  BRAND_ACTIVATION: `Brand Activation`,
  BRAND_ONBOARDING: `Brand Onboarding`,
  BRAND_ORDERS: undefined,
  BRAND_PAYOUT_CALCULATION: `Payout calculation`,
  BRAND_NOTIFICATIONS_CENTRE: `Brand Notifications Centre`,
  BRAND_PAYOUTS: `Brand payouts`,
  BRAND_PORTAL_HOMEPAGE: `Brand portal homepage`,
  BRAND_PORTAL_SEARCH: `Brand portal search`,
  BRAND_PORTAL_NAVIGATION: undefined,
  BRAND_PORTAL_PRODUCTS_PAGE: `Brand portal products page`,
  BRAND_PREVIEW: `Brand Preview`,
  BRAND_PRICING: `Brand Product Pricing`,
  BRAND_PRODUCT_SEARCH_SUGGESTIONS: `Brand Product Search Suggestions`,
  BRAND_PRODUCT_TAGS: `Brand Product Tags`,
  BRAND_PROMOS: undefined,
  BRAND_PROSPECTING: undefined,
  BRAND_RESTRICTIONS: `Brand restrictions`,
  BRAND_REVIEWS: `Brand Reviews`,
  BRAND_SAFETY: `Brand Safety`,
  BRAND_SEARCH: `Brand Search`,
  BRAND_SHOP_CURRENCY: `Brand shop currency`,
  BRAND_SHOP_PAGE: undefined,
  BRAND_SHOP_SETTINGS: undefined,
  PRODUCT_GEO_AVAILABILITY: `Product Geo Availability`,
  BRAND_SHOPIFY_INTEGRATION: undefined,
  BRAND_SHOPIFY_CATALOG_SYNC: `Brand Shopify Catalog Sync`,
  BRAND_SHOPIFY_PRODUCT_IMPORT: `Brand Shopify Product Import`,
  BRAND_SHOPIFY_VARIANT_IMPORT: `Brand Shopify Variant Import`,
  BRAND_SHOPIFY_PRODUCT_LINKING: `Brand Shopify Product Linking`,
  BRAND_SHOPIFY_PRODUCT_STATUS_SYNC: `Brand Shopify Product Status Sync`,
  BRAND_SHOPIFY_DATA_REPLICATION: `Brand Shopify Data Replication`,
  BRAND_SHOPIFY_PERFORMANCE_TRACKING: `Brand Shopify Performance Tracking`,
  BRAND_SHOPIFY_OTHER: `Brand Shopify Other`,
  BRAND_SHOPIFY_METAFIELDS_SYNC: `Brand Shopify Metafields Sync`,
  BRAND_SHOPIFY_CONTENT_SYNC: `Brand Shopify Content Sync`,
  BRAND_SHOPIFY_HOME: `Brand Shopify Home`,
  BRAND_SHOPIFY_INVENTORY_SYNC: `Brand Shopify Inventory Sync`,
  BRAND_SHOPIFY_ORDER_SYNC: `Brand Shopify Order Sync`,
  BRAND_SHOPIFY_PREFERENCES: `Brand Shopify Preferences`,
  BRAND_SHOPIFY_PRICE_SYNC: `Brand Shopify Price Sync`,
  BRAND_SHOPIFY_SALES_CHANNEL_MIGRATION: `Brand Shopify Sales Channel Migration`,
  BRAND_SHOPIFY_SETUP: `Brand Shopify Setup`,
  RETAILER_SHOPIFY_APP: undefined,
  BRAND_SLA: `Brand SLA`,
  BRAND_TAGS: undefined,
  BRAND_TILE: `Brand tile`,
  BRAND_VERIFICATION: undefined,
  BRAND_WIDGET: `Brand Widget`,
  BRANDS: undefined,
  BRAZE: `Braze Infrastructure`,
  BRAZE_EMAILS: `Braze Emails`,
  BROWSER_EXTENSION: `Faire Browser Extension`,
  BUILDER_IO: `Builder.io`,
  BUY_IT_AGAIN: `Buy it again`,
  BULK_ACTIONS: `Bulk Actions`,
  BULK_PRODUCT_EDIT: `Bulk Product Edit`,
  BULK_PRODUCT_EXPORT: `Bulk Product Export`,
  BULK_PRODUCT_UPLOAD: `Bulk Product Upload`,
  CAPABILITIES: `Capabilities`,
  CARBON_NEUTRAL_RETAILER: undefined,
  CART: `Cart`,
  CART_RECOMMENDATIONS: `Cart Recommendations`,
  CART_COLLABORATION: `Cart Collaboration`,
  CATEGORIES: undefined,
  CATEGORY_PAGE_RECOMMENDATIONS: `Category page layouts`,
  BROWSE_INFRASTRUCTURE: `browse Infrastructure`,
  CATEGORY_RESULTS: `Category results page`,
  CATEGORY_RESULTS_RANKING: `Category results ranking`,
  CATALOGS_MIGRATION: `Code related to migrating from monolith -> catalogs service`,
  CATALOG_VERIFICATION: `Catalog Verification`,
  CHAT_GPT_ENTERPRISE: `Chat GPT Enterprise`,
  CHECKOUT: `Checkout`,
  CLAWBACKS: `Clawbacks`,
  CLIENT_EVENTS: `Client Events`,
  CLIENT_HEALTH_TOOL: `Client Health Tool`,
  COCKROACH_DB: `Cockroach DB`,
  COLLECTIONS: `(Deprecated) Starter Collections`,
  COMMISSIONS: `(Deprecated) Commissions`,
  COMMS_PLANNER: `Outgoing Comms Planner`,
  CONDUCTOR: `Conductor`,
  CONSUMER: `Consumer`,
  CSV_IMPORT: undefined,
  CURRENCY_CONVERSION: `Currency conversion`,
  CX_CUSTOMER_QUEUES: `CX Customer Queues`,
  CX_FOUNDATIONS: `CX Foundations`,
  RETAILER_FIRST_ORDER_INCENTIVE: `First Order Incentive`,
  RETAILER_ACTIVATION_INCENTIVES: `Retailer Activation Incentives`,
  CX_OPS: `CX Operations`,
  DATA_ATLAS: `Data Atlas`,
  DATA_FACTORY: `Data Factory`,
  DATA_LAKE: `Data Lake`,
  DATA_LOOKUP: undefined,
  DATABASE: `Database`,
  DATABASE_EXPLORER: `Database Explorer`,
  DELAYER: `Delayer`,
  DRAFT_ORDERS: undefined,
  RETAILER_DRAFT_ORDERS: undefined,
  DUTIES: `Customs Duties`,
  E2E: `E2E Infrastructure`,
  ECO_FRIENDLY: `Eco-friendly Experience`,
  EDGE_INFRA: `Edge Worker Infrastructure`,
  EDIT_ORDERS: undefined,
  EMAIL_INFRA: `Email Infrastructure`,
  ERROR_RATE_TRIAGE: `DD Monitor Error Ticket to Pod Triage`,
  EVENTS: `Events`,
  EXCLUSIVITY: `Exclusivity`,
  EXPERIMENTS: `Experiments`,
  EXPERIMENT_PLATFORM: `Experiment Platform`,
  EXPIRED_SETTINGS_CLEANUP: `Expired Settings Cleanup`,
  EXTERNAL_APIS: undefined,
  EXTERNAL_API_BRANDS: `External API - Brands`,
  EXTERNAL_API_CORE: `External API - Core`,
  EXTERNAL_API_BRAND_PROMOS: `External API - Brands`,
  EXTERNAL_API_ORDERS: `External API - Orders`,
  EXTERNAL_API_OAUTH: `External API OAuth`,
  EXTERNAL_API_MCP_OAUTH: `External API - MCP OAuth`,
  EXTERNAL_API_PARTNERSHIPS: `External API - Partnerships`,
  EXTERNAL_API_PRODUCTS: `External API - Products`,
  EXTERNAL_API_PREPACKS: `External API - Prepacks`,
  EXTERNAL_API_PRODUCT_INVENTORY: `External API - Inventory`,
  EXTERNAL_API_RETAILERS: `External API - Retailers`,
  EXTERNAL_API_TAXONOMY: `External API - Taxonomy`,
  EXTERNAL_API_PRODUCT_REVIEWS: `External API - Product Reviews`,
  EXTERNAL_DEVELOPER: undefined,
  FAIREY: `Fairey`,
  FAIRE_CLI: `Faire CLI`,
  FAIRE_CONTENT: undefined,
  FAIRE_DIRECT: `Faire Direct`,
  FAIRE_DIRECT_ADOPTION_EMAIL: `Faire Direct Adoption email`,
  FAIRE_DIRECT_APP: `Faire Direct App`,
  FAIRE_DIRECT_RETAILERS: `Faire Direct Retailers`,
  FAIRE_DIRECT_REWARDS: `Faire Direct Rewards`,
  FAIRE_DIRECT_REWARDS_LIFECYCLE_EMAIL: `Faire Direct Rewards Lifecycle Email`,
  FAIRE_DIRECT_TRIGGER_EMAIL: `Faire Direct Trigger Email`,
  FAIRE_FOLK_HUB: undefined,
  FAIRE_SOCIAL_PROOF: `TrustPilot integration`,
  FAIRE_SPACES: undefined,
  RETAILER_POS_INTEGRATIONS: undefined,
  FAIRESYNC: undefined,
  FAIRESYNC_INTEGRATION_CLOVER: undefined,
  FAIRESYNC_INTEGRATION_SHOPIFY: undefined,
  FAIRESYNC_INTEGRATION_SQUARE: undefined,
  FAIRESYNC_INTEGRATION_LIGHTSPEED: undefined,
  FAIRESYNC_INTEGRATION_QUICKBOOKS: undefined,
  FAIREWORKS: undefined,
  FASHION_WEEK: undefined,
  FILTERS: `Filters`,
  FLASH_SALES: `Flash Sales`,
  FOOD_AND_BEVERAGE: undefined,
  FRONTEND_APIS: undefined,
  FRONTEND_TOOLING: `Frontend Tooling`,
  FULLSTORY_CONFIG: `FullStory recording`,
  GITHUB: `GitHub`,
  GMAIL: undefined,
  GOOSE: `Goose`,
  GUARANTEED_VOLUME: undefined,
  HACK_WEEK: undefined,
  HELP_CENTER: `Help Center`,
  HOME_FEED: `Home Feed`,
  TRANSLATIONS: `Translation Infrastucture`,
  HUBSPOT: undefined,
  IDV: `Identity Verification`,
  IMAGES: undefined,
  INALYTICS: `Inalytics`,
  INCENTIVES: `Incentives`,
  INFRA: `Infrastructure`,
  INFERENCE: undefined,
  INSIDER: `Insider`,
  INSTRUMENTS: `Instruments`,
  INTERNAL_API: undefined,
  INVENTORY: undefined,
  ISSUE_REPORTS: undefined,
  JOBS: `Job Framework`,
  KITCHEN_SINK: `Kitchen Sink`,
  KNOWLEDGE_GRAPH: `Knowledge Graph`,
  LAIKA: `Laika`,
  LAUNCH_WITH_FAIRE: undefined,
  LATENCY_TRIAGE: `DD Monitor Latency Ticket to Pod Triage`,
  LEGAL_DOCUMENTS: `Legal Documents`,
  STAGING: `Staging`,
  LIVE_STREAMS: undefined,
  LLM: undefined,
  LLM_OPERATIONS: `LLM Operations`,
  LOCALIZATION: `Localization`,
  LOGGED_IN_HOMEPAGE: `Logged-in Homepage`,
  MAKER_BUY_BACK: `Maker Buy Back`,
  MARKETS: `Markets`,
  MESSENGER: `Messenger`,
  MESSENGER_CONTEXT_PANEL: `Messenger Context Panel`,
  MESSENGER_INLINE_CONTEXT: `Messenger Inline Context`,
  MILESTONES: `Milestones`,
  MISPRICED_RESELLER: `Mispriced Reseller`,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_IN: `Mobile Retailer Homepage Logged In`,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_OUT: `Mobile Retailer Homepage Logged Out`,
  MOBILE_RETAILER_LOGGED_OUT: `Mobile Retailer Logged Out Experience`,
  MOBILE_RETAILER_MESSENGER: `Mobile Retailer Messenger`,
  MOBILE_RETAILER_ONBOARDING: `Mobile Retailer Onboarding`,
  MOBILE_RETAILER_SIGNUP: `Mobile Retailer Signup`,
  MY_BRANDS: `My Brands`,
  ZENDESK_TRANSLATIONS: `Zendesk Translations`,
  MYSQL: `MySQL`,
  NAVIGATION_INFRASTRUCTURE: `Infrastructure that powers the navigation experience`,
  NAVIGATION_TREE_UX: `Navigation Tree UX`,
  NET_TERMS: `Net Terms`,
  NEWSROOM: `Newsroom`,
  NEW_RETAILERS: `New Retailers`,
  PARTNERSHIPS_PAGE: `Partnerships Page`,
  OMNISEARCH: `Omnisearch`,
  ONE_FAIRE_TEAM: `One Faire Team`,
  OPEN_SIZING: undefined,
  OPEN_WITH_FAIRE: `Open with Faire`,
  OPEN_WITH_FAIRE_LOGGED_OUT: `Open with Faire - Logged-out`,
  ORDER_SUBMISSION: undefined,
  ORDERS: undefined,
  PACKING_SLIP: undefined,
  PAYMENTS: `Payments`,
  PDF_RENDERING: `PDF Rendering`,
  PERF_DARK_READ: `Performance Dark Read`,
  PICK_LIST: undefined,
  PLAID: undefined,
  POSTMARK: undefined,
  PR_BOT: `PR Bot`,
  PREORDERS: undefined,
  PREPACKS: undefined,
  PRERELEASE: `Prerelease`,
  PRESTASHOP: `Prestashop`,
  PRICING: undefined,
  PRICING_PARITY: `Pricing Parity`,
  PRIVACY: `Data Privacy & Compliance`,
  PRODUCERS: undefined,
  PRODUCT_CHANGE_HISTORY: `Product Change History`,
  PRODUCT_INFO: undefined,
  PRODUCT_PRICE_MATCH_GUARANTEE: `Product Price Match Guarantee`,
  PRODUCT_REVIEWS: `Product Reviews`,
  PRODUCT_SAMPLES: `Product Samples`,
  PRODUCT_TILE: `Product tiles`,
  PRODUCTS: undefined,
  PRODUCTS_API: undefined,
  PRODUCTS_PLATFORM: undefined,
  PROMO_MODALS: `Promo modals`,
  PROMOTIONAL_EVENTS: `Promotional Events`,
  PROMO_CODES: `Promo codes for retailers`,
  PURCHASE_ORDER: `Purchase Order`,
  PUSH_NOTIFICATIONS: `Push Notifications`,
  QUALTRICS: undefined,
  QUEUES: `Queues`,
  QUICK_ADD: `Quick Add`,
  R2B_REFERRALS: undefined,
  R2R_REFERRALS: undefined,
  RANKING: `Search Ranking`,
  RECOMMENDATIONS: undefined,
  REDIS: `Redis`,
  RELEASE_TOOL: `Release Tool`,
  REGIONAL_SEARCH: `Regional Search`,
  REORDER_UPDATES_HUB: `Reorder Updates Hub`,
  RETAILER_ADVERTISING: `Advertising to retailers`,
  RETAILER_BRAND_LOYALTY: `Retailer Brand Loyalty`,
  RETAILER_BRANDS_MANAGEMENT: `Retailer Brands Management`,
  RETAILER_FINDER_APP: undefined,
  RETAILER_INVOICES: undefined,
  RETAILER_LAYOUT_ELEMENTS: `Retailer Layout Elements`,
  LAYOUT_SERVICE: `Layout Service`,
  RETAILER_MARKETING: undefined,
  RETAILER_MOBILE: `Faire Retailer App`,
  RETAILER_NUX: `Retailer NUX`,
  RETAILER_ONBOARDING: `Retailer Onboarding`,
  RETAILER_ORDER_MANAGEMENT: `Retailer Order Management`,
  RETAILER_OWNER_TRANSFER: `Retailer owner transfer`,
  RETAILER_PORTAL: undefined,
  RETAILER_POS: undefined,
  RETAILER_REPORTING: undefined,
  RETAILER_SAVINGS: `Retailer Savings`,
  RETAILER_SETTINGS_PAGE: `Retailer Settings Page`,
  RETAILER_STYLE_QUIZ: `Retailer Style Quiz`,
  CAREERS_PAGE: `Careers Page`,
  RETAILER_YEAR_IN_REVIEW: `Retailer Year In Review`,
  RETAILERS: `Retailers`,
  RETAILER_CONVERSION: `Retailer Conversion`,
  RETAILER_CORE: undefined,
  RETURNS: `Returns`,
  REVERSE_SYNCER: `Reverse Syncer`,
  RISK: undefined,
  RISK_OPS: `Risk Operations`,
  RISK_ASSESSMENT: `Risk Assessment`,
  SALES_REPS: `Sales Reps`,
  SALESFORCE: undefined,
  SAMPLES: `Samples`,
  SAMPLES_RETAILER: `Retailer-facing samples`,
  SPYGLASS: `Spyglass`,
  HELP_CENTER_INFRA: `Help Center Infrastructure`,
  HELP_CENTER_PAGES: `Help Center Pages`,
  HELP_CENTER_SELF_SERVE: `Help Center Self-Serve`,
  SANDBOX: `Backend sandbox environments`,
  SEARCH: `Search UX`,
  SEARCH_SUGGESTIONS: `Search Suggestions`,
  SEARCH_INFRASTRUCTURE: `Search Infrastructure`,
  SEARCH_EXPERIENCE_ACCELERATOR: `Temporary catch-all product area for things owned by the Search Experience Accelerator Pod`,
  SEE_MORE_PAGE: `See More page extension for existing layout elements`,
  RETAILER_MULTI_USER_MANAGEMENT: `Retailer users management`,
  RETAILER_TEAM_SHARING: `Retailer team item sharing`,
  SEASONAL_CATEGORIES: `Seasonal Categories`,
  IMPERSONATION: `Impersonation`,
  SECURITY: `Security`,
  SENTRY: undefined,
  SEO: `SEO`,
  SESSIONS: `Session`,
  SETTINGS: `Setting Framework`,
  SHIPMENTS: undefined,
  SHIPPING: `Shipping`,
  SHIPPING_SERVICE_EXTRACTION: `Shipping Service`,
  STATE_MACHINES: `Internal state machine framework`,
  ADDRESSES: `Addresses`,
  SHIPPING_INSURANCE: `Shipping Insurance`,
  COMMERCIAL_INVOICES: `Commercial Invoices`,
  TARIFF_CODES: `Tariff Codes`,
  SAPIENT: `Sapient tracking integration`,
  SHOPIFY_MAKERS: undefined,
  SIGNIN: `Signin`,
  SIGNUP: `Signup`,
  SLACK: `Slack API`,
  SLATE_DESIGN_SYSTEM: undefined,
  SLATE_CORE_COMPONENTS_LIBRARY: undefined,
  SLATE_FOUNDATIONS_LIBRARY: undefined,
  SLATE_TOOLS: undefined,
  BRAND_COMPONENTS_LIBRARY: `Brand Components Library`,
  RETAILER_COMPONENTS_LIBRARY: `Retailer Components Library`,
  SLATE_COMPONENTS: `Slate Components`,
  SLATE_ICONS: `Slate Icons`,
  SLATE_FOUNDATIONS: `Slate Foundations`,
  COMMUNITY_LIBRARY_COMPONENTS: `Community Library Components`,
  STORYBOOK_INFRA: `Storybook Infra`,
  DESIGN_PROTOTYPE_PLAYGROUND: `Design Prototype Playground`,
  ACCESSIBILITY_TOOLING: `Accessibility Tooling`,
  ICON_TOOLING: `Icon Tooling`,
  UI_LIBRARY_TOOLING: `UI Library Tooling`,
  SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: `Search Query Understanding and Retrieval Algorithm`,
  STRIPE: undefined,
  SUNCO: `SunCo chat integration`,
  SWATCHES: `Swatches`,
  SWITCHBOARD: `Switchboard`,
  TAKTILE: `Taktile`,
  TASKS: `Task`,
  FAIRE_TASK_MANAGER: `Faire Task Manager`,
  TAX_FORMS: `Tax Forms for brands`,
  TAXES: undefined,
  TAXONOMY: undefined,
  TERMS_OF_SERVICE: undefined,
  TEST: undefined,
  TESTIMONIALS: undefined,
  TIME_TURNER: `Time Turner`,
  TOP_BRAND: `Top Shop`,
  TOP_PRODUCTS: `Top Products`,
  TRADESHOW: undefined,
  UNIVERSAL_FEEDBACK_TOOL: `Universal Feedback Tool`,
  UPMARKET: undefined,
  UPMARKET_EXPERIENCE: undefined,
  USER_INVITATION: `User invitation`,
  USERS: `User Management`,
  VALIDATION: `Validation`,
  VIDEOS: undefined,
  VISITORS: `web-visitor React App`,
  VS_CODE_EXTENSION: `VS Code Extension`,
  WAITLISTED_SIGNUP: `Waitlisted signup`,
  WAREHOUSE_TOOLING: `Warehouse Tooling`,
  WEB_DOCS_SITE: `Web Docs Site`,
  WEB_RETAILER_SERVER: `Web Retailer Server`,
  WEB_SERVER_SIDE_RENDERING: `Server-side rendering`,
  WEBSERVER: `Web Server`,
  XLSX_IMPORT: undefined,
  XLSX_ONBOARDING_IMPORT: undefined,
  ZIP_CODE_PROTECTION: undefined,
  RETAILER_TEAM_MANAGEMENT: undefined,
  BRAND_INCREMENTALITY: undefined,
  ZENDESK: `Zendesk`,
  MOBILE_PERFORMANCE_MONITORING_INFRASTRUCTURE: undefined,
  ADS: undefined,
  ADS_MANAGER: undefined,
  LOCAL_FILTERS_AND_MERCHANDISING: undefined,
  RECOGNIZABLE_BRANDS: `Recognizable Brands`,
  LOGGED_OUT_RETAILERS: `Logged Out Retailers`,
  WEB_BRAND_SERVER: `Web Brand Server`,
  WEB_BRAND_NEXTJS: `Web Brand NextJS`,
  FINANCIAL_EVENTS: `Financial Events`,
  WEB_PROXY: `Web Proxy service`,
  RETAILER_PROFILE_INFO: `Retailer Profile Info`,
  SHIPPING_RESTRICTION: `Retailer Shipping Restriction`,
  RECOMMENDATIONS_INFRASTRUCTURE: `Recommendations Infrastructure`,
  DISCOVERY_RECOMMENDATIONS: `Discovery Recommendations`,
  BRAND_PAGE: `Brand page`,
  PRODUCT_PAGE: `Product page`,
  PRODUCT_PAGE_MINISHOP_AND_RECOMMENDATIONS: `Product page minishop & recommendations`,
  PRODUCT_PAGE_PRODUCT_DETAILS: `Product page product details`,
  PRODUCT_PAGE_REVIEWS: `Product page reviews`,
  FONOA: `Fonoa third-party vendor integration`,
  MOBILE_CORE: `Mobile Core Infrastructure`,
  RETAILER_STORE_MANAGEMENT: `Retailer store management`,
  COMMISSION_UPDATE_REQUESTS: `Commission update requests`,
  SCIM: `SCIM User Management`,
  INTERNAL_API_SALESFORCE: `Internal API support for Salesforce`,
  INTERNAL_API_CATALOGS_MIGRATION: `Internal API support for Catalogs Migration`,
  INTERNAL_API_RETAILER_SHOPIFY_INTEGRATION: `Internal API support for the embedded Retailer Shopify App`,
  INTERNAL_API_INVENTORY: `Internal API support for Inventory`,
  INTERNAL_API_ORDERS: `Internal API support for orders`,
  FAIRE_FOR_TEAMS: `Faire for Teams`,
  MULTI_BRAND: `Multi Brand`,
  ALERT_BANNERS_BRAND: `Alert Banners Brand`,
  ALERT_BANNERS_RETAILERS: `Alert Banners Retailer`,
  ISSUE_REPORT_CLAWBACKS: `Clawback for brands`,
  RETURN_CLAWBACKS: `Clawback for retailers`,
  CANONICAL_DATA: `Canonical Data Model & ETLs`,
  FINACIAL_DATA_PLATFORM: `Financial Data Platform`,
  DATA_SECURITY: `Data Security & Compliance`,
  DATA_WAREHOUSE: `Snowflake`,
  DATA_AIRFLOW: `Airflow`,
  DATA_FAIREFLOW: `Faireflow`,
  DATA_SQL_VALIDATION_DAG: `SQL Validation DAG`,
  DATA_FIVETRAN: `Fivetran`,
  DATA_LOOKER: `Looker`,
  DATA_MODE: `Mode`,
  DATA_SELECTSTAR: `SelectStar`,
  DATA_FAIRE_COM: `data.faire.com`,
  DATA_MESH: `Data Mesh`,
  DATA_ENV: `Data Environments (Staging, Pre-release, PROD)`,
  STREAM_PROCESSING: `Stream Processing (Ververica, Flink)`,
  DATA_AWS: `Data AWS (S3, EC2, etc.)`,
  DATA_CONTRACTS: `Data Contracts`,
  RETAILER_UNIVERSE: `Retailer Universe`,
  KG_SCRAPE: `KG Scraping`,
  KG_MATCH: `KG Matching`,
  XP_METRICS: `Experiment Metrics`,
  FEATURE_STORE: `Feature Store & DSL`,
  MODEL_STORE: `Model Store (CometML)`,
  INFERENCE_SERVICE: `Inference Service`,
  ML_OBSERVABILITY: `ML Observability`,
  OBSERVABILITY: `Observability`,
  ORACLE_CLOUD: `Oracle Cloud GPU Cluster`,
  OCI_GPU_CLUSTER_INFRA: `Oracle Cloud GPU Cluster Infra`,
  ML_TRAINING: `ML Model Training Framework`,
  INTERNAL_API_PRODUCTS: `Internal API support for Products`,
  INTERNAL_API_IMAGES: `Internal API support for Images`,
  BACKEND_TEST_INFRA: `Backend Test Infra`,
  CATALOGS_SERVICE: `Catalogs Service`,
  BRAND_TERMS_OF_SERVICE: `Brand Terms of Service`,
  RETAILER_NOTIFICATIONS: `Retailer Notifications`,
  PHOENIX: `Mobile Phoenix Architecture`,
  MOBILE_APP_BUILD_INFRASTRUCTURE: `Mobile Build Infrastructure`,
  MOBILE_APP_SETTINGS: `Mobile App Settings`,
  MOBILE_APP_STARTUP: `Mobile App Startup`,
  PRODUCT_MESSAGING: `Product Messaging`,
  PERSONALIZATION: `Personalization`,
  CUSTOM_ARRANGEMENT: `Custom Arrangement`,
  RUNWAY: `Runway Client`,
  CONVERSATIONAL_SEARCH: `Conversational Search`,
  RETAILER_ADDRESS_MANAGEMENT: `Retailer Address Management`,
  RETAILER_BACKORDERS: `Retailer Backorders`,
  DIGEST_PAGE: `The Digest or 'Weekly Drop' Page`,
  PAGE_DATA_APIS: `Page data APIs`,
  MOBILE_CI: `Mobile CI`,
  CSV_EXPORT: undefined,
  PAID_MARKETING: `MarTech`,
  BRAND_MESSENGER: `Brand Messenger`,
  RETAILER_MESSENGER: `Retailer Messenger`,
  MESSENGER_INFRASTRUCTURE: `messenger infrastructure`,
  RETAILER_AUTHORIZATION: `Retailer Authorization`,
  SHOP_LOCAL: `Shop Local`,
  CONFIG_VARS: `Config Vars`,
  CACHING: `Caching`,
  SIDE_CART: `Side Cart`,
  UNLISTED_PRODUCTS: `Unlisted Products`,
  FAIRE_PAY: `Faire Pay`,
  FULFILLED_BY_FAIRE: `Fulfilled by Faire`,
  SHIPBOB: `ShipBob`,
  FULFILLMENT_INBOUND: `Fulfillment Inbound`,
  FAIRE_SOURCE: `Faire Source`,
  FAIRE_SOURCE_BUY_IT_AGAIN: `Faire Source Buy It Again`,
  HOME_RETAILER_SERVICE: `Home retailer Service`,
  ADMIN_SERVER: `Admin Server`,
  PETE_SERVER: `Pete Server`,
  VOLUME_BASED_DISCOUNTS: `Volume Based Discounts`,
  CI_CD: `CI`,
  PRODUCT_BUNDLES: `Product Bundles`,
  CUSTOMER_FEEDBACK: `Customer Feedback`,
  MISSION_CONTROL: `Mission Control`,
  MOBILE_WARDROBE: `Mobile Wardrobe`,
  SINGLE_SIGN_ON: `Single Sign On (SSO)`,
  SDUI: `SDUI (Server-Driven UI)`,
  EPPO: `Eppo`,
  VISITOR_APP: `Visitor App`,
  VISITOR_SERVER: `Visitor Server`,
  PURCHASE_ORDER_INGESTION: undefined,
  HELP_CENTER_NEXT_JS: `Help Center NextJS`,
  IMPRESSION_LOGGING: `Impression Logging`,
  RETAILER_BRAND_CONSOLIDATION: `Retailer Brand Consolidation`,
  PINECONE: `Pinecone`,
  BRANDS_SERVICE: `Brands Service`,
  BRANDS_SERVICE_MIGRATION: `Brands Service Migration`,
  CART_CHECKOUT_IMPROVEMENT: `Cart Checkout Improvement`,
  PRODUCT_LISTING_QUALITY: undefined,
  PRODUCT_DELISTING: `Product Delisting`,
  PRODUCT_EDITOR: `Product Editor`,
  ORDERS_MIGRATION: `Orders service migration`,
  RETAILER_ACCOUNT_MANAGEMENT: `Retailer Account Management`,
  OWNED_TOKENS: `Owned Tokens`,
  INSIGHTS_UPDATES_HUB: `Insights Updates Hub`,
  WEB_BRIDGE: `Web Bridge`,
  BRAND_SHOPIFY_ADMIN: `Brand Shopify Admin`,
  VIRTUAL_ASSISTANT: `Virtual Assistant`,
  TERRAFORM_TOOLING: `Terraform Tooling`,
  K8S_CLUSTERS: `Kubernetes Cluster Management`,
  NETWORKING: `Networking`,
  AWS_COSTS: `AWS Cost Attribution`,
  DNS: `DNS`,
  CDN: `CDN`,
  OBJECT_STORAGE: `Object Storage`,
  ONCALL_TOOLS: `On-call Tooling`,
  DISASTER_RECOVERY: `Disaster Recovery`,
  SERVICE_MESH: `Service Mesh`,
  GAMEDAYS: `Game Day Tooling`,
  REMOTE_DEV: `Engineering Remote Dev`,
  MESSENGER_USER_CONFIGURATIONS: `Messenger User Configurations`,
  ADMIN_LAYOUT: `Admin Layout`,
  RETAILER_VETTING: `Retailer Vetting`,
  RETAILER_OFF_FAIRE_MATCH: `Retailer Off-Faire Match`,
  TEMPORAL: `Temporal`,
  GROW_WITH_FAIRE: `Grow with faire`,
  MARKET_HUB: `Market Hub`,
  MARKET_PROMOTIONS: `Market Promotions`,
  QUALITY_TOOLING: `Quality Tooling`,
  TEST_INFRA: `Test Infrastructure`,
  ONBOARDING_PROJECT: `Onboarding Project`,
  SAMURAI: `SAMURAI`,
  FAIRE_FUNDS_TRIAGE: `Faire Funds Triage`,
  BRAND_SALES_REP_ATTRIBUTION: `Brand sales rep attribution`,
  NEXTJS_INFRASTRUCTURE: `Next.js Infrastructure`,
  QUICKBOOKS_ACCOUNTING_SYNC: `QuickBooks Accounting Sync`,
  APP_MODAL_FRAMEWORK: `App Modal Framework`,
  SIGNUP_FLOW: `Signup Flow`,
  SIGNUP_MODAL: `Signup Modal`,
  R2B_REQUEST_TO_SHOP: `R2B Request to Shop`,
  RETAILER_ACTIVATION_CHECKLIST: `Retailer Activation Checklist`,
  REVENUE_TEAM: `Revenue Team`,
  TRENDS: `Trends and Faire Forecast pages`,
  MESSENGER_EMOJI_AND_MESSAGE_REACTION: `Messenger emoji and message reaction`,
  PORTKEY: `Portkey Integration`,
  UPMARKET_PLUS: `Upmarket Plus`,
  FAIREADMIN_ACCESS: `FaireAdmin Access`,
  SHOPIFY_EMAIL_RELAY: `Shopify Email Relay`,
  EXTERNAL_API_PRODUCT_PRICES: `External API - Product Prices`,
  BRAND_PAGE_HEADER: `Brand Page Header`,
  BRAND_PAGE_PRODUCT_GRID: `Brand Page Product Grid`,
  BRAND_PAGE_RECOMMENDATIONS: `Brand Page Recommendations`,
  BRAND_PAGE_BRAND_REVIEWS: `Brand Page Brand Reviews`,
  FAIRE_PLUS: `Faire Plus`,
  PRODUCT_PURCHASABILITY: `Product Purchasability`,
  REORDER_HUB: `Reorder Hub`,
  MESSAGE_TEMPLATES: `Message Templates`,
  DATAFOLD: `Datafold`,
  ANOMALO: `Anomalo`,
  RETAILER_HEADER: `Retailer Header`,
  EXTERNAL_API_AUTH: `External API Auth`,
  IMAGE_CORRECTNESS_AND_CONSISTENCY: `Image Correctness and Consistency`,
  IMAGE_QUALITY_AND_GOVERNANCE: `Image Quality and Governance`,
  PRODUCT_IMAGES: `Product Images`,
  IMAGE_PLATFORM_INFRASTRUCTURE: `Image Platform Infrastructure`,
  PRODUCT_IMAGE_CORRECTNESS_AND_CONSISTENCY: `Product Image Correctness and Consistency`,
  PRODUCT_IMAGE_MANAGEMENT: `Product Image Management`,
  WORKATO: `Workato`,
  FUNCTIONAL_STAGE: `Functional Stage`,
  FORMULA_DSL: `Formula DSL`,
  FINANCIAL_INVOICE: `Financial Invoice`,
  BRAND_STORIES: `Brand Stories`,
  SECURITY_UTILITIES: `Security Utilities`,
  INPUT_SANITIZATION: `Input Sanitization`,
  BOT_DEFENSE: `Bot Defense`,
  SECURITY_AUDIT_LOGGING: `Security Audit Logging`,
  WRITE_MODE_ENFORCEMENT: `Write Mode Enforcement`,
  SECRET_MANAGEMENT: `Secret Management`,
  FAIRE_SOURCE_SHOP_PAGE: `Faire Source Shop Page`,
  POSTHOG: `PostHog`,
  SEARCH_BAR: `Search Bar`,
  SEARCH_SUGGESTIONS_EMPTY_STATE: `Search Suggestions Empty State`,
  BRAND_PAGE_SEARCH: `Brand Page Search`,
  AWS_INFRA: `AWS Infrastructure`,
  WEB_API: `Web API`,
  BRAND_FINANCING: `Brand Financing`,
  COMPLIANCE: `Compliance`,
  MARKDOWN_ALLOWANCES: `Markdown Allowances`,
  FSR_CONFIGURATION: `FSR Configuration`,
  SWARM_UI: `Swarm UI`,
  ANALYTICS_EVENTS: `Analytics Events`,
  BRAND_SHOPIFY_ORDER_FULFILLMENT_SYNC: `Brand Shopify Order Fulfillment Sync`,
  BRAND_BULK_FULFILLMENT_CSV: `Brand Bulk Fulfillment CSV`,
  BULK_UPLOAD_FRAMEWORK: `Bulk Upload Framework`,
  CUSTOMIZABLE_PRODUCTS: `Customizable Products`,
  SHOPIFY_BESTSELLER_NUDGE: `Shopify Bestseller Nudge`,
  FIREBASE: `Firebase`,
  AGENT_DOJO: `Agent Dojo`,
  TEST_DASHBOARD: `Test Dashboard`,
  FAIRESPACE: `Fairespace`,
  TEST_TRACKER: `Test Tracker`,
  QUIP: `Quip`,
  IT_IAM: `IT IAM`,
  DATA_IMPORTED_ENTITIES: `Data Imported Entities`,
  DETEKT: `Detekt`,
  FINANCIAL_INVOICE_SETTLEMENTS: `Financial Invoice Settlements`,
};

export const getTitleForProductArea = (
  enumValue: ProductArea | keyof typeof ProductArea
): string | undefined => {
  return titleForProductArea[enumValue];
};

const descriptionForProductArea: Partial<Record<ProductArea, string>> = {
  PRODUCT_AREA_UNKNOWN: undefined,
  ABOUT_US_PAGE: undefined,
  ADMIN: `Admin Authorization`,
  ADYEN: undefined,
  ADYEN_PAYOUT: `Adyen brand side integration (Adyen for Platforms)`,
  STRIPE_PAYOUT: `Stripe brand side integration (Stripe Connect platform)`,
  AFFILIATES: `Affiliate program run through Impact`,
  AI_BRIDGE: `AI Bridge is a service that provides an interface for executing ML models`,
  AI_TOOLS: `AI Tools a Burrito-wrapper powering FLARE, our in-house Python/LLM platform`,
  ALCOHOL: `Alcohol sales, category restrictions related to alcohol`,
  ALERT_BANNERS: `Alert banners for brands and retailers`,
  AMEX: `AMEX sign up offer landing page`,
  ANTI_ABUSE: undefined,
  API_PERFORMANCE: `Api Performance and Metrics`,
  APPAREL_BRAND: undefined,
  APPAREL_COLLECTIONS: `Apparel Collections are Product Based Collections catered for Apparel Brands`,
  CORE_COLLECTIONS: `Core Product Based Collections are Product Based Collections catered for Non-Apparel Brands and Retailers`,
  COLLECTIONS_RETAILER_DISPLAY: `Retailer-facing display logic for Product Based Collections`,
  APPAREL_DISCOVERY: undefined,
  APPDASH: `Internal tool for managing multiservices. Contains Goose.`,
  ATELIER_FAIRE: `Specific to the L'Atelier Faire event`,
  AUTH: `User authentication.`,
  AUTOBOTS_FRAMEWORK: `Autobots framework: tooling and infrastructure owned by the Client Foundations team.`,
  AUTOPILOT: `Set of AI-driven automations that handle routine pull request tasks`,
  MFA: `Anything that has to do with multi-factor authentication or login codes.`,
  AWS_SAGEMAKER: `Build, train, and deploy machine learning models`,
  B2B_REFERRALS: undefined,
  BACKEND_DRIVEN_MESSAGING_CONTAINERS: `Framework for backend-controlled UI messaging components and dynamic frontend content delivery.`,
  BACKFILA: `Internal tool for running backfills, large-scale data migration or update operations on database records`,
  BADGES: undefined,
  BLOG_GATED_CONTENT: `Gated content that requires a brand to register, typically linked to from the Faire blog`,
  BOARDS: undefined,
  BRAND_ACCOUNT_SETTINGS: `Settings and features related to a brand's account`,
  BRAND_ACQUISITION: `Areas related to acquiring brands`,
  BRAND_ANALYTICS: undefined,
  PRODUCT_SALES_REPORT: `Areas related to the product sales report related analytics`,
  BRAND_ANNOUNCEMENTS: undefined,
  BRAND_APP: undefined,
  BRAND_CATALOG_COMPLETENESS: `Areas related to the completeness of the brand's catalog`,
  BRAND_CORE: `Core brand resources that cannot be assigned to a more specific product area`,
  BRAND_CRM: undefined,
  BRAND_CUSTOMER_ENGAGEMENT_SURVEY: undefined,
  BRAND_DAILY_DIGEST: undefined,
  BRAND_EMAIL_PREFERENCES: undefined,
  BRAND_F14D_DISCOUNTS: undefined,
  BRAND_FRAUD: `This feature allows us to check if a brand is a good quality brand and not fraudulent during the brand onboarding process.`,
  BRAND_HYPE_MAP: undefined,
  BRAND_INTEGRATIONS: `Third-party brand integrations connecting brands' business tools to Faire (e.g. WooCommerce, ShipStation, QuickBooks). Does not include Shopify; Shopify ownership is split across focused product areas such as Brand Shopify Setup.`,
  BRAND_INVOICES: undefined,
  BRAND_LEADS: undefined,
  BRAND_LISTING_QUALITY: undefined,
  BRAND_LOYALTY: `Features related to brand loyalty programs such as Faire Direct Rewards and Top Shop. Faire Direct Rewards loyalty program has ended, therefore new work should be done in Top Shop.`,
  BRAND_MARKETING_CAMPAIGNS: undefined,
  BRAND_MARKETPLACE: undefined,
  BRAND_MARKETPLACE_HOMEPAGE: undefined,
  BRAND_MCP: `MCP server and tools that let brands interact with Faire through AI agents`,
  BRAND_MOBILE: undefined,
  BRAND_MULTI_USER_MANAGEMENT: undefined,
  BRAND_NUDGES: undefined,
  BRAND_ACTIVATION: `Areas related to activating a new brand after the brand onboarded. Includes initial catalog setup`,
  BRAND_ONBOARDING: `Areas related to onboarding new brands to the Faire platform. Includes application form and initial account setup (e.g. description of the brand and shop images). Does not include catalog setup.`,
  BRAND_ORDERS: undefined,
  BRAND_PAYOUT_CALCULATION: `Calculating Payouts to brands.`,
  BRAND_NOTIFICATIONS_CENTRE: `The brand portal notifications centre`,
  BRAND_PAYOUTS: `Payouts to brands (only payout creation/initiation without payout infrastructure)`,
  BRAND_PORTAL_HOMEPAGE: `Components of the brand portal homepage`,
  BRAND_PORTAL_SEARCH: `Brand portal products search`,
  BRAND_PORTAL_NAVIGATION: undefined,
  BRAND_PORTAL_PRODUCTS_PAGE: `The brand-facing products page in brand portal (/brand-portal/my-shop/products) — action cards, filter chips, side-panel filters, and the products table`,
  BRAND_PREVIEW: `AKA View My Shop. Allows brands to see their own brand page`,
  BRAND_PRICING: `Pricing of products on Faire. This includes MSRP, Wholesale price, and any pricing rules that apply to products listed by brands on the Faire platform.`,
  BRAND_PRODUCT_SEARCH_SUGGESTIONS: `The suggested search queries that appear when a retailer types search requests on the brand page`,
  BRAND_PRODUCT_TAGS: `Custom product tags that brands assign to products in Brand Portal and via catalogs APIs`,
  BRAND_PROMOS: undefined,
  BRAND_PROSPECTING: undefined,
  BRAND_RESTRICTIONS: `Allows brands to choose the countries from which retailers can buy their products`,
  BRAND_REVIEWS: `Brand-level reviews and ratings from retailers. This feature covers the collection, display, and management of reviews for brands on the Faire platform.`,
  BRAND_SAFETY: `Brand Safety features that ensure a trustworthy marketplace for retailers and brands. This includes mechanisms to detect and prevent counterfeit products, products containing sensitive content, and maintain high standards for brand quality.`,
  BRAND_SEARCH: `Searching for brands on Faire (not a brand's products)`,
  BRAND_SHOP_CURRENCY: `Logic that allows brands to view the brand portal in currencies other than USD`,
  BRAND_SHOP_PAGE: undefined,
  BRAND_SHOP_SETTINGS: undefined,
  PRODUCT_GEO_AVAILABILITY: `Enables brands to set the country availability of their products`,
  BRAND_SHOPIFY_INTEGRATION: `Deprecated, use a more specific product area.`,
  BRAND_SHOPIFY_CATALOG_SYNC: `Shopify catalog management for the brand Shopify integration`,
  BRAND_SHOPIFY_PRODUCT_IMPORT: `Product import for the brand Shopify integration`,
  BRAND_SHOPIFY_VARIANT_IMPORT: `Variant import for the brand Shopify integration`,
  BRAND_SHOPIFY_PRODUCT_LINKING: `Product linking (manual or automatic) for the brand Shopify integration`,
  BRAND_SHOPIFY_PRODUCT_STATUS_SYNC: `Product status sync for the brand Shopify integration`,
  BRAND_SHOPIFY_DATA_REPLICATION: `Faire and Shopify data replication for the brand Shopify integration`,
  BRAND_SHOPIFY_PERFORMANCE_TRACKING: `Shopify product performance tracking for the brand Shopify integration`,
  BRAND_SHOPIFY_OTHER: `Other functionality from the brand Shopify integration not covered by specific product areas`,
  BRAND_SHOPIFY_METAFIELDS_SYNC: `Shopify metafields sync for the brand Shopify integration`,
  BRAND_SHOPIFY_CONTENT_SYNC: `Product content sync for the brand Shopify integration`,
  BRAND_SHOPIFY_HOME: `Homepage on Shopify for the brand Shopify integration, such as banners, home resources, link summaries`,
  BRAND_SHOPIFY_INVENTORY_SYNC: `Shopify inventory sync for the brand Shopify integration`,
  BRAND_SHOPIFY_ORDER_SYNC: `Shopify order sync for the brand Shopify integration`,
  BRAND_SHOPIFY_PREFERENCES: `Managing preferences for the brand Shopify integration`,
  BRAND_SHOPIFY_PRICE_SYNC: `Product price syncing from Shopify to Faire`,
  BRAND_SHOPIFY_SALES_CHANNEL_MIGRATION: `Migrating brands from the old brand integration to the Sales Channel one`,
  BRAND_SHOPIFY_SETUP: `Installation and setup of the brand Shopify integration`,
  RETAILER_SHOPIFY_APP: `Changes limited to the embedded retailer Shopify app. Actual features of the retailer integration (e.g, syncing over ordered products) should use RETAILER_POS_INTEGRATIONS.`,
  BRAND_SLA: `Brand Service Level Agreement (SLA) features that help maintain high standards for brand performance on the Faire platform. This includes monitoring and enforcing SLAs related to order fulfillment, customer service, and overall brand reliability.`,
  BRAND_TAGS: undefined,
  BRAND_TILE: `Tile representation of a brand used on brand first results such as carousels recommending brands, brand first category results grid and brand first search results grid.`,
  BRAND_VERIFICATION: undefined,
  BRAND_WIDGET: `Faire Direct widgets that can be embedded on brand's own website`,
  BRANDS: `Deprecated, use a more specific product area.`,
  BRAZE: `Braze platform integration and infrastructure owned by the Growth Platform team.`,
  BRAZE_EMAILS: `Marketing email campaigns and templates owned by the Marketing Operations team.`,
  BROWSER_EXTENSION: `Faire Browser Extension (Chrome + Firefox)`,
  BUILDER_IO: `Builder.io integration`,
  BUY_IT_AGAIN: `Buy it again page or carousel`,
  BULK_ACTIONS: `Bulk action internal framework.`,
  BULK_PRODUCT_EDIT: `Brand bulk product edit tool`,
  BULK_PRODUCT_EXPORT: `Brand bulk product export tool`,
  BULK_PRODUCT_UPLOAD: `Brand bulk product upload tool`,
  CAPABILITIES: `User capabilities, teams and permissions.`,
  CARBON_NEUTRAL_RETAILER: undefined,
  CART: `Retailer cart`,
  CART_RECOMMENDATIONS: `Product recommendations to surface in a retailer's cart.`,
  CART_COLLABORATION: `Retailer cart collaborators and reviews.`,
  CATEGORIES: undefined,
  CATEGORY_PAGE_RECOMMENDATIONS: `Generate/show/hide category page layouts`,
  BROWSE_INFRASTRUCTURE: `Related to the infrastructure that powers Faire's browsing surfaces`,
  CATEGORY_RESULTS: `Category page search results`,
  CATEGORY_RESULTS_RANKING: `Ranking logic/rules for category page results`,
  CATALOGS_MIGRATION: undefined,
  CATALOG_VERIFICATION: `Verification of brand submitted catalogs for pricing and completeness`,
  CHAT_GPT_ENTERPRISE: `Enterprise solutions for Chat GPT`,
  CHECKOUT: `Checkout flow for retailers.`,
  CLAWBACKS: `Clawing back refunds given to retailers/brands as a result of return/issue cancellation`,
  CLIENT_EVENTS: `Tools related to our client event analytics or PETE`,
  CLIENT_HEALTH_TOOL: `Tool to allow pillars and pods to view client health metrics`,
  COCKROACH_DB: `Migration of MySQL database to Cockroach DB`,
  COLLECTIONS: `DEPRECATED. Use either PREPACKS or CORE_COLLECTIONS.`,
  COMMISSIONS: `DEPRECATED. Use BRAND_ORDERS for order commission display/calculation, BRAND_PAYOUTS or BRAND_PAYOUT_CALCULATION for payout commission amounts, BRAND_ONBOARDING for special deal commission rates, or COMMISSION_UPDATE_REQUESTS for brand commission update requests.`,
  COMMS_PLANNER: `Anything related to outgoing communication planner`,
  CONDUCTOR: `The Conductor UI Orchestration System (Docs to be added)`,
  CONSUMER: `DEPRECATED. Neighborhood, Faire's, direct-to-consumer marketplace.`,
  CSV_IMPORT: undefined,
  CURRENCY_CONVERSION: `Logic for converting monetary amounts between currencies`,
  CX_CUSTOMER_QUEUES: `Various customer queues used by CX to handle incoming tickets`,
  CX_FOUNDATIONS: `Core customer experience infrastructure and tooling for support operations and ticket management`,
  RETAILER_FIRST_ORDER_INCENTIVE: `Area to manage first order incentives for retailers.`,
  RETAILER_ACTIVATION_INCENTIVES: `Area to manage every incentive of the Retailer Activation pod.`,
  CX_OPS: `Anything related to CX operations, zendesk etc`,
  DATA_ATLAS: undefined,
  DATA_FACTORY: `Data Science data sets loading and management.`,
  DATA_LAKE: undefined,
  DATA_LOOKUP: undefined,
  DATABASE: `Relational database persistence. Core infrastructure.`,
  DATABASE_EXPLORER: `Tool to explorer our DB https://www.faire.com/admin2/eng/db-explorer`,
  DELAYER: `Delayed jobs management`,
  DRAFT_ORDERS: undefined,
  RETAILER_DRAFT_ORDERS: `Draft orders (brand invoices) feature allowing retailers to view and manage pre-order quotes from brands on the orders page.`,
  DUTIES: `Customs duties and tax calculations for international shipments and cross-border commerce.`,
  E2E: `E2E Infrastructure and framework (Playwright, Auto-revert, Stability Automation)`,
  ECO_FRIENDLY: `Sustainability Hub and Eco-friendly brand tags and product attributes`,
  EDGE_INFRA: `Core infrastructure and framework running on the edge network`,
  EDIT_ORDERS: undefined,
  EMAIL_INFRA: `Infrastructure related to emails`,
  ERROR_RATE_TRIAGE: `Triage product area used for PR bot to assign DD monitor error tickets to correct pod.`,
  EVENTS: `Event producer and consumer core framework.`,
  EXCLUSIVITY: `Exclusivity feature for Retailers and Brands.`,
  EXPERIMENTS: `Tooling for running experiments (Eppo)`,
  EXPERIMENT_PLATFORM: `Experiment Platform`,
  EXPIRED_SETTINGS_CLEANUP: `Product Area for PR Bot to assign Expired Settings Jira tickets`,
  EXTERNAL_APIS: `DEPRECATED: Use \`EXERNAL_API_XXX\` instead for specific features`,
  EXTERNAL_API_BRANDS: `External API support for Brand functionality`,
  EXTERNAL_API_CORE: `External API core shared functionality, e.g. ratelimiters`,
  EXTERNAL_API_BRAND_PROMOS: `External API support for Brand Promotions functionality`,
  EXTERNAL_API_ORDERS: `External API support for Orders functionality`,
  EXTERNAL_API_OAUTH: `External Api OAuth for installing apps for brands via OAuth protocol`,
  EXTERNAL_API_MCP_OAUTH: `OAuth 2.1 consent grants for Brand MCP clients`,
  EXTERNAL_API_PARTNERSHIPS: `External API support for partnerships functionality`,
  EXTERNAL_API_PRODUCTS: `External API support for Product model functionality`,
  EXTERNAL_API_PREPACKS: `External API support for Prepack functionality`,
  EXTERNAL_API_PRODUCT_INVENTORY: `External API support for product inventory functionality`,
  EXTERNAL_API_RETAILERS: `External API support for retailers functionality`,
  EXTERNAL_API_TAXONOMY: `External API support for product taxonomy functionality`,
  EXTERNAL_API_PRODUCT_REVIEWS: `External API support for Product Reviews functionality`,
  EXTERNAL_DEVELOPER: undefined,
  FAIREY: `Fairey chatbot infrastructure, such as integrations and prompt factories.`,
  FAIRE_CLI: `Faire CLI, for various command-line utilities.`,
  FAIRE_CONTENT: undefined,
  FAIRE_DIRECT: `Faire Direct, Faire's brand to retailer referral program`,
  FAIRE_DIRECT_ADOPTION_EMAIL: `Email series to brands to encourage them to set up Faire Direct`,
  FAIRE_DIRECT_APP: `iPad App for brands to write invoices for retailers at trade shows`,
  FAIRE_DIRECT_RETAILERS: `Area specific to Faire Direct retailers`,
  FAIRE_DIRECT_REWARDS: `Incentives for brands to use Faire Direct`,
  FAIRE_DIRECT_REWARDS_LIFECYCLE_EMAIL: `Emails sent to brands about their Faire Direct Rewards status`,
  FAIRE_DIRECT_TRIGGER_EMAIL: `Transactional email triggers for emails sent to brands about adopting Faire Direct`,
  FAIRE_FOLK_HUB: `Shut down due to lack of an owner.`,
  FAIRE_SOCIAL_PROOF: `Fetching and returning TrustPilot information`,
  FAIRE_SPACES: undefined,
  RETAILER_POS_INTEGRATIONS: `Product matching and catalog management features for retailer POS integrations.`,
  FAIRESYNC: `Retailer POS integration platform enabling two-way synchronization of products, orders, and inventory between Faire and external POS systems.`,
  FAIRESYNC_INTEGRATION_CLOVER: `Clover-specific retailer POS integration implementation including OAuth authentication, webhook handling, and data synchronization.`,
  FAIRESYNC_INTEGRATION_SHOPIFY: undefined,
  FAIRESYNC_INTEGRATION_SQUARE: `Square-specific retailer POS integration implementation including OAuth authentication, inventory management, and catalog synchronization.`,
  FAIRESYNC_INTEGRATION_LIGHTSPEED: `Lightspeed specific retailer POS integration implementation including OAuth authentication, inventory management, and catalog synchronization.`,
  FAIRESYNC_INTEGRATION_QUICKBOOKS: `We never launched this brand integration with Quickbooks and we removed all its code`,
  FAIREWORKS: undefined,
  FASHION_WEEK: undefined,
  FILTERS: `Retailer facing filters used to narrow down results across pages`,
  FLASH_SALES: `Time-limited promotional sales featuring products that have been returned by retailers`,
  FOOD_AND_BEVERAGE: undefined,
  FRONTEND_APIS: undefined,
  FRONTEND_TOOLING: `Frontend tooling that doesn't have a more specific ProductArea`,
  FULLSTORY_CONFIG: undefined,
  GITHUB: `GitHub integration and workflows`,
  GMAIL: undefined,
  GOOSE: `Goose is a service for managing sql migrations and queries. It is a replacement for Shift.`,
  GUARANTEED_VOLUME: undefined,
  HACK_WEEK: undefined,
  HELP_CENTER: `General FAQ/support resources`,
  HOME_FEED: `Retailer homepage on web and home feed on mobile`,
  TRANSLATIONS: `Backend infrastructure and tooling supporting translation requests`,
  HUBSPOT: undefined,
  IDV: `Identity verification system for validating business and retailer identities`,
  IMAGES: undefined,
  INALYTICS: `Intake of client analytics events.`,
  INCENTIVES: `Faire offered incentives for retailers`,
  INFRA: `AWS infrastructure, platform frameworks, and multi-region platform support.`,
  INFERENCE: undefined,
  INSIDER: `Faire's membership program offering benefits such as free shipping.`,
  INSTRUMENTS: `Payment instruments used to make payments.`,
  INTERNAL_API: `DEPRECATED: Use \`INTERNAL_API_XXX\` instead for specific features`,
  INVENTORY: undefined,
  ISSUE_REPORTS: undefined,
  JOBS: `Job producer and consumer core framework.`,
  KITCHEN_SINK: `All of our core components in one place.`,
  KNOWLEDGE_GRAPH: `A KG containing all the information we have on our retailers, brands, and products.`,
  LAIKA: `A custom lucene-backed search engine`,
  LAUNCH_WITH_FAIRE: `Deprecated - use OPEN_WITH_FAIRE product area instead`,
  LATENCY_TRIAGE: `Triage product area used for PR bot to assign DD monitor latency tickets to correct pod.`,
  LEGAL_DOCUMENTS: undefined,
  STAGING: undefined,
  LIVE_STREAMS: undefined,
  LLM: undefined,
  LLM_OPERATIONS: `Operations related to Large Language Models`,
  LOCALIZATION: `This Product Area is no longer supported. Team should refer to Address, Currency and Translation infra.`,
  LOGGED_IN_HOMEPAGE: `Area specific to homepage for logged-in retailers`,
  MAKER_BUY_BACK: `Return resolution program allowing brands to repurchase returned inventory at a discounted rate`,
  MARKETS: `Faire Market events (e.g., Faire Summer Market, Faire Winter Market) including coordination for related promotions, advertising, and market specials`,
  MESSENGER: `User to user direct messaging.`,
  MESSENGER_CONTEXT_PANEL: `Related to the additional information (e.g. profile, orders) that a user can see on Messenger.`,
  MESSENGER_INLINE_CONTEXT: `Inline contextual information displayed within messenger conversations`,
  MILESTONES: `Fetching, saving, and removing milestones for user events`,
  MISPRICED_RESELLER: `Features that help identify and manage mispriced resellers on the Faire platform.`,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_IN: `The homepage on the retailer mobile apps, for logged in users`,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_OUT: `The homepage on the retailer mobile apps, for logged out users`,
  MOBILE_RETAILER_LOGGED_OUT: `The logged out experience on the retailer mobile apps`,
  MOBILE_RETAILER_MESSENGER: `Messenger feature within the retailer mobile apps`,
  MOBILE_RETAILER_ONBOARDING: `Onboarding experience in the retailer mobile apps`,
  MOBILE_RETAILER_SIGNUP: `Signup experience in the retailer mobile apps`,
  MY_BRANDS: undefined,
  ZENDESK_TRANSLATIONS: `This is deprecated. Refer to ZENDESK instead`,
  MYSQL: `Relational database persistence. Core infrastructure.`,
  NAVIGATION_INFRASTRUCTURE: undefined,
  NAVIGATION_TREE_UX: `How navigation nodes and category nodes (navigation tree) are displayed to users`,
  NET_TERMS: `Retailer terms management`,
  NEWSROOM: undefined,
  NEW_RETAILERS: `Admin feed of newly created retailers`,
  PARTNERSHIPS_PAGE: `Include pages like Amex and Square landing pages`,
  OMNISEARCH: `Tool to search across many entities in the database https://www.faire.com/admin2`,
  ONE_FAIRE_TEAM: `Features related to the one.faire.team hub for connecting with your co-workers.`,
  OPEN_SIZING: undefined,
  OPEN_WITH_FAIRE: `Relates to Open With Faire features, for logged-in retailers`,
  OPEN_WITH_FAIRE_LOGGED_OUT: `Relates to Open With Faire features, for logged-out retailers`,
  ORDER_SUBMISSION: `Retailer order placement flow including cart validation, order creation, payment processing, and order confirmation.`,
  ORDERS: undefined,
  PACKING_SLIP: undefined,
  PAYMENTS: `Payments from retailers and payments infrastructure.`,
  PDF_RENDERING: `Ensure international brands get first class experience viewing tax forms and commercial invoices.`,
  PERF_DARK_READ: `performance testing using dark reads.`,
  PICK_LIST: undefined,
  PLAID: undefined,
  POSTMARK: undefined,
  PR_BOT: `PR Bot NodeJS server, and Faire PR Bot GitHub App`,
  PREORDERS: undefined,
  PREPACKS: undefined,
  PRERELEASE: `Work related to the prerelease environment`,
  PRESTASHOP: `Brand acquisition landing page for Prestashop partnership`,
  PRICING: undefined,
  PRICING_PARITY: `Features that help identify prices of products outside Faire, and enforcement of Faire's pricing policies.`,
  PRIVACY: `Data privacy controls, GDPR compliance, and user data protection.`,
  PRODUCERS: undefined,
  PRODUCT_CHANGE_HISTORY: `Tracks and displays the history of changes made to product details to brands.`,
  PRODUCT_INFO: undefined,
  PRODUCT_PRICE_MATCH_GUARANTEE: `Product price match guarantee feature`,
  PRODUCT_REVIEWS: `Product reviews and ratings`,
  PRODUCT_SAMPLES: `Area for retailers to order samples for products. Deprecated, the new feature that is similar is SAMPLES`,
  PRODUCT_TILE: `Tile representation of products used in retailer results such as product recommendation carousels, product first category results grid, product first search results grid.`,
  PRODUCTS: undefined,
  PRODUCTS_API: `APIs for managing products`,
  PRODUCTS_PLATFORM: `Infrastructure that handles product related replication between catalogs and monolith`,
  PROMO_MODALS: `Modals for promotion`,
  PROMOTIONAL_EVENTS: `Events like Faire Summer Market or Faire Winter Market`,
  PROMO_CODES: `General infrastructure surrounding promotional codes to be used by retailers`,
  PURCHASE_ORDER: `Purchase order processing system for matching, validation, and ingestion of retailer purchase orders`,
  PUSH_NOTIFICATIONS: `Sending notification to mobile devices running Faire apps`,
  QUALTRICS: undefined,
  QUEUES: `Lists of cases worked through by ops teams to complete various business objectives.`,
  QUICK_ADD: `Retailer Quick Add modal and related add-to-cart flows from product tiles.`,
  R2B_REFERRALS: undefined,
  R2R_REFERRALS: undefined,
  RANKING: `Search Ranking Algorithms`,
  RECOMMENDATIONS: undefined,
  REDIS: `Redis and ElasticCache core infrastructure.`,
  RELEASE_TOOL: `Internal tool for managing deployments.`,
  REGIONAL_SEARCH: `Regional search for retailers.`,
  REORDER_UPDATES_HUB: `Area for retailers to see updates from previously ordered brands (AKA Retailer Brand Insights)`,
  RETAILER_ADVERTISING: `Sending data to platforms for advertising purposes such as facebook.`,
  RETAILER_BRAND_LOYALTY: `Area for benefits given to Retailers when ordering from brands they're loyal to`,
  RETAILER_BRANDS_MANAGEMENT: `Area for retailers to manager their relationships with brands`,
  RETAILER_FINDER_APP: undefined,
  RETAILER_INVOICES: undefined,
  RETAILER_LAYOUT_ELEMENTS: `Dynamic FE elements that allow BE to control frontend layout and content`,
  LAYOUT_SERVICE: `Service-specific infrastructure for layout service`,
  RETAILER_MARKETING: undefined,
  RETAILER_MOBILE: undefined,
  RETAILER_NUX: `Post-signup new user experience for retailers, including NUX product recommendations and signals.`,
  RETAILER_ONBOARDING: `Sign up and post sign up experiences for new retailers.`,
  RETAILER_ORDER_MANAGEMENT: `Area for retailers to manage their orders`,
  RETAILER_OWNER_TRANSFER: `Transferring account ownership of a retailer from one user to another within the same retailer.`,
  RETAILER_PORTAL: undefined,
  RETAILER_POS: undefined,
  RETAILER_REPORTING: undefined,
  RETAILER_SAVINGS: `Retailer-facing savings experiences (incentives, discounts, and related savings programs owned by the Retailer Activation team).`,
  RETAILER_SETTINGS_PAGE: `Account preferences, payment methods, and store configuration options for retailers`,
  RETAILER_STYLE_QUIZ: `Retailer style quiz and Google store type (GST) classification.`,
  CAREERS_PAGE: undefined,
  RETAILER_YEAR_IN_REVIEW: `Unique lookback at a retailer's past year`,
  RETAILERS: `Deprecated, use a more specific product area.`,
  RETAILER_CONVERSION: `Looks into converting inactive retailers into active ordering ones`,
  RETAILER_CORE: `Core retailer resources that cannot be assigned to a more specific product area`,
  RETURNS: `Return order management system handling return requests, assessments, inspections, and resolution workflows`,
  REVERSE_SYNCER: `Replay CockroachDB write back to MySQL`,
  RISK: `Deprecated; use a more fine-grained RISK_* product area instead`,
  RISK_OPS: `Risk Ops tools`,
  RISK_ASSESSMENT: `Data-driven risk assesment`,
  SALES_REPS: `Sales rep management and tracking`,
  SALESFORCE: undefined,
  SAMPLES: `Brand-facing samples. Built for Food and Beverage products and brands.`,
  SAMPLES_RETAILER: `The retailer side of the sampling feature. Retailers request samples from brands. See also SAMPLES.`,
  SPYGLASS: `Spyglass is a tool for searching and analyzing user-facing comms across different channels`,
  HELP_CENTER_INFRA: `Infrastructure components such as Next.js, testing frameworks (e.g., end-to-end testing), and monorepo management for the help center`,
  HELP_CENTER_PAGES: `All user-facing pages within the help center, including retailer/brand pages, search results pages, and topic and article pages`,
  HELP_CENTER_SELF_SERVE: `All pages related to self-service workflows, such as order selection and issue topic selection`,
  SANDBOX: undefined,
  SEARCH: `Retailer search results - layout in particular. This represents how search results are displayed to the user`,
  SEARCH_SUGGESTIONS: `The suggested search queries that appear when a retailer types search requests`,
  SEARCH_INFRASTRUCTURE: undefined,
  SEARCH_EXPERIENCE_ACCELERATOR: undefined,
  SEE_MORE_PAGE: undefined,
  RETAILER_MULTI_USER_MANAGEMENT: `Management (updating permission and subscription) of the multi users under a retailer`,
  RETAILER_TEAM_SHARING: `Sharing of shareable item with anonymous users via limited deep-links or established users via e-mail`,
  SEASONAL_CATEGORIES: undefined,
  IMPERSONATION: `User impersonation functionality for admin support and customer service.`,
  SECURITY: `Core security features, access controls, and security monitoring.`,
  SENTRY: undefined,
  SEO: `Pages/features introduced to drive up our SEO (Search Engine Optimization).`,
  SESSIONS: `User session management.`,
  SETTINGS: `Setting Framework (FSL)`,
  SHIPMENTS: `DEPRECATED: Replaced by SHIPPING product area for shipping functionality.`,
  SHIPPING: `Shipping of products.`,
  SHIPPING_SERVICE_EXTRACTION: `Related to the extraction of the shipping service.`,
  STATE_MACHINES: undefined,
  ADDRESSES: `Management of addresses`,
  SHIPPING_INSURANCE: `Insurance for shipped items`,
  COMMERCIAL_INVOICES: `Handling of commercial invoices`,
  TARIFF_CODES: `Management of tariff codes`,
  SAPIENT: `Integration with Sapient for Royalmail tracking`,
  SHOPIFY_MAKERS: undefined,
  SIGNIN: `faire.com signin`,
  SIGNUP: `faire.com signup`,
  SLACK: `Backend API for sending Slack notifications`,
  SLATE_DESIGN_SYSTEM: undefined,
  SLATE_CORE_COMPONENTS_LIBRARY: undefined,
  SLATE_FOUNDATIONS_LIBRARY: undefined,
  SLATE_TOOLS: undefined,
  BRAND_COMPONENTS_LIBRARY: undefined,
  RETAILER_COMPONENTS_LIBRARY: undefined,
  SLATE_COMPONENTS: undefined,
  SLATE_ICONS: `Icons from Slate Figma icon library (https://www.figma.com/design/qcB5qVN7uKBBYHN49ihDE7/Slate-Icons?node-id=10925-585)`,
  SLATE_FOUNDATIONS: `Slate color, dimensions (spacing, radius), and typography`,
  COMMUNITY_LIBRARY_COMPONENTS: undefined,
  STORYBOOK_INFRA: `Shared storybook infrastructure`,
  DESIGN_PROTOTYPE_PLAYGROUND: `Frontend playground for designers, allowing rapid prototyping with Slate and Community Library`,
  ACCESSIBILITY_TOOLING: `Tooling, scripts, and pipelines for automated accessibility testing & tracking`,
  ICON_TOOLING: `Shared icon related tooling for icons where Figma is source-of-truth`,
  UI_LIBRARY_TOOLING: `Shared tooling (coverage tracking, API alignment, automation) for Slate and Community Library`,
  SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: undefined,
  STRIPE: undefined,
  SUNCO: `Integration with Sunshine Conversations for the Help Center`,
  SWATCHES: `https://www.notion.so/faire/Swatches-f049024297c046c8aa122bc25c8214fc`,
  SWITCHBOARD: `Websocket management.`,
  TAKTILE: `Integration with 3rd party service Taktile`,
  TASKS: `Scheduled task execution core framework.`,
  FAIRE_TASK_MANAGER: `Internal tool for managing and coordinating task workflows.`,
  TAX_FORMS: undefined,
  TAXES: undefined,
  TAXONOMY: undefined,
  TERMS_OF_SERVICE: undefined,
  TEST: undefined,
  TESTIMONIALS: undefined,
  TIME_TURNER: `Tool to view changes in a database entity over time https://www.faire.com/admin2/records/time-turner`,
  TOP_BRAND: `Rewarding brands for great service with a Top Shop badge. Brands can earn Top Shop status by maintaining high ratings, low return rates, and excellent customer service.`,
  TOP_PRODUCTS: undefined,
  TRADESHOW: undefined,
  UNIVERSAL_FEEDBACK_TOOL: `Form for employees to submit feedback on internal tools`,
  UPMARKET: undefined,
  UPMARKET_EXPERIENCE: undefined,
  USER_INVITATION: `Feature for retailer admin to invite multiple users to the retailer`,
  USERS: `User account management and user data operations.`,
  VALIDATION: `Validation framework for enforcing data integrity and constraints`,
  VIDEOS: undefined,
  VISITORS: `General fallback for features pertaining to the web-visitor React App.`,
  VS_CODE_EXTENSION: `The Faire VS Code Extension`,
  WAITLISTED_SIGNUP: `Allows retailers in countries where we haven't launched to record their interest in joining Faire`,
  WAREHOUSE_TOOLING: `Internal tools and infrastructure for warehouse operations, fulfillment, and inventory management`,
  WEB_DOCS_SITE: `Faire Web Docs site for all frontend and slate documentation`,
  WEB_RETAILER_SERVER: `Node.js server for web-retailer. DEPRECATED: Migrating to Next.js infrastructure.`,
  WEB_SERVER_SIDE_RENDERING: `Server-side rendering for web front-end. DEPRECATED: Migrating to Next.js infrastructure.`,
  WEBSERVER: `Web server core infrastructure and framework.`,
  XLSX_IMPORT: undefined,
  XLSX_ONBOARDING_IMPORT: undefined,
  ZIP_CODE_PROTECTION: `DEPRECATED: Geographic exclusivity protection system, replaced by EXCLUSIVITY product area`,
  RETAILER_TEAM_MANAGEMENT: `Teams Page, checkout review and collaborator tracking on cart, orders, etc.`,
  BRAND_INCREMENTALITY: undefined,
  ZENDESK: `Zendesk integration for customer support ticketing, user management, and help center functionality`,
  MOBILE_PERFORMANCE_MONITORING_INFRASTRUCTURE: undefined,
  ADS: `Retailer-facing functionality for serving marketplace ads, a.k.a. Paid Placement or Promoted Listings`,
  ADS_MANAGER: `Brand experience for managing marketplace ads`,
  LOCAL_FILTERS_AND_MERCHANDISING: `Filters and merchandising to increase local supply in Europe`,
  RECOGNIZABLE_BRANDS: `Relate to Recognizable Brands model usage`,
  LOGGED_OUT_RETAILERS: `Logged out retailer experience`,
  WEB_BRAND_SERVER: `Node.js server for brand-portal`,
  WEB_BRAND_NEXTJS: `NextJS infrastructure and routing for brand-portal`,
  FINANCIAL_EVENTS: `Financial Events`,
  WEB_PROXY: `Web Proxy service`,
  RETAILER_PROFILE_INFO: `Related to keeping the retailer's profile information up to date`,
  SHIPPING_RESTRICTION: `Related to retailer restrictions to prevent certain products from being shipped to certain countries (e.g, can't ship cosmetics to Spain)`,
  RECOMMENDATIONS_INFRASTRUCTURE: `Related to the infrastructure that powers Faire's recommendations`,
  DISCOVERY_RECOMMENDATIONS: `Related to the general process of recommendation at Faire, across all discovery surfaces`,
  BRAND_PAGE: `Area specific to brand page for retailers`,
  PRODUCT_PAGE: `Area specific to product page for retailers`,
  PRODUCT_PAGE_MINISHOP_AND_RECOMMENDATIONS: `Product page section showing brand minishop and product recommendations`,
  PRODUCT_PAGE_PRODUCT_DETAILS: `Product page section showing product information, pricing, and attributes`,
  PRODUCT_PAGE_REVIEWS: `Product page section showing product reviews and ratings`,
  FONOA: `Integration with Fonoa for business identifier validations`,
  MOBILE_CORE: undefined,
  RETAILER_STORE_MANAGEMENT: `Features related to managing multiple stores within a retailer.`,
  COMMISSION_UPDATE_REQUESTS: `Features related to manage commission update requests from the brand`,
  SCIM: `Features related Scim integrations with Okta.`,
  INTERNAL_API_SALESFORCE: `Internal API support for Salesforce`,
  INTERNAL_API_CATALOGS_MIGRATION: `Internal API support for Catalogs Migration`,
  INTERNAL_API_RETAILER_SHOPIFY_INTEGRATION: `Internal API support for the embedded Retailer Shopify App`,
  INTERNAL_API_INVENTORY: `Internal API support for Inventory`,
  INTERNAL_API_ORDERS: `Internal API support for orders`,
  FAIRE_FOR_TEAMS: `Faire for teams is a feature that allows brands to manage multiple users within their organization.`,
  MULTI_BRAND: `Allows users to manage multiple brands.`,
  ALERT_BANNERS_BRAND: `Alert banners for brands`,
  ALERT_BANNERS_RETAILERS: `Alert banners for retailers`,
  ISSUE_REPORT_CLAWBACKS: `Clawback for brands`,
  RETURN_CLAWBACKS: `Clawback for retailers`,
  CANONICAL_DATA: `Canonical Data Model & ETLs`,
  FINACIAL_DATA_PLATFORM: `Financial Data Platform`,
  DATA_SECURITY: `Data Security & Compliance`,
  DATA_WAREHOUSE: `Data Warehouse (Snowflake)`,
  DATA_AIRFLOW: `Data Workflow Management (Airflow)`,
  DATA_FAIREFLOW: `Airflow utilities library (Operators, Hooks, Notifiers etc.)`,
  DATA_SQL_VALIDATION_DAG: `SQL validation airflow DAG`,
  DATA_FIVETRAN: `Data Movement (Fivetran)`,
  DATA_LOOKER: `Data Reporting (Looker)`,
  DATA_MODE: `Data Reporting (Mode)`,
  DATA_SELECTSTAR: `SelectStar`,
  DATA_FAIRE_COM: `data.faire.com`,
  DATA_MESH: `Data Mesh`,
  DATA_ENV: `Data Environments (Staging, Pre-release, PROD)`,
  STREAM_PROCESSING: `Stream Processing (Ververica, Flink)`,
  DATA_AWS: `Data AWS (S3, EC2, etc.)`,
  DATA_CONTRACTS: `Data Contracts`,
  RETAILER_UNIVERSE: `Retailer Universe`,
  KG_SCRAPE: `External Data Integration (web crawlers, 3rd party APIs)`,
  KG_MATCH: `NLP & Image-based Entity Matching`,
  XP_METRICS: `Experiment Metrics`,
  FEATURE_STORE: `Feature Store & DSL`,
  MODEL_STORE: `Model Store (CometML)`,
  INFERENCE_SERVICE: `ML Inference Service`,
  ML_OBSERVABILITY: `ML Observability`,
  OBSERVABILITY: `Observability`,
  ORACLE_CLOUD: `Oracle Cloud GPU Cluster`,
  OCI_GPU_CLUSTER_INFRA: `Oracle Cloud GPU Cluster Infra`,
  ML_TRAINING: `ML Model Training Framework`,
  INTERNAL_API_PRODUCTS: `Internal API support for Products`,
  INTERNAL_API_IMAGES: `Internal API support for Images`,
  BACKEND_TEST_INFRA: `Common test utilities for backend services`,
  CATALOGS_SERVICE: `Service-specific infrastructure for catalogs service`,
  BRAND_TERMS_OF_SERVICE: `Brand Terms of Service`,
  RETAILER_NOTIFICATIONS: `Retailer Notifications`,
  PHOENIX: `Mobile Phoenix architecture infrastructure`,
  MOBILE_APP_BUILD_INFRASTRUCTURE: `Build and CI infrastructure for mobile`,
  MOBILE_APP_SETTINGS: `Settings and experiment infrastructure for mobile`,
  MOBILE_APP_STARTUP: `Mobile app launch and initialization processes`,
  PRODUCT_MESSAGING: `Product messaging platform`,
  PERSONALIZATION: `Personalization`,
  CUSTOM_ARRANGEMENT: `Tool to arrange products in the brand portal and then show them in the retailer portal in that order`,
  RUNWAY: `Integration with third-party vendor Runway, our mobile release tooling`,
  CONVERSATIONAL_SEARCH: `Conversational Search aims to use LLMs to provide guided shopping assistance to users.`,
  RETAILER_ADDRESS_MANAGEMENT: `Managing addresses for retailers; EG: CRUD operations as well as managing associations with other entities.`,
  RETAILER_BACKORDERS: `Handling backorders on retailer side.`,
  DIGEST_PAGE: `A personalized page with recommendations for each retailer.`,
  PAGE_DATA_APIS: `Moving page data returned from HomeResourceTemplateBuilder to page APIs.`,
  MOBILE_CI: `Mobile CI Projects Infrastructure.`,
  CSV_EXPORT: `Framework for asynchronous csv exports`,
  PAID_MARKETING: `Integrations and support for external Marketing platforms like Meta and Google`,
  BRAND_MESSENGER: `Brand specific messaging`,
  RETAILER_MESSENGER: `Retailer specific messaging`,
  MESSENGER_INFRASTRUCTURE: `Related to the infrastructure that powers Faire's messaging`,
  RETAILER_AUTHORIZATION: `Retailer authorization for the Activation team (for example, credit check authorization)`,
  SHOP_LOCAL: `Shop Local app`,
  CONFIG_VARS: `Configuring backend applications with ConfigVars and SecretConfigVars`,
  CACHING: `Caching data to improve performance and reduce load on downstream components`,
  SIDE_CART: `The side cart experience, used on brand and PDP pages to show the items currently in cart`,
  UNLISTED_PRODUCTS: `Retailer requests unlisted products from Brands functionality`,
  FAIRE_PAY: `The Faire Pay payment method ands its associated tools.`,
  FULFILLED_BY_FAIRE: `Faire-run Fulfillment for Brands`,
  SHIPBOB: `Integration with third party logistics (3PL) vendor ShipBob`,
  FULFILLMENT_INBOUND: `Faire-owned inbound warehouse receiving for Fulfilled by Faire`,
  FAIRE_SOURCE: `Faire’s program that lets retailers order from multiple brands with one low minimum.`,
  FAIRE_SOURCE_BUY_IT_AGAIN: `Faire Source's Buy It Again feature (Reorder tab on the Faire Source Shop Page)`,
  HOME_RETAILER_SERVICE: `Service-specific infrastructure for home-retailer service`,
  ADMIN_SERVER: `Admin server for providing Admin2 release info`,
  PETE_SERVER: `Pete server for providing pete event server release info`,
  VOLUME_BASED_DISCOUNTS: `Volume Based Discounts provides savings based on purchase volume`,
  CI_CD: `Continuous Integration (Buildkite)`,
  PRODUCT_BUNDLES: `Retailer-facing product bundle recommendations`,
  CUSTOMER_FEEDBACK: `Generic customer feedback consisting of a single text field`,
  MISSION_CONTROL: `The internal Mission Control tool: https://dev.faire.team/tools/mission-control`,
  MOBILE_WARDROBE: `External logger companion tool for mobile`,
  SINGLE_SIGN_ON: `Login via SSO`,
  SDUI: `Faire's internal server-driven UI framework`,
  EPPO: `Integration with the Eppo experimentation platform https://docs.geteppo.com/`,
  VISITOR_APP: `Visitor app code in frontend repo that's responsible for logged-out web pages`,
  VISITOR_SERVER: `Visitor server code in frontend repo that's responsible for logged-out web pages`,
  PURCHASE_ORDER_INGESTION: undefined,
  HELP_CENTER_NEXT_JS: `NextJS infrastructure and routing for help center`,
  IMPRESSION_LOGGING: `Impression logging engineering infrastructure for backend and viewport impressions`,
  RETAILER_BRAND_CONSOLIDATION: `Retailer awareness of brands on Faire already integrated with their POS`,
  PINECONE: `Integration with Pinecone for vector database`,
  BRANDS_SERVICE: `Service-specific infrastructure for brands service`,
  BRANDS_SERVICE_MIGRATION: `Service-specific infrastructure for brands service migration`,
  CART_CHECKOUT_IMPROVEMENT: `Relevant to cart and checkout improvement that we want to do to activate retailers`,
  PRODUCT_LISTING_QUALITY: undefined,
  PRODUCT_DELISTING: `Delisting brand products due to terms of service violations`,
  PRODUCT_EDITOR: `Product area for the single product editor`,
  ORDERS_MIGRATION: `Service extraction of orders-related functionality from monolith`,
  RETAILER_ACCOUNT_MANAGEMENT: `Account and User Management`,
  OWNED_TOKENS: `System for signing identifiers against session information to prevent IDOR leaks.`,
  INSIGHTS_UPDATES_HUB: `Area for retailers to see updates from followed brands (AKA Retailer Brand Insights)`,
  WEB_BRIDGE: `Importing a brand's catalog from their personal website using web scraping`,
  BRAND_SHOPIFY_ADMIN: `Admin tools for brand shopify integration`,
  VIRTUAL_ASSISTANT: `Virtual assistant tools and infrastructure for Help Center customer support and operations`,
  TERRAFORM_TOOLING: `Infrastructure as code workflows and reusable modules using Terraform/OpenTofu and Spacelift.`,
  K8S_CLUSTERS: `Management and provisioning of Kubernetes (EKS) clusters and related resources.`,
  NETWORKING: `Configuration and management of VPCs, gateways, ingress, and edge networking infrastructure.`,
  AWS_COSTS: `Monitoring, controlling, and attributing AWS infrastructure costs.`,
  DNS: `DNS management using Cloudflare and Amazon Route53.`,
  CDN: `Content delivery network (CDN) management using Cloudflare and Fastly.`,
  OBJECT_STORAGE: `Object storage solutions including AWS S3.`,
  ONCALL_TOOLS: `On-call and incident management tools, including PagerDuty, Rootly, and standard monitors.`,
  DISASTER_RECOVERY: `Disaster recovery processes and business continuity planning.`,
  SERVICE_MESH: `Service mesh infrastructure and management using Linkerd.`,
  GAMEDAYS: `GameDay tooling and processes, including fault injection services for resilience testing.`,
  REMOTE_DEV: undefined,
  MESSENGER_USER_CONFIGURATIONS: `Configurations that change a user's experience when using messenger.`,
  ADMIN_LAYOUT: `General UI layout features in admin2, including retailer profile page and other layout components`,
  RETAILER_VETTING: `Surfacing information brands can use to vet retailers.`,
  RETAILER_OFF_FAIRE_MATCH: `Relating to off-Faire data matching for retailers to improve retailer onboarding and activation.`,
  TEMPORAL: `Workflow and activity management using the Temporal platform.`,
  GROW_WITH_FAIRE: `Program to incentivize a retailer to grow with Faire.`,
  MARKET_HUB: `The markets hub on our Brand Portal. It tells brands about upcoming events as well as past events. It also includes our markets analytics.`,
  MARKET_PROMOTIONS: `The special type of Brand Promo that we use during Markets.`,
  QUALITY_TOOLING: `Tooling related to testing, such as test spec, data creation util`,
  TEST_INFRA: `Test infrastructure, such as test distribution and test avoidance`,
  ONBOARDING_PROJECT: `Sample service module for onboarding new engineers`,
  SAMURAI: `Infrastructure for executing the remote samurai AI agent workflows`,
  FAIRE_FUNDS_TRIAGE: `Faire Funds is an employee program to encourage dogfooding and reporting issues`,
  BRAND_SALES_REP_ATTRIBUTION: `Allows brands to attribute sales reps to customers/orders`,
  NEXTJS_INFRASTRUCTURE: `Infrastructure that powers Next.js services such as middleware, data fetching, and caching`,
  QUICKBOOKS_ACCOUNTING_SYNC: `The base infrastructure for connecting Faire to QuickBooks online for 2-way data sync.`,
  APP_MODAL_FRAMEWORK: `General framework used for decentralizing app modals.`,
  SIGNUP_FLOW: `Covers everything related to the end-to-end signup journey, including onboarding steps, eligibility checks, and account creation logic`,
  SIGNUP_MODAL: `Covers the UI/UX and functionality specific to any modal/dialog components that facilitate signup within the app`,
  R2B_REQUEST_TO_SHOP: `Retailer-to-Brand request to shop functionality`,
  RETAILER_ACTIVATION_CHECKLIST: `Features related to retailer activation checklist and onboarding guidance.`,
  REVENUE_TEAM: `Features related to the Revenue (Sales) team, including BSMs, BP, and Retailer Sales.`,
  TRENDS: `Features related to the Faire Forecast page or trends hub`,
  MESSENGER_EMOJI_AND_MESSAGE_REACTION: `Features related to the Faire messenger emoji and message reaction`,
  PORTKEY: `Features and integrations related to Portkey AI gateway services`,
  UPMARKET_PLUS: `Features related to work for our upmarket plus retailers`,
  FAIREADMIN_ACCESS: `FaireAdmin access control including read only access, write access, read only and write impersonation`,
  SHOPIFY_EMAIL_RELAY: `Service that generates and routes emails to anonymized @relay.faire.com addresses for retailers`,
  EXTERNAL_API_PRODUCT_PRICES: `External API support for product price functionality`,
  BRAND_PAGE_HEADER: `Area specific to brand page header section for retailers`,
  BRAND_PAGE_PRODUCT_GRID: `Area specific to brand page product grid for retailers`,
  BRAND_PAGE_RECOMMENDATIONS: `Area specific to brand page recommendations section for retailers`,
  BRAND_PAGE_BRAND_REVIEWS: `Area specific to brand page brand reviews section for retailers`,
  FAIRE_PLUS: `Features related to work for our Faire plus brands`,
  PRODUCT_PURCHASABILITY: `Product out-of-stock/in-stock state management and sale state transitions`,
  REORDER_HUB: `Area specific to the reorder hub`,
  MESSAGE_TEMPLATES: `Message template management for brand-owned messaging templates.`,
  DATAFOLD: `Data diff and regression testing`,
  ANOMALO: `Data quality monitoring and alerting`,
  RETAILER_HEADER: `Area specific to the Retailer navigation header`,
  EXTERNAL_API_AUTH: `General authentication and token management infrastructure for External APIs`,
  IMAGE_CORRECTNESS_AND_CONSISTENCY: `Area specific to ensuring images are correctly displayed`,
  IMAGE_QUALITY_AND_GOVERNANCE: `Area specific to enforcing quality image standards and content safety`,
  PRODUCT_IMAGES: `Area specific to Brand product image management`,
  IMAGE_PLATFORM_INFRASTRUCTURE: `Area specific to infrastructure for storing, serving, and managing images`,
  PRODUCT_IMAGE_CORRECTNESS_AND_CONSISTENCY: `Area specific to ensuring product images are correctly displayed`,
  PRODUCT_IMAGE_MANAGEMENT: `Area specific to how product images are managed on the platform`,
  WORKATO: `Integration with Workato automation platform for workflow automation`,
  FUNCTIONAL_STAGE: `Functional stage framework to enable decomposition and facilitate experiments and feature toggle routing`,
  FORMULA_DSL: `DSL for creating and evaluating formulas`,
  FINANCIAL_INVOICE: `Areas related to financial invoice infrastructure`,
  BRAND_STORIES: `Brand storytelling and marketing content features`,
  SECURITY_UTILITIES: `Cryptographic primitives, secure hashing (PBKDF2), secure random generation, constant-time comparison, content digest computation, and MFA secret management.`,
  INPUT_SANITIZATION: `Input validation and sanitization to prevent injection attacks: HTML sanitization (XSS), CSV injection prevention, URL validation and detection, IP range validation, image size validation, and PDF string sanitization.`,
  BOT_DEFENSE: `Bot detection and mitigation including CAPTCHA verification (hCaptcha), rate limiting, and automated abuse prevention.`,
  SECURITY_AUDIT_LOGGING: `Security event logging, audit trails, and security log viewing for user accounts including brand and retailer security log pages and the underlying logging service.`,
  WRITE_MODE_ENFORCEMENT: `Database write-mode controls, read-only enforcement, and write-mode override mechanisms to prevent unauthorized data mutations.`,
  SECRET_MANAGEMENT: `Management of secret configuration variables, API keys, webhook secrets, and sensitive credential storage.`,
  FAIRE_SOURCE_SHOP_PAGE: `Faire Source's Shop Page where retailers can browse and order from multiple brands.`,
  POSTHOG: `Product analytics and session replay platform`,
  SEARCH_BAR: `The search bar UI component used by retailers to enter search queries`,
  SEARCH_SUGGESTIONS_EMPTY_STATE: `The empty state displayed when there are no search suggestions for a retailer's query`,
  BRAND_PAGE_SEARCH: `The search functionality within a brand's page, allowing retailers to search for products within a brand's catalog`,
  AWS_INFRA: `AWS infrastructure components, including networking, compute, storage, and related platform primitives.`,
  WEB_API: `Web platform APIs and tooling, including API Explorer and codegen.`,
  BRAND_FINANCING: `Brand financing offerings, including the Parafin integration for capital offers to brands.`,
  COMPLIANCE: `Company compliance programs and controls, including SOX, ISO 27001, and other regulatory and certification requirements.`,
  MARKDOWN_ALLOWANCES: `Markdown allowances and related discount workflows.`,
  FSR_CONFIGURATION: `FSR (Fairly Specific Requirements) Configuration`,
  SWARM_UI: `Swarm UI is a development tool that enables engineers to kick off background agent runs for batch processing of multiple similar tasks, or LSCs. It provides a web interface at https://dev.faire.team/ai/swarm where developers can create "swarms" - coordinated sets of GitHub issues that are automatically generated and assigned to AI agents for parallel execution.`,
  ANALYTICS_EVENTS: `Kinesis Firehose and analytics event publishing infrastructure.`,
  BRAND_SHOPIFY_ORDER_FULFILLMENT_SYNC: `Syncing fulfillment data (tracking numbers, carrier info, fulfillment status) between Faire and Shopify for brand orders`,
  BRAND_BULK_FULFILLMENT_CSV: undefined,
  BULK_UPLOAD_FRAMEWORK: `Generic bulk upload framework infrastructure shared across upload types`,
  CUSTOMIZABLE_PRODUCTS: `Customizable products and per-product lead-time overrides across catalog, cart, and orders`,
  SHOPIFY_BESTSELLER_NUDGE: `Surfacing Shopify draft products to eligible brands in Brand Portal to prompt publishing`,
  FIREBASE: `Firebase platform services and integrations owned by Growth Platform.`,
  AGENT_DOJO: `Internal tool to host agentic coding platforms`,
  TEST_DASHBOARD: `Backend for CI test-run ingestion and flaky-test quarantine tracking.`,
  FAIRESPACE: `Internal hosting for static sites on space.faire.team`,
  TEST_TRACKER: `Backend for CI test-run ingestion and flaky-test quarantine tracking.`,
  QUIP: `Pinned page comments left by employees through the Quip browser extension`,
  IT_IAM: `IT Engineering identity & access management: Okta and Opal application integrations, group management, and the SSO-integration tooling.`,
  DATA_IMPORTED_ENTITIES: `Service tables whose source of truth is a dataset computed in the warehouse and delivered over SQS by the core-data-import framework.`,
  DETEKT: `Detekt static analysis: custom lint rules, Bazel wiring and baselines. Owned by the Detektors (Slack: #detektors, GitHub team: https://github.com/orgs/Faire/teams/detektors), not by the pod.`,
  FINANCIAL_INVOICE_SETTLEMENTS: `Program configurable framework that settles due financial invoices: charges, retries, refunds via credit notes, and settlement events for programs.`,
};

export const getDescriptionForProductArea = (
  enumValue: ProductArea | keyof typeof ProductArea
): string | undefined => {
  return descriptionForProductArea[enumValue];
};

const documentation_linkForProductArea: Partial<Record<ProductArea, string>> = {
  PRODUCT_AREA_UNKNOWN: undefined,
  ABOUT_US_PAGE: undefined,
  ADMIN: undefined,
  ADYEN: undefined,
  ADYEN_PAYOUT: undefined,
  STRIPE_PAYOUT: undefined,
  AFFILIATES: undefined,
  AI_BRIDGE: undefined,
  AI_TOOLS: undefined,
  ALCOHOL: undefined,
  ALERT_BANNERS: undefined,
  AMEX: undefined,
  ANTI_ABUSE: undefined,
  API_PERFORMANCE: undefined,
  APPAREL_BRAND: undefined,
  APPAREL_COLLECTIONS: undefined,
  CORE_COLLECTIONS: undefined,
  COLLECTIONS_RETAILER_DISPLAY: undefined,
  APPAREL_DISCOVERY: undefined,
  APPDASH: undefined,
  ATELIER_FAIRE: undefined,
  AUTH: undefined,
  AUTOBOTS_FRAMEWORK: undefined,
  AUTOPILOT: undefined,
  MFA: undefined,
  AWS_SAGEMAKER: undefined,
  B2B_REFERRALS: undefined,
  BACKEND_DRIVEN_MESSAGING_CONTAINERS: undefined,
  BACKFILA: undefined,
  BADGES: undefined,
  BLOG_GATED_CONTENT: undefined,
  BOARDS: undefined,
  BRAND_ACCOUNT_SETTINGS: undefined,
  BRAND_ACQUISITION: undefined,
  BRAND_ANALYTICS: undefined,
  PRODUCT_SALES_REPORT: undefined,
  BRAND_ANNOUNCEMENTS: undefined,
  BRAND_APP: undefined,
  BRAND_CATALOG_COMPLETENESS: undefined,
  BRAND_CORE: undefined,
  BRAND_CRM: undefined,
  BRAND_CUSTOMER_ENGAGEMENT_SURVEY: undefined,
  BRAND_DAILY_DIGEST: undefined,
  BRAND_EMAIL_PREFERENCES: undefined,
  BRAND_F14D_DISCOUNTS: undefined,
  BRAND_FRAUD: undefined,
  BRAND_HYPE_MAP: undefined,
  BRAND_INTEGRATIONS: undefined,
  BRAND_INVOICES: undefined,
  BRAND_LEADS: undefined,
  BRAND_LISTING_QUALITY: undefined,
  BRAND_LOYALTY: undefined,
  BRAND_MARKETING_CAMPAIGNS: undefined,
  BRAND_MARKETPLACE: undefined,
  BRAND_MARKETPLACE_HOMEPAGE: undefined,
  BRAND_MCP: undefined,
  BRAND_MOBILE: undefined,
  BRAND_MULTI_USER_MANAGEMENT: undefined,
  BRAND_NUDGES: undefined,
  BRAND_ACTIVATION: undefined,
  BRAND_ONBOARDING: undefined,
  BRAND_ORDERS: undefined,
  BRAND_PAYOUT_CALCULATION: undefined,
  BRAND_NOTIFICATIONS_CENTRE: `https://app.notion.com/p/faire/Brand-Notifications-Centre-product-area-documentation-3ed2efb5c25a80348fb8c4fe5a9c47b0?source=copy_link`,
  BRAND_PAYOUTS: undefined,
  BRAND_PORTAL_HOMEPAGE: undefined,
  BRAND_PORTAL_SEARCH: undefined,
  BRAND_PORTAL_NAVIGATION: undefined,
  BRAND_PORTAL_PRODUCTS_PAGE: undefined,
  BRAND_PREVIEW: undefined,
  BRAND_PRICING: undefined,
  BRAND_PRODUCT_SEARCH_SUGGESTIONS: undefined,
  BRAND_PRODUCT_TAGS: undefined,
  BRAND_PROMOS: undefined,
  BRAND_PROSPECTING: undefined,
  BRAND_RESTRICTIONS: undefined,
  BRAND_REVIEWS: undefined,
  BRAND_SAFETY: undefined,
  BRAND_SEARCH: undefined,
  BRAND_SHOP_CURRENCY: undefined,
  BRAND_SHOP_PAGE: undefined,
  BRAND_SHOP_SETTINGS: undefined,
  PRODUCT_GEO_AVAILABILITY: undefined,
  BRAND_SHOPIFY_INTEGRATION: undefined,
  BRAND_SHOPIFY_CATALOG_SYNC: undefined,
  BRAND_SHOPIFY_PRODUCT_IMPORT: undefined,
  BRAND_SHOPIFY_VARIANT_IMPORT: undefined,
  BRAND_SHOPIFY_PRODUCT_LINKING: undefined,
  BRAND_SHOPIFY_PRODUCT_STATUS_SYNC: undefined,
  BRAND_SHOPIFY_DATA_REPLICATION: undefined,
  BRAND_SHOPIFY_PERFORMANCE_TRACKING: `https://www.notion.so/Shopify-performance-data-2802efb5c25a8099ac3fe59a05f80d3c`,
  BRAND_SHOPIFY_OTHER: undefined,
  BRAND_SHOPIFY_METAFIELDS_SYNC: undefined,
  BRAND_SHOPIFY_CONTENT_SYNC: `https://www.notion.so/faire/Brand-Shopify-Content-Sync-965d13f656fa452f8be0a9a94587ee96?source=copy_link`,
  BRAND_SHOPIFY_HOME: undefined,
  BRAND_SHOPIFY_INVENTORY_SYNC: undefined,
  BRAND_SHOPIFY_ORDER_SYNC: undefined,
  BRAND_SHOPIFY_PREFERENCES: undefined,
  BRAND_SHOPIFY_PRICE_SYNC: undefined,
  BRAND_SHOPIFY_SALES_CHANNEL_MIGRATION: undefined,
  BRAND_SHOPIFY_SETUP: undefined,
  RETAILER_SHOPIFY_APP: undefined,
  BRAND_SLA: undefined,
  BRAND_TAGS: undefined,
  BRAND_TILE: undefined,
  BRAND_VERIFICATION: undefined,
  BRAND_WIDGET: undefined,
  BRANDS: undefined,
  BRAZE: undefined,
  BRAZE_EMAILS: undefined,
  BROWSER_EXTENSION: undefined,
  BUILDER_IO: undefined,
  BUY_IT_AGAIN: undefined,
  BULK_ACTIONS: undefined,
  BULK_PRODUCT_EDIT: undefined,
  BULK_PRODUCT_EXPORT: undefined,
  BULK_PRODUCT_UPLOAD: undefined,
  CAPABILITIES: undefined,
  CARBON_NEUTRAL_RETAILER: undefined,
  CART: `https://www.notion.so/faire/Carts-Hub-1e42efb5c25a80f1b5a3fbfc220b0445?pvs=25`,
  CART_RECOMMENDATIONS: undefined,
  CART_COLLABORATION: undefined,
  CATEGORIES: undefined,
  CATEGORY_PAGE_RECOMMENDATIONS: undefined,
  BROWSE_INFRASTRUCTURE: undefined,
  CATEGORY_RESULTS: undefined,
  CATEGORY_RESULTS_RANKING: undefined,
  CATALOGS_MIGRATION: undefined,
  CATALOG_VERIFICATION: undefined,
  CHAT_GPT_ENTERPRISE: undefined,
  CHECKOUT: `https://www.notion.so/faire/Checkout-Eng-Hub-1d72efb5c25a8019b268e5179fc5a88f`,
  CLAWBACKS: undefined,
  CLIENT_EVENTS: undefined,
  CLIENT_HEALTH_TOOL: undefined,
  COCKROACH_DB: undefined,
  COLLECTIONS: undefined,
  COMMISSIONS: undefined,
  COMMS_PLANNER: undefined,
  CONDUCTOR: undefined,
  CONSUMER: undefined,
  CSV_IMPORT: undefined,
  CURRENCY_CONVERSION: undefined,
  CX_CUSTOMER_QUEUES: undefined,
  CX_FOUNDATIONS: undefined,
  RETAILER_FIRST_ORDER_INCENTIVE: undefined,
  RETAILER_ACTIVATION_INCENTIVES: undefined,
  CX_OPS: undefined,
  DATA_ATLAS: undefined,
  DATA_FACTORY: undefined,
  DATA_LAKE: undefined,
  DATA_LOOKUP: undefined,
  DATABASE: undefined,
  DATABASE_EXPLORER: undefined,
  DELAYER: undefined,
  DRAFT_ORDERS: undefined,
  RETAILER_DRAFT_ORDERS: undefined,
  DUTIES: undefined,
  E2E: undefined,
  ECO_FRIENDLY: undefined,
  EDGE_INFRA: undefined,
  EDIT_ORDERS: undefined,
  EMAIL_INFRA: undefined,
  ERROR_RATE_TRIAGE: undefined,
  EVENTS: undefined,
  EXCLUSIVITY: undefined,
  EXPERIMENTS: undefined,
  EXPERIMENT_PLATFORM: undefined,
  EXPIRED_SETTINGS_CLEANUP: undefined,
  EXTERNAL_APIS: undefined,
  EXTERNAL_API_BRANDS: undefined,
  EXTERNAL_API_CORE: undefined,
  EXTERNAL_API_BRAND_PROMOS: undefined,
  EXTERNAL_API_ORDERS: undefined,
  EXTERNAL_API_OAUTH: undefined,
  EXTERNAL_API_MCP_OAUTH: undefined,
  EXTERNAL_API_PARTNERSHIPS: undefined,
  EXTERNAL_API_PRODUCTS: undefined,
  EXTERNAL_API_PREPACKS: undefined,
  EXTERNAL_API_PRODUCT_INVENTORY: undefined,
  EXTERNAL_API_RETAILERS: undefined,
  EXTERNAL_API_TAXONOMY: undefined,
  EXTERNAL_API_PRODUCT_REVIEWS: undefined,
  EXTERNAL_DEVELOPER: undefined,
  FAIREY: undefined,
  FAIRE_CLI: undefined,
  FAIRE_CONTENT: undefined,
  FAIRE_DIRECT: undefined,
  FAIRE_DIRECT_ADOPTION_EMAIL: undefined,
  FAIRE_DIRECT_APP: undefined,
  FAIRE_DIRECT_RETAILERS: undefined,
  FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_DIRECT_REWARDS_LIFECYCLE_EMAIL: undefined,
  FAIRE_DIRECT_TRIGGER_EMAIL: undefined,
  FAIRE_FOLK_HUB: undefined,
  FAIRE_SOCIAL_PROOF: undefined,
  FAIRE_SPACES: undefined,
  RETAILER_POS_INTEGRATIONS: undefined,
  FAIRESYNC: undefined,
  FAIRESYNC_INTEGRATION_CLOVER: undefined,
  FAIRESYNC_INTEGRATION_SHOPIFY: `https://www.notion.so/faire/CSRF-and-Oauth-flow-for-Fairesync-Integration-Shopify-documentation-34b2efb5c25a8047a3acd94b5ef79efe`,
  FAIRESYNC_INTEGRATION_SQUARE: undefined,
  FAIRESYNC_INTEGRATION_LIGHTSPEED: undefined,
  FAIRESYNC_INTEGRATION_QUICKBOOKS: undefined,
  FAIREWORKS: undefined,
  FASHION_WEEK: undefined,
  FILTERS: undefined,
  FLASH_SALES: undefined,
  FOOD_AND_BEVERAGE: undefined,
  FRONTEND_APIS: undefined,
  FRONTEND_TOOLING: undefined,
  FULLSTORY_CONFIG: undefined,
  GITHUB: undefined,
  GMAIL: undefined,
  GOOSE: undefined,
  GUARANTEED_VOLUME: undefined,
  HACK_WEEK: undefined,
  HELP_CENTER: undefined,
  HOME_FEED: undefined,
  TRANSLATIONS: undefined,
  HUBSPOT: undefined,
  IDV: undefined,
  IMAGES: undefined,
  INALYTICS: undefined,
  INCENTIVES: undefined,
  INFRA: undefined,
  INFERENCE: undefined,
  INSIDER: undefined,
  INSTRUMENTS: undefined,
  INTERNAL_API: undefined,
  INVENTORY: `https://www.notion.so/faire/Inventory-be294b9da3164c0488ad64dfcb240288?source=copy_link`,
  ISSUE_REPORTS: undefined,
  JOBS: undefined,
  KITCHEN_SINK: undefined,
  KNOWLEDGE_GRAPH: undefined,
  LAIKA: undefined,
  LAUNCH_WITH_FAIRE: undefined,
  LATENCY_TRIAGE: undefined,
  LEGAL_DOCUMENTS: undefined,
  STAGING: undefined,
  LIVE_STREAMS: undefined,
  LLM: undefined,
  LLM_OPERATIONS: undefined,
  LOCALIZATION: undefined,
  LOGGED_IN_HOMEPAGE: undefined,
  MAKER_BUY_BACK: undefined,
  MARKETS: undefined,
  MESSENGER: undefined,
  MESSENGER_CONTEXT_PANEL: undefined,
  MESSENGER_INLINE_CONTEXT: undefined,
  MILESTONES: undefined,
  MISPRICED_RESELLER: undefined,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_IN: undefined,
  MOBILE_RETAILER_HOMEPAGE_LOGGED_OUT: undefined,
  MOBILE_RETAILER_LOGGED_OUT: undefined,
  MOBILE_RETAILER_MESSENGER: undefined,
  MOBILE_RETAILER_ONBOARDING: undefined,
  MOBILE_RETAILER_SIGNUP: undefined,
  MY_BRANDS: undefined,
  ZENDESK_TRANSLATIONS: undefined,
  MYSQL: undefined,
  NAVIGATION_INFRASTRUCTURE: undefined,
  NAVIGATION_TREE_UX: undefined,
  NET_TERMS: undefined,
  NEWSROOM: undefined,
  NEW_RETAILERS: undefined,
  PARTNERSHIPS_PAGE: undefined,
  OMNISEARCH: undefined,
  ONE_FAIRE_TEAM: undefined,
  OPEN_SIZING: undefined,
  OPEN_WITH_FAIRE: undefined,
  OPEN_WITH_FAIRE_LOGGED_OUT: undefined,
  ORDER_SUBMISSION: undefined,
  ORDERS: undefined,
  PACKING_SLIP: undefined,
  PAYMENTS: undefined,
  PDF_RENDERING: undefined,
  PERF_DARK_READ: undefined,
  PICK_LIST: undefined,
  PLAID: undefined,
  POSTMARK: undefined,
  PR_BOT: undefined,
  PREORDERS: undefined,
  PREPACKS: undefined,
  PRERELEASE: undefined,
  PRESTASHOP: undefined,
  PRICING: undefined,
  PRICING_PARITY: undefined,
  PRIVACY: undefined,
  PRODUCERS: undefined,
  PRODUCT_CHANGE_HISTORY: `https://www.notion.so/How-to-Add-Support-for-New-Fields-to-Product-Change-History-3092efb5c25a80aba162c222813a70b4`,
  PRODUCT_INFO: undefined,
  PRODUCT_PRICE_MATCH_GUARANTEE: undefined,
  PRODUCT_REVIEWS: undefined,
  PRODUCT_SAMPLES: undefined,
  PRODUCT_TILE: undefined,
  PRODUCTS: undefined,
  PRODUCTS_API: undefined,
  PRODUCTS_PLATFORM: undefined,
  PROMO_MODALS: undefined,
  PROMOTIONAL_EVENTS: undefined,
  PROMO_CODES: undefined,
  PURCHASE_ORDER: undefined,
  PUSH_NOTIFICATIONS: undefined,
  QUALTRICS: undefined,
  QUEUES: undefined,
  QUICK_ADD: undefined,
  R2B_REFERRALS: undefined,
  R2R_REFERRALS: undefined,
  RANKING: undefined,
  RECOMMENDATIONS: undefined,
  REDIS: undefined,
  RELEASE_TOOL: undefined,
  REGIONAL_SEARCH: undefined,
  REORDER_UPDATES_HUB: undefined,
  RETAILER_ADVERTISING: undefined,
  RETAILER_BRAND_LOYALTY: undefined,
  RETAILER_BRANDS_MANAGEMENT: undefined,
  RETAILER_FINDER_APP: undefined,
  RETAILER_INVOICES: undefined,
  RETAILER_LAYOUT_ELEMENTS: undefined,
  LAYOUT_SERVICE: undefined,
  RETAILER_MARKETING: undefined,
  RETAILER_MOBILE: undefined,
  RETAILER_NUX: undefined,
  RETAILER_ONBOARDING: undefined,
  RETAILER_ORDER_MANAGEMENT: undefined,
  RETAILER_OWNER_TRANSFER: undefined,
  RETAILER_PORTAL: undefined,
  RETAILER_POS: undefined,
  RETAILER_REPORTING: undefined,
  RETAILER_SAVINGS: undefined,
  RETAILER_SETTINGS_PAGE: undefined,
  RETAILER_STYLE_QUIZ: undefined,
  CAREERS_PAGE: undefined,
  RETAILER_YEAR_IN_REVIEW: undefined,
  RETAILERS: undefined,
  RETAILER_CONVERSION: undefined,
  RETAILER_CORE: undefined,
  RETURNS: undefined,
  REVERSE_SYNCER: undefined,
  RISK: undefined,
  RISK_OPS: undefined,
  RISK_ASSESSMENT: undefined,
  SALES_REPS: undefined,
  SALESFORCE: undefined,
  SAMPLES: undefined,
  SAMPLES_RETAILER: undefined,
  SPYGLASS: undefined,
  HELP_CENTER_INFRA: undefined,
  HELP_CENTER_PAGES: undefined,
  HELP_CENTER_SELF_SERVE: undefined,
  SANDBOX: undefined,
  SEARCH: undefined,
  SEARCH_SUGGESTIONS: undefined,
  SEARCH_INFRASTRUCTURE: undefined,
  SEARCH_EXPERIENCE_ACCELERATOR: undefined,
  SEE_MORE_PAGE: undefined,
  RETAILER_MULTI_USER_MANAGEMENT: undefined,
  RETAILER_TEAM_SHARING: undefined,
  SEASONAL_CATEGORIES: undefined,
  IMPERSONATION: undefined,
  SECURITY: undefined,
  SENTRY: undefined,
  SEO: undefined,
  SESSIONS: undefined,
  SETTINGS: undefined,
  SHIPMENTS: undefined,
  SHIPPING: undefined,
  SHIPPING_SERVICE_EXTRACTION: undefined,
  STATE_MACHINES: undefined,
  ADDRESSES: undefined,
  SHIPPING_INSURANCE: undefined,
  COMMERCIAL_INVOICES: undefined,
  TARIFF_CODES: undefined,
  SAPIENT: undefined,
  SHOPIFY_MAKERS: undefined,
  SIGNIN: undefined,
  SIGNUP: undefined,
  SLACK: undefined,
  SLATE_DESIGN_SYSTEM: undefined,
  SLATE_CORE_COMPONENTS_LIBRARY: undefined,
  SLATE_FOUNDATIONS_LIBRARY: undefined,
  SLATE_TOOLS: undefined,
  BRAND_COMPONENTS_LIBRARY: undefined,
  RETAILER_COMPONENTS_LIBRARY: undefined,
  SLATE_COMPONENTS: undefined,
  SLATE_ICONS: undefined,
  SLATE_FOUNDATIONS: undefined,
  COMMUNITY_LIBRARY_COMPONENTS: undefined,
  STORYBOOK_INFRA: undefined,
  DESIGN_PROTOTYPE_PLAYGROUND: undefined,
  ACCESSIBILITY_TOOLING: undefined,
  ICON_TOOLING: undefined,
  UI_LIBRARY_TOOLING: undefined,
  SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: undefined,
  STRIPE: undefined,
  SUNCO: undefined,
  SWATCHES: undefined,
  SWITCHBOARD: undefined,
  TAKTILE: undefined,
  TASKS: undefined,
  FAIRE_TASK_MANAGER: undefined,
  TAX_FORMS: undefined,
  TAXES: undefined,
  TAXONOMY: undefined,
  TERMS_OF_SERVICE: undefined,
  TEST: undefined,
  TESTIMONIALS: undefined,
  TIME_TURNER: undefined,
  TOP_BRAND: undefined,
  TOP_PRODUCTS: undefined,
  TRADESHOW: undefined,
  UNIVERSAL_FEEDBACK_TOOL: undefined,
  UPMARKET: undefined,
  UPMARKET_EXPERIENCE: undefined,
  USER_INVITATION: undefined,
  USERS: undefined,
  VALIDATION: undefined,
  VIDEOS: undefined,
  VISITORS: undefined,
  VS_CODE_EXTENSION: undefined,
  WAITLISTED_SIGNUP: undefined,
  WAREHOUSE_TOOLING: undefined,
  WEB_DOCS_SITE: undefined,
  WEB_RETAILER_SERVER: undefined,
  WEB_SERVER_SIDE_RENDERING: undefined,
  WEBSERVER: undefined,
  XLSX_IMPORT: undefined,
  XLSX_ONBOARDING_IMPORT: undefined,
  ZIP_CODE_PROTECTION: undefined,
  RETAILER_TEAM_MANAGEMENT: undefined,
  BRAND_INCREMENTALITY: undefined,
  ZENDESK: undefined,
  MOBILE_PERFORMANCE_MONITORING_INFRASTRUCTURE: undefined,
  ADS: undefined,
  ADS_MANAGER: undefined,
  LOCAL_FILTERS_AND_MERCHANDISING: undefined,
  RECOGNIZABLE_BRANDS: undefined,
  LOGGED_OUT_RETAILERS: undefined,
  WEB_BRAND_SERVER: `https://www.notion.so/faire/Next-js-in-Web-Brand-Server-1d11f01e06ed4feb9164c32ee77f1aac`,
  WEB_BRAND_NEXTJS: `https://www.notion.so/faire/Next-js-in-Web-Brand-Server-1d11f01e06ed4feb9164c32ee77f1aac`,
  FINANCIAL_EVENTS: undefined,
  WEB_PROXY: undefined,
  RETAILER_PROFILE_INFO: undefined,
  SHIPPING_RESTRICTION: undefined,
  RECOMMENDATIONS_INFRASTRUCTURE: undefined,
  DISCOVERY_RECOMMENDATIONS: undefined,
  BRAND_PAGE: `https://www.notion.so/faire/Brand-Page-for-Retailers-1d02efb5c25a804a97a6e5a9676dedd7`,
  PRODUCT_PAGE: `https://www.notion.so/faire/Product-Details-Page-PDP-Hub-2092efb5c25a8002b7d8f2aaa3e90c9c`,
  PRODUCT_PAGE_MINISHOP_AND_RECOMMENDATIONS: undefined,
  PRODUCT_PAGE_PRODUCT_DETAILS: undefined,
  PRODUCT_PAGE_REVIEWS: undefined,
  FONOA: undefined,
  MOBILE_CORE: undefined,
  RETAILER_STORE_MANAGEMENT: undefined,
  COMMISSION_UPDATE_REQUESTS: undefined,
  SCIM: undefined,
  INTERNAL_API_SALESFORCE: undefined,
  INTERNAL_API_CATALOGS_MIGRATION: undefined,
  INTERNAL_API_RETAILER_SHOPIFY_INTEGRATION: undefined,
  INTERNAL_API_INVENTORY: undefined,
  INTERNAL_API_ORDERS: undefined,
  FAIRE_FOR_TEAMS: undefined,
  MULTI_BRAND: undefined,
  ALERT_BANNERS_BRAND: undefined,
  ALERT_BANNERS_RETAILERS: undefined,
  ISSUE_REPORT_CLAWBACKS: undefined,
  RETURN_CLAWBACKS: undefined,
  CANONICAL_DATA: undefined,
  FINACIAL_DATA_PLATFORM: undefined,
  DATA_SECURITY: undefined,
  DATA_WAREHOUSE: undefined,
  DATA_AIRFLOW: undefined,
  DATA_FAIREFLOW: undefined,
  DATA_SQL_VALIDATION_DAG: undefined,
  DATA_FIVETRAN: undefined,
  DATA_LOOKER: undefined,
  DATA_MODE: undefined,
  DATA_SELECTSTAR: undefined,
  DATA_FAIRE_COM: undefined,
  DATA_MESH: undefined,
  DATA_ENV: undefined,
  STREAM_PROCESSING: undefined,
  DATA_AWS: undefined,
  DATA_CONTRACTS: undefined,
  RETAILER_UNIVERSE: undefined,
  KG_SCRAPE: undefined,
  KG_MATCH: undefined,
  XP_METRICS: undefined,
  FEATURE_STORE: undefined,
  MODEL_STORE: undefined,
  INFERENCE_SERVICE: undefined,
  ML_OBSERVABILITY: undefined,
  OBSERVABILITY: undefined,
  ORACLE_CLOUD: undefined,
  OCI_GPU_CLUSTER_INFRA: undefined,
  ML_TRAINING: undefined,
  INTERNAL_API_PRODUCTS: undefined,
  INTERNAL_API_IMAGES: undefined,
  BACKEND_TEST_INFRA: undefined,
  CATALOGS_SERVICE: undefined,
  BRAND_TERMS_OF_SERVICE: undefined,
  RETAILER_NOTIFICATIONS: undefined,
  PHOENIX: undefined,
  MOBILE_APP_BUILD_INFRASTRUCTURE: undefined,
  MOBILE_APP_SETTINGS: undefined,
  MOBILE_APP_STARTUP: undefined,
  PRODUCT_MESSAGING: undefined,
  PERSONALIZATION: undefined,
  CUSTOM_ARRANGEMENT: undefined,
  RUNWAY: undefined,
  CONVERSATIONAL_SEARCH: undefined,
  RETAILER_ADDRESS_MANAGEMENT: undefined,
  RETAILER_BACKORDERS: undefined,
  DIGEST_PAGE: undefined,
  PAGE_DATA_APIS: undefined,
  MOBILE_CI: undefined,
  CSV_EXPORT: undefined,
  PAID_MARKETING: undefined,
  BRAND_MESSENGER: undefined,
  RETAILER_MESSENGER: undefined,
  MESSENGER_INFRASTRUCTURE: undefined,
  RETAILER_AUTHORIZATION: undefined,
  SHOP_LOCAL: undefined,
  CONFIG_VARS: undefined,
  CACHING: undefined,
  SIDE_CART: undefined,
  UNLISTED_PRODUCTS: undefined,
  FAIRE_PAY: undefined,
  FULFILLED_BY_FAIRE: undefined,
  SHIPBOB: undefined,
  FULFILLMENT_INBOUND: undefined,
  FAIRE_SOURCE: undefined,
  FAIRE_SOURCE_BUY_IT_AGAIN: undefined,
  HOME_RETAILER_SERVICE: undefined,
  ADMIN_SERVER: undefined,
  PETE_SERVER: undefined,
  VOLUME_BASED_DISCOUNTS: undefined,
  CI_CD: undefined,
  PRODUCT_BUNDLES: undefined,
  CUSTOMER_FEEDBACK: undefined,
  MISSION_CONTROL: undefined,
  MOBILE_WARDROBE: undefined,
  SINGLE_SIGN_ON: undefined,
  SDUI: undefined,
  EPPO: undefined,
  VISITOR_APP: undefined,
  VISITOR_SERVER: undefined,
  PURCHASE_ORDER_INGESTION: undefined,
  HELP_CENTER_NEXT_JS: undefined,
  IMPRESSION_LOGGING: undefined,
  RETAILER_BRAND_CONSOLIDATION: undefined,
  PINECONE: undefined,
  BRANDS_SERVICE: undefined,
  BRANDS_SERVICE_MIGRATION: undefined,
  CART_CHECKOUT_IMPROVEMENT: undefined,
  PRODUCT_LISTING_QUALITY: undefined,
  PRODUCT_DELISTING: undefined,
  PRODUCT_EDITOR: undefined,
  ORDERS_MIGRATION: undefined,
  RETAILER_ACCOUNT_MANAGEMENT: undefined,
  OWNED_TOKENS: undefined,
  INSIGHTS_UPDATES_HUB: undefined,
  WEB_BRIDGE: `https://www.notion.so/faire/Web-Bridge-0bc7cda89293409783a295c1c7a96473?source=copy_link`,
  BRAND_SHOPIFY_ADMIN: undefined,
  VIRTUAL_ASSISTANT: undefined,
  TERRAFORM_TOOLING: undefined,
  K8S_CLUSTERS: undefined,
  NETWORKING: undefined,
  AWS_COSTS: undefined,
  DNS: undefined,
  CDN: undefined,
  OBJECT_STORAGE: undefined,
  ONCALL_TOOLS: undefined,
  DISASTER_RECOVERY: undefined,
  SERVICE_MESH: undefined,
  GAMEDAYS: undefined,
  REMOTE_DEV: undefined,
  MESSENGER_USER_CONFIGURATIONS: undefined,
  ADMIN_LAYOUT: undefined,
  RETAILER_VETTING: undefined,
  RETAILER_OFF_FAIRE_MATCH: undefined,
  TEMPORAL: undefined,
  GROW_WITH_FAIRE: undefined,
  MARKET_HUB: undefined,
  MARKET_PROMOTIONS: undefined,
  QUALITY_TOOLING: undefined,
  TEST_INFRA: undefined,
  ONBOARDING_PROJECT: undefined,
  SAMURAI: undefined,
  FAIRE_FUNDS_TRIAGE: undefined,
  BRAND_SALES_REP_ATTRIBUTION: undefined,
  NEXTJS_INFRASTRUCTURE: undefined,
  QUICKBOOKS_ACCOUNTING_SYNC: undefined,
  APP_MODAL_FRAMEWORK: undefined,
  SIGNUP_FLOW: undefined,
  SIGNUP_MODAL: undefined,
  R2B_REQUEST_TO_SHOP: undefined,
  RETAILER_ACTIVATION_CHECKLIST: undefined,
  REVENUE_TEAM: undefined,
  TRENDS: undefined,
  MESSENGER_EMOJI_AND_MESSAGE_REACTION: undefined,
  PORTKEY: undefined,
  UPMARKET_PLUS: undefined,
  FAIREADMIN_ACCESS: undefined,
  SHOPIFY_EMAIL_RELAY: undefined,
  EXTERNAL_API_PRODUCT_PRICES: undefined,
  BRAND_PAGE_HEADER: undefined,
  BRAND_PAGE_PRODUCT_GRID: undefined,
  BRAND_PAGE_RECOMMENDATIONS: undefined,
  BRAND_PAGE_BRAND_REVIEWS: undefined,
  FAIRE_PLUS: undefined,
  PRODUCT_PURCHASABILITY: `https://www.notion.so/faire/Product-Purchasability-2b82efb5c25a80a8a494c4cb1d51a6de?source=copy_link`,
  REORDER_HUB: undefined,
  MESSAGE_TEMPLATES: undefined,
  DATAFOLD: undefined,
  ANOMALO: undefined,
  RETAILER_HEADER: undefined,
  EXTERNAL_API_AUTH: undefined,
  IMAGE_CORRECTNESS_AND_CONSISTENCY: undefined,
  IMAGE_QUALITY_AND_GOVERNANCE: undefined,
  PRODUCT_IMAGES: undefined,
  IMAGE_PLATFORM_INFRASTRUCTURE: undefined,
  PRODUCT_IMAGE_CORRECTNESS_AND_CONSISTENCY: undefined,
  PRODUCT_IMAGE_MANAGEMENT: undefined,
  WORKATO: undefined,
  FUNCTIONAL_STAGE: undefined,
  FORMULA_DSL: undefined,
  FINANCIAL_INVOICE: undefined,
  BRAND_STORIES: undefined,
  SECURITY_UTILITIES: undefined,
  INPUT_SANITIZATION: undefined,
  BOT_DEFENSE: undefined,
  SECURITY_AUDIT_LOGGING: undefined,
  WRITE_MODE_ENFORCEMENT: undefined,
  SECRET_MANAGEMENT: undefined,
  FAIRE_SOURCE_SHOP_PAGE: undefined,
  POSTHOG: undefined,
  SEARCH_BAR: undefined,
  SEARCH_SUGGESTIONS_EMPTY_STATE: undefined,
  BRAND_PAGE_SEARCH: undefined,
  AWS_INFRA: undefined,
  WEB_API: undefined,
  BRAND_FINANCING: undefined,
  COMPLIANCE: undefined,
  MARKDOWN_ALLOWANCES: undefined,
  FSR_CONFIGURATION: `https://www.notion.so/faire/Move-FSR-configuration-closer-to-code-34c2efb5c25a800db42dda7d4da8935b?source=copy_link`,
  SWARM_UI: `https://www.notion.so/faire/Swarm-UI-31c2efb5c25a80a59eaad6d73bb068a6?source=copy_link`,
  ANALYTICS_EVENTS: undefined,
  BRAND_SHOPIFY_ORDER_FULFILLMENT_SYNC: undefined,
  BRAND_BULK_FULFILLMENT_CSV: undefined,
  BULK_UPLOAD_FRAMEWORK: undefined,
  CUSTOMIZABLE_PRODUCTS: undefined,
  SHOPIFY_BESTSELLER_NUDGE: `https://www.notion.so/faire/Shopify-Bestseller-Nudge`,
  FIREBASE: undefined,
  AGENT_DOJO: undefined,
  TEST_DASHBOARD: undefined,
  FAIRESPACE: undefined,
  TEST_TRACKER: undefined,
  QUIP: undefined,
  IT_IAM: undefined,
  DATA_IMPORTED_ENTITIES: undefined,
  DETEKT: `https://app.notion.com/p/faire/Detektors-68374c23d93147f2b36d04386f3cf0c2`,
  FINANCIAL_INVOICE_SETTLEMENTS: `https://app.notion.com/p/faire/Configurable-Invoice-Payments-3ce2efb5c25a80c69bbee11c1b5afaad`,
};

export const getDocumentation_linkForProductArea = (
  enumValue: ProductArea | keyof typeof ProductArea
): string | undefined => {
  return documentation_linkForProductArea[enumValue];
};
